// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27180%27 height=%27180%27%3E%3Cfilter id=%27n%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%270.8%27 numOctaves=%272%27 stitchTiles=%27stitch%27/%3E%3CfeColorMatrix type=%27saturate%27 values=%270%27/%3E%3C/filter%3E%3Crect width=%27180%27 height=%27180%27 filter=%27url%28%23n%29%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════════
   Latted landing — modern editorial infrastructure
   Design tokens, type scale, motion, and section styles.
   Breakpoints: mobile 0–639, tablet 640–1023, desktop 1024+.
   Mobile-first. Spacing only from the approved token set.
   ═══════════════════════════════════════════════════════════════ */

.lp-page {
  /* Spacing tokens (approved set only) */
  --lp-space-2: 2px;
  --lp-space-4: 4px;
  --lp-space-8: 8px;
  --lp-space-12: 12px;
  --lp-space-16: 16px;
  --lp-space-24: 24px;
  --lp-space-32: 32px;
  --lp-space-40: 40px;
  --lp-space-48: 48px;
  --lp-space-64: 64px;
  --lp-space-80: 80px;
  --lp-space-96: 96px;

  /* Type */
  --lp-font-sans: 'Geist Sans', 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  --lp-font-mono: 'Geist Mono', 'SF Mono', ui-monospace, monospace;

  /* Motion */
  --lp-ease: cubic-bezier(0.32, 0.72, 0, 1);
  --lp-dur-travel: 700ms;
  --lp-dur-press: 200ms;

  /* Layout */
  --lp-content-max: 1200px;
  --lp-composer-max: 840px;
  --lp-text-max: 680px;
  --lp-gutter: var(--lp-space-16);
  --lp-section-pad: var(--lp-space-64);

  /* Light theme tokens */
  --lp-page-bg: #F6F0E5;
  --lp-surface: #FFFDF8;
  --lp-surface-subdued: #EDE3D4;
  --lp-surface-elevated: #FFFDF8;
  --lp-surface-active: #EDE3D4;
  --lp-text: #17120E;
  --lp-text-muted: #6F655A;
  --lp-border: #D8CBB9;
  --lp-terracotta: #A6533B;
  --lp-rust: #8B432F;
  --lp-olive: #626A45;
  --lp-success: #16A34A;
  --lp-sepia: #59483B;
  --lp-error: #8B432F;
  --lp-hero-heading-from: #000000;
  --lp-hero-heading-to: #666666;
  --lp-focus-ring: rgba(166, 83, 59, 0.28);
  --lp-grain-opacity: 0.05;
  --lp-glass: rgba(255, 253, 248, 0.78);

  background: var(--lp-page-bg);
  color: var(--lp-text);
  font-family: var(--lp-font-sans);
  position: relative;
  min-height: 100vh;
  overflow-x: clip;
  -webkit-font-smoothing: antialiased;
}

@media (min-width: 640px) {
  .lp-page {
    --lp-gutter: var(--lp-space-24);
    --lp-section-pad: var(--lp-space-80);
  }
}

@media (min-width: 1024px) {
  .lp-page {
    --lp-gutter: var(--lp-space-32);
    --lp-section-pad: var(--lp-space-96);
  }
}

@media (prefers-color-scheme: dark) {
  :root:not([data-theme]) .lp-page,
  :root[data-theme='dark'] .lp-page {
    --lp-page-bg: #131209;
    --lp-surface: #181818;
    --lp-surface-subdued: #1F1F1F;
    --lp-surface-elevated: #1F1F1F;
    --lp-surface-active: #272727;
    --lp-text: #FFFFFF;
    --lp-text-muted: #9B9B9B;
    --lp-border: #313131;
    --lp-terracotta: #C77B61;
    --lp-rust: #C77B61;
    --lp-olive: #9DA47B;
    --lp-success: #4ADE80;
    --lp-sepia: #B49A86;
    --lp-error: #C77B61;
    --lp-hero-heading-from: #FFFFFF;
    --lp-hero-heading-to: #9B9B9B;
    --lp-focus-ring: rgba(199, 123, 97, 0.32);
    --lp-grain-opacity: 0.04;
    --lp-glass: rgba(24, 24, 24, 0.78);
  }
}

:root[data-theme='dark'] .lp-page {
  --lp-page-bg: #131209;
  --lp-surface: #181818;
  --lp-surface-subdued: #1F1F1F;
  --lp-surface-elevated: #1F1F1F;
  --lp-surface-active: #272727;
  --lp-text: #FFFFFF;
  --lp-text-muted: #9B9B9B;
  --lp-border: #313131;
  --lp-terracotta: #C77B61;
  --lp-rust: #C77B61;
  --lp-olive: #9DA47B;
  --lp-success: #4ADE80;
  --lp-sepia: #B49A86;
  --lp-error: #C77B61;
  --lp-hero-heading-from: #FFFFFF;
  --lp-hero-heading-to: #9B9B9B;
  --lp-focus-ring: rgba(199, 123, 97, 0.32);
  --lp-grain-opacity: 0.04;
  --lp-glass: rgba(24, 24, 24, 0.78);
}

/* Paper grain overlay — illustration layer only, never over text contrast */
.lp-page::before {
  content: '';
  position: fixed;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  opacity: var(--lp-grain-opacity);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 180px 180px;
}

.lp-page > * {
  position: relative;
  z-index: 2;
}

/* ─── Utilities ─── */

.lp-visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
}

.lp-skip-link {
  position: fixed;
  top: var(--lp-space-8);
  left: var(--lp-space-8);
  z-index: 300;
  transform: translateY(-64px);
  background: var(--lp-text);
  color: var(--lp-page-bg);
  padding: var(--lp-space-8) var(--lp-space-12);
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  transition: transform var(--lp-dur-press) var(--lp-ease);
}

.lp-skip-link:focus-visible {
  transform: translateY(0);
  outline: 2px solid var(--lp-terracotta);
  outline-offset: 2px;
}

/* The skip target is focusable programmatically but shows no outline itself. */
.lp-page main:focus {
  outline: none;
}

.lp-container {
  width: 100%;
  max-width: var(--lp-content-max);
  margin: 0 auto;
  padding-left: var(--lp-gutter);
  padding-right: var(--lp-gutter);
}

.lp-section {
  padding-top: var(--lp-section-pad);
  padding-bottom: var(--lp-section-pad);
  scroll-margin-top: 96px;
}

.lp-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.01em;
  color: var(--lp-terracotta);
  margin: 0 0 var(--lp-space-16);
}

.lp-heading {
  margin: 0;
  font-weight: 500;
  letter-spacing: -0.02em;
  line-height: 1.08;
  font-size: 30px;
  text-wrap: balance;
  color: var(--lp-text);
}

@media (min-width: 640px) {
  .lp-heading { font-size: 36px; }
}

@media (min-width: 1024px) {
  .lp-heading { font-size: 48px; }
}

.lp-body {
  margin: var(--lp-space-24) 0 0;
  font-size: 16px;
  line-height: 1.65;
  color: var(--lp-text-muted);
  text-wrap: pretty;
  max-width: var(--lp-text-max);
}

@media (min-width: 640px) {
  .lp-body { font-size: 16px; }
}

@media (min-width: 1024px) {
  .lp-body { font-size: 18px; }
}

/* Section entrance reveal — one group per section */
.lp-reveal {
  opacity: 0;
  transform: translateY(64px);
  filter: blur(12px);
  transition:
    opacity 800ms var(--lp-ease),
    transform 800ms var(--lp-ease),
    filter 800ms var(--lp-ease);
}

.lp-reveal--visible {
  opacity: 1;
  transform: translateY(0);
  filter: blur(0);
}

/* Shared focus treatment */
.lp-focusable:focus-visible {
  outline: 2px solid var(--lp-terracotta);
  outline-offset: 2px;
}

/* ═══════════════════════════════════════════════════════════════
   Navigation
   ═══════════════════════════════════════════════════════════════ */

/* At the top of the page the bar is chrome-free: no card, no blur, and the
   full wordmark. Crossing the hero sentinel collapses it into the card. */
.lp-nav {
  position: fixed;
  top: var(--lp-space-24);
  left: 50%;
  transform: translateX(-50%);
  z-index: 120;
  width: min(var(--lp-content-max), calc(100% - (2 * var(--lp-gutter))));
  height: 64px;
  display: flex;
  align-items: center;
  gap: var(--lp-space-8);
  padding: 0;
  border: 1px solid transparent;
  border-radius: 999px;
  background: transparent;
  transition: background-color var(--lp-dur-press) var(--lp-ease),
    border-color var(--lp-dur-press) var(--lp-ease),
    height 280ms var(--lp-ease),
    padding 280ms var(--lp-ease);
}

.lp-nav--scrolled {
  height: 48px;
  padding: 0 var(--lp-space-8) 0 var(--lp-space-16);
  border-color: var(--lp-border);
  background: var(--lp-surface);
  backdrop-filter: blur(14px);
}

.lp-nav__logo {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  width: 92px;
  height: 46px;
  border-radius: 8px;
  transition: width 280ms var(--lp-ease), height 280ms var(--lp-ease);
}

.lp-nav--scrolled .lp-nav__logo {
  width: 30px;
  height: 34px;
}

/* The wordmark and the icon are stacked so the swap cross-fades in place. */
.lp-nav__logo-img {
  position: absolute;
  left: 0;
  top: 50%;
  display: block;
  width: auto;
  transform: translateY(-50%);
  transition: opacity 200ms var(--lp-ease), height 280ms var(--lp-ease);
}

.lp-nav__logo-img--wordmark { height: 46px; }

.lp-nav__logo-img--icon {
  height: 24px;
  opacity: 0;
}

.lp-nav--scrolled .lp-nav__logo-img--wordmark {
  height: 34px;
  opacity: 0;
}

.lp-nav--scrolled .lp-nav__logo-img--icon { opacity: 1; }

@media (prefers-reduced-motion: reduce) {
  .lp-nav,
  .lp-nav__logo,
  .lp-nav__logo-img { transition: none; }
}

.lp-nav__links {
  display: none;
  align-items: center;
  gap: var(--lp-space-4);
  margin: 0 auto;
}

.lp-nav__link {
  display: inline-flex;
  align-items: center;
  min-height: 36px;
  padding: var(--lp-space-8) var(--lp-space-12);
  border-radius: 999px;
  font-size: 14px;
  font-weight: 600;
  color: var(--lp-text-muted);
  text-decoration: none;
  transition: color var(--lp-dur-press) var(--lp-ease),
    background-color var(--lp-dur-press) var(--lp-ease);
}

.lp-nav__link:hover {
  color: var(--lp-text);
}

.lp-nav__link--active {
  color: var(--lp-text);
}

.lp-nav__actions {
  display: flex;
  align-items: center;
  gap: var(--lp-space-8);
  margin-left: auto;
}

.lp-nav__signin {
  display: none;
  align-items: center;
  min-height: 36px;
  padding: var(--lp-space-8) var(--lp-space-12);
  border: none;
  border-radius: 999px;
  background: transparent;
  color: var(--lp-text-muted);
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: color var(--lp-dur-press) var(--lp-ease);
}

.lp-nav__signin:hover {
  color: var(--lp-text);
}

.lp-btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--lp-space-8);
  min-height: 36px;
  padding: var(--lp-space-8) var(--lp-space-12);
  border: 1px solid var(--lp-text);
  border-radius: 999px;
  background: var(--lp-text);
  color: var(--lp-page-bg);
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
  text-decoration: none;
  cursor: pointer;
  transition: transform var(--lp-dur-press) var(--lp-ease),
    opacity var(--lp-dur-press) var(--lp-ease);
}

.lp-btn-primary:hover {
  opacity: 0.88;
  transform: translateY(-1px);
}

.lp-btn-primary:active {
  transform: translateY(1px) scale(0.98);
}

.lp-btn-primary:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  transform: none;
}

.lp-nav__cta {
  display: none;
}

.lp-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid var(--lp-border);
  border-radius: 999px;
  background: transparent;
  color: var(--lp-text-muted);
  cursor: pointer;
  transition: color var(--lp-dur-press) var(--lp-ease),
    background-color var(--lp-dur-press) var(--lp-ease),
    transform var(--lp-dur-press) var(--lp-ease);
}

.lp-icon-btn:hover {
  color: var(--lp-text);
  background: var(--lp-surface-active);
}

.lp-icon-btn:active {
  transform: scale(0.98);
}

.lp-nav__menu-btn {
  position: relative;
}

.lp-nav__menu-btn .lp-nav__menu-icon {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  transition: opacity var(--lp-dur-press) var(--lp-ease),
    transform var(--lp-dur-press) var(--lp-ease);
}

.lp-nav__menu-btn .lp-nav__menu-icon--close {
  opacity: 0;
  transform: rotate(-90deg) scale(0.6);
}

.lp-nav__menu-btn--open .lp-nav__menu-icon--close {
  opacity: 1;
  transform: rotate(0deg) scale(1);
}

.lp-nav__menu-btn--open .lp-nav__menu-icon--bars {
  opacity: 0;
  transform: rotate(90deg) scale(0.6);
}

@media (min-width: 1024px) {
  .lp-nav__links { display: flex; }
  .lp-nav__signin { display: inline-flex; }
  .lp-nav__cta { display: inline-flex; }
  .lp-nav__menu-btn { display: none; }
}

/* Mobile menu overlay */
.lp-menu-overlay {
  position: fixed;
  inset: 0;
  z-index: 110;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 96px var(--lp-gutter) var(--lp-space-48);
  background: var(--lp-glass);
  backdrop-filter: blur(24px);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity var(--lp-dur-travel) var(--lp-ease),
    visibility 0s linear var(--lp-dur-travel);
}

.lp-menu-overlay--open {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transition-delay: 0s;
}

.lp-menu-overlay__links {
  display: flex;
  flex-direction: column;
  gap: var(--lp-space-8);
  list-style: none;
  margin: 0;
  padding: 0;
}

.lp-menu-overlay__link {
  display: block;
  padding: var(--lp-space-12) 0;
  font-size: 30px;
  font-weight: 500;
  letter-spacing: -0.02em;
  color: var(--lp-text);
  text-decoration: none;
  opacity: 0;
  transform: translateY(24px);
  transition: opacity var(--lp-dur-travel) var(--lp-ease),
    transform var(--lp-dur-travel) var(--lp-ease);
}

.lp-menu-overlay--open .lp-menu-overlay__link {
  opacity: 1;
  transform: translateY(0);
}

.lp-menu-overlay__footer {
  margin-top: var(--lp-space-48);
  display: flex;
  flex-direction: column;
  gap: var(--lp-space-16);
}

.lp-menu-overlay__signin {
  align-self: flex-start;
  border: none;
  background: none;
  padding: var(--lp-space-8) 0;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  color: var(--lp-text-muted);
  cursor: pointer;
}

.lp-menu-overlay__cta {
  width: 100%;
  min-height: 48px;
  font-size: 16px;
}

/* ═══════════════════════════════════════════════════════════════
   Hero
   ═══════════════════════════════════════════════════════════════ */

.lp-hero {
  position: relative;
  isolation: isolate;
  padding-top: calc(72px + var(--lp-space-64));
  padding-bottom: var(--lp-section-pad);
  text-align: center;
}

/* Floating 3D app icons behind the headline. Decorative and inert. */
.lp-hero__scene {
  position: absolute;
  inset: -4% 0 0;
  z-index: 0;
  pointer-events: none;
  opacity: 0;
  transition: opacity 900ms ease;
  /* Fade the icons out before they reach the composer. */
  mask-image: linear-gradient(to bottom, #000 68%, transparent 94%);
}

.lp-hero__scene--ready { opacity: 1; }

.lp-hero__scene canvas {
  display: block;
  width: 100%;
  height: 100%;
}

.lp-hero > .lp-container {
  position: relative;
  z-index: 1;
}

@media (prefers-reduced-motion: reduce) {
  .lp-hero__scene { transition: none; }
}

@media (min-width: 640px) {
  .lp-hero { padding-top: calc(72px + var(--lp-space-80)); }
}

@media (min-width: 1024px) {
  .lp-hero { padding-top: calc(72px + var(--lp-space-96)); }
}

.lp-hero__headline {
  margin: 0 auto;
  max-width: var(--lp-text-max);
  /* Scales down on narrow phones so the no-wrap accent phrase still fits. */
  font-size: clamp(28px, 8.4vw, 36px);
  font-weight: 500;
  line-height: 1.04;
  letter-spacing: -0.03em;
  text-wrap: balance;
  background: linear-gradient(90deg, var(--lp-hero-heading-from), var(--lp-hero-heading-to));
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

@media (min-width: 640px) {
  .lp-hero__headline { font-size: 60px; }
}

@media (min-width: 1024px) {
  .lp-hero__headline { font-size: 72px; }
}

/* Accent phrase: never wraps, so the hand-drawn underline always sits under
   a single unbroken line of text. */
.lp-hero__accent {
  position: relative;
  display: inline-block;
  white-space: nowrap;
  /* The positioned span paints outside the h1's background-clip pass, so it
     carries its own copy of the heading gradient. */
  background: linear-gradient(90deg, var(--lp-hero-heading-from), var(--lp-hero-heading-to));
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

/* Scales uniformly with the phrase, so the stroke thickens with the type and
   the dash lengths below stay valid at every viewport. */
.lp-hero__underline {
  position: absolute;
  left: -1.5%;
  top: 100%;
  width: 103%;
  height: auto;
  margin-top: -0.16em;
  overflow: visible;
  pointer-events: none;
  color: var(--lp-terracotta);
}

.lp-hero__underline-path {
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  /* The path runs ~300 viewBox units; the dash covers the whole sweep. */
  stroke-dasharray: 320;
  stroke-dashoffset: 320;
  transition: stroke-dashoffset 900ms var(--lp-ease) 420ms;
}

.lp-hero__accent--drawn .lp-hero__underline-path {
  stroke-dashoffset: 0;
}

@media (prefers-reduced-motion: reduce) {
  .lp-hero__underline-path { transition: none; }
}

.lp-hero__subheadline {
  margin: var(--lp-space-24) auto 0;
  max-width: var(--lp-text-max);
  font-size: 16px;
  line-height: 1.6;
  color: var(--lp-text-muted);
  text-wrap: pretty;
}

@media (min-width: 640px) {
  .lp-hero__subheadline { font-size: 18px; }
}

@media (min-width: 1024px) {
  .lp-hero__subheadline { font-size: 20px; }
}

.lp-hero__composer {
  margin: var(--lp-space-40) auto 0;
  max-width: var(--lp-composer-max);
  text-align: left;
}

/* ═══════════════════════════════════════════════════════════════
   Composer
   ═══════════════════════════════════════════════════════════════ */

.lp-composer {
  position: relative;
  background: var(--lp-surface);
  border: 1px solid var(--lp-border);
  border-radius: 16px;
  padding: var(--lp-space-16) var(--lp-space-16) var(--lp-space-12);
  transition: border-color var(--lp-dur-press) var(--lp-ease),
    box-shadow var(--lp-dur-press) var(--lp-ease);
}

.lp-composer:focus-within {
  border-color: var(--lp-terracotta);
  box-shadow: 0 0 0 3px var(--lp-focus-ring);
}

.lp-composer--drag {
  border-style: dashed;
  border-color: var(--lp-terracotta);
}

.lp-composer__textarea {
  display: block;
  width: 100%;
  min-height: 128px;
  margin: 0;
  padding: 0;
  border: none;
  outline: none;
  resize: none;
  background: transparent;
  color: var(--lp-text);
  font-family: inherit;
  font-size: 16px;
  line-height: 1.6;
}

@media (min-width: 1024px) {
  .lp-composer__textarea { min-height: 144px; }
}

.lp-composer__textarea::placeholder {
  color: var(--lp-text-muted);
  opacity: 0.7;
}

.lp-composer__textarea:disabled {
  opacity: 0.6;
}

.lp-composer__menu-wrap {
  position: relative;
}

.lp-composer__chips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--lp-space-8);
  margin-top: var(--lp-space-12);
}

.lp-chip {
  display: inline-flex;
  align-items: center;
  gap: var(--lp-space-8);
  max-width: 100%;
  padding: var(--lp-space-4) var(--lp-space-8);
  border: 1px solid var(--lp-border);
  border-radius: 12px;
  background: var(--lp-surface-subdued);
  color: var(--lp-text);
  font-size: 13px;
  font-weight: 500;
  line-height: 1.3;
}

.lp-chip__ext {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  padding: 0 var(--lp-space-4);
  border-radius: 8px;
  background: var(--lp-surface);
  border: 1px solid var(--lp-border);
  color: var(--lp-text-muted);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  flex-shrink: 0;
}

.lp-chip__meta {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.lp-chip__name {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lp-chip__size {
  font-size: 11px;
  font-weight: 400;
  color: var(--lp-text-muted);
}

.lp-chip__remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 999px;
  background: transparent;
  color: var(--lp-text-muted);
  cursor: pointer;
  flex-shrink: 0;
  transition: background-color var(--lp-dur-press) var(--lp-ease),
    color var(--lp-dur-press) var(--lp-ease);
}

.lp-chip__remove:hover {
  background: var(--lp-surface-active);
  color: var(--lp-text);
}

.lp-chip--skeleton {
  width: 180px;
  height: 40px;
  border-radius: 12px;
  background: linear-gradient(
    100deg,
    var(--lp-surface-subdued) 40%,
    var(--lp-surface-active) 50%,
    var(--lp-surface-subdued) 60%
  );
  background-size: 200% 100%;
  animation: lpSkeleton 1.4s var(--lp-ease) infinite;
}

@keyframes lpSkeleton {
  from { background-position: 120% 0; }
  to { background-position: -80% 0; }
}

.lp-composer__toolbar {
  display: flex;
  align-items: center;
  gap: var(--lp-space-8);
  margin-top: var(--lp-space-12);
}

.lp-composer__toolbar-group {
  display: flex;
  align-items: center;
  gap: var(--lp-space-8);
}

.lp-composer__submit {
  margin-left: auto;
}

.lp-tool-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--lp-space-8);
  min-width: 40px;
  height: 40px;
  padding: 0 var(--lp-space-12);
  border: 1px solid var(--lp-border);
  border-radius: 12px;
  background: transparent;
  color: var(--lp-text-muted);
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: color var(--lp-dur-press) var(--lp-ease),
    background-color var(--lp-dur-press) var(--lp-ease),
    transform var(--lp-dur-press) var(--lp-ease);
}

.lp-tool-btn:hover:not(:disabled) {
  color: var(--lp-text);
  background: var(--lp-surface-active);
}

.lp-tool-btn:active:not(:disabled) {
  transform: translateY(1px);
}

.lp-tool-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.lp-tool-btn--icon-only {
  padding: 0;
  width: 40px;
}

.lp-multi-agent {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: var(--lp-text-muted);
  font-size: 12px;
  font-weight: 560;
  cursor: pointer;
  white-space: nowrap;
}

.lp-multi-agent__switch {
  position: relative;
  width: 30px;
  height: 17px;
  padding: 0;
  border: 1px solid var(--lp-border-strong);
  border-radius: 999px;
  background: var(--lp-surface-subdued);
  cursor: pointer;
  transition: background var(--lp-dur-press), border-color var(--lp-dur-press);
}

.lp-multi-agent__switch[data-state='checked'] {
  border-color: var(--lp-text);
  background: var(--lp-text);
}

.lp-multi-agent__switch:focus-visible { outline: 2px solid var(--lp-text); outline-offset: 2px; }
.lp-multi-agent__switch:disabled { opacity: .5; cursor: default; }

.lp-multi-agent__thumb {
  display: block;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: var(--lp-surface-elevated);
  box-shadow: 0 1px 2px rgba(0, 0, 0, .22);
  transform: translateX(2px);
  transition: transform var(--lp-dur-press) var(--lp-ease);
}

.lp-multi-agent__thumb[data-state='checked'] { transform: translateX(15px); }

.lp-submit-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid var(--lp-text);
  border-radius: 12px;
  background: var(--lp-text);
  color: var(--lp-page-bg);
  cursor: pointer;
  transition: opacity var(--lp-dur-press) var(--lp-ease),
    transform var(--lp-dur-press) var(--lp-ease);
}

.lp-submit-btn:hover:not(:disabled) {
  opacity: 0.88;
  transform: translateY(-1px);
}

.lp-submit-btn:active:not(:disabled) {
  transform: translateY(1px) scale(0.98);
}

.lp-submit-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.lp-submit-btn__skeleton {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  background: linear-gradient(
    100deg,
    transparent 20%,
    currentColor 50%,
    transparent 80%
  );
  background-size: 200% 100%;
  opacity: 0.9;
  animation: lpSkeleton 1s var(--lp-ease) infinite;
}

.lp-composer__submit--planning {
  width: 112px;
  padding: 0 14px;
  opacity: 1 !important;
  cursor: wait !important;
}

.lp-planning-label {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 650;
  letter-spacing: -0.01em;
}

.lp-planning-dots {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  height: 10px;
}

.lp-planning-dots i {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: currentColor;
  animation: lpPlanningDot 1.05s ease-in-out infinite;
}

.lp-planning-dots i:nth-child(2) { animation-delay: 0.14s; }
.lp-planning-dots i:nth-child(3) { animation-delay: 0.28s; }

@keyframes lpPlanningDot {
  0%, 60%, 100% { opacity: .3; transform: translateY(0); }
  30% { opacity: 1; transform: translateY(-2px); }
}

@media (prefers-reduced-motion: reduce) {
  .lp-planning-dots i { animation: none; opacity: .7; }
}

.lp-composer__status {
  margin: var(--lp-space-8) 0 0;
  font-size: 14px;
  line-height: 1.5;
}

.lp-composer__status--error {
  color: var(--lp-error);
}

.lp-composer__status--hint {
  color: var(--lp-text-muted);
}

.lp-composer__drop-hint {
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background: color-mix(in srgb, var(--lp-surface) 88%, transparent);
  color: var(--lp-terracotta);
  font-size: 16px;
  font-weight: 600;
  pointer-events: none;
}

/* Aspect ratio dropdown (Radix) */
.lp-ar-trigger[data-state='open'] {
  color: var(--lp-text);
  background: var(--lp-surface-active);
  border-color: color-mix(in srgb, var(--lp-text-muted) 45%, var(--lp-border));
}

.lp-ar-trigger[data-state='open'] > svg:last-child {
  transform: rotate(180deg);
}

.lp-ar-trigger > svg:last-child {
  transition: transform 120ms var(--lp-ease);
}

.lp-ar-content {
  --lp-ar-surface: var(--color-bg-canvas-surface, #fff);
  --lp-ar-surface-raised: var(--color-bg-sidebar, #f7f7f7);
  --lp-ar-surface-active: var(--color-bg-user-bubble, #f1f2f3);
  --lp-ar-border: var(--color-border-input, #d7d9dd);
  --lp-ar-text: var(--color-text-primary, #111318);
  --lp-ar-text-muted: var(--color-text-secondary, #656970);

  width: 232px;
  max-height: min(360px, var(--radix-dropdown-menu-content-available-height));
  overflow-y: auto;
  color: var(--lp-ar-text);
  background: var(--lp-ar-surface);
  border: 1px solid var(--lp-ar-border);
  border-radius: 7px;
  padding: 5px;
  box-shadow: 0 16px 40px rgb(0 0 0 / 18%);
  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;
  z-index: 200;
  transform-origin: var(--radix-dropdown-menu-content-transform-origin);
  animation: lpMenuIn 120ms cubic-bezier(0.32, 0.72, 0, 1);
}

@keyframes lpMenuIn {
  from { opacity: 0; transform: translateY(3px) scale(0.99); }
}

.lp-ar-content__label {
  display: block;
  padding: 7px 9px 8px;
  color: var(--lp-ar-text-muted);
  font-size: 10px;
  font-weight: 650;
  letter-spacing: 0.055em;
  text-transform: uppercase;
}

.lp-ar-item {
  display: grid;
  min-height: 46px;
  grid-template-columns: 30px minmax(0, 1fr) 18px;
  align-items: center;
  gap: 9px;
  padding: 5px 8px;
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  color: var(--lp-ar-text-muted);
  outline: none;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 120ms cubic-bezier(0.32, 0.72, 0, 1),
    border-color 120ms cubic-bezier(0.32, 0.72, 0, 1),
    color 120ms cubic-bezier(0.32, 0.72, 0, 1);
}

.lp-ar-item:hover,
.lp-ar-item[data-highlighted] {
  background: var(--lp-ar-surface-active);
  border-color: var(--lp-ar-border);
  color: var(--lp-ar-text);
}

.lp-ar-item--selected {
  color: var(--lp-ar-text);
  background: var(--lp-ar-surface-active);
}

.lp-ar-item__icon {
  display: grid;
  width: 30px;
  height: 30px;
  place-items: center;
  color: var(--lp-ar-text-muted);
  background: var(--lp-ar-surface-raised);
  border: 1px solid var(--lp-ar-border);
  border-radius: 4px;
}

.lp-ar-item[data-highlighted] .lp-ar-item__icon,
.lp-ar-item--selected .lp-ar-item__icon {
  color: var(--lp-ar-text);
}

.lp-ar-item__copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 2px;
}

.lp-ar-item__label {
  font-family: 'Geist Mono', 'SF Mono', ui-monospace, monospace;
  font-size: 12px;
  font-weight: 650;
  line-height: 1.2;
}

.lp-ar-item__description {
  overflow: hidden;
  color: var(--lp-ar-text-muted);
  font-size: 10px;
  font-weight: 450;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lp-ar-item__check {
  display: grid;
  width: 18px;
  height: 18px;
  place-items: center;
  color: var(--lp-ar-text);
}

.lp-ar-trigger__label {
  font-family: var(--lp-font-mono);
  font-size: 12px;
  letter-spacing: -0.01em;
}

/* Unified run settings */
.lp-run-settings__trigger[data-state='open'] {
  color: var(--lp-text);
  background: var(--lp-surface-active);
}

.lp-run-settings__trigger[data-state='open'] > svg:last-child {
  transform: rotate(180deg);
}

.lp-run-settings__trigger > svg:last-child {
  transition: transform 160ms cubic-bezier(0.2, 0, 0, 1);
}

.lp-run-settings {
  z-index: 1200;
  width: min(400px, calc(100vw - 24px));
  max-height: min(680px, var(--radix-popover-content-available-height, calc(100vh - 24px)));
  overflow-y: auto;
  color: var(--color-text-primary, #111318);
  background: var(--color-bg-canvas-surface, #fff);
  border: 1px solid var(--color-border-input, #d7d9dd);
  border-radius: 8px;
  box-shadow: 0 16px 40px rgb(0 0 0 / 18%);
  font-family: inherit;
  transform-origin: var(--radix-popover-content-transform-origin);
  will-change: opacity, transform;
  animation: lpRunSettingsInBottom 180ms cubic-bezier(0.2, 0, 0, 1);
}

@keyframes lpRunSettingsInBottom {
  from { opacity: 0; transform: translateY(-4px); }
}

@keyframes lpRunSettingsInTop {
  from { opacity: 0; transform: translateY(4px); }
}

.lp-run-settings[data-side='top'] { animation-name: lpRunSettingsInTop; }

.lp-run-settings__advanced-trigger > span,
.lp-run-settings__choices label > span,
.lp-run-settings__ratios button > span:nth-child(2) {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 2px;
}

.lp-run-settings__advanced-trigger small,
.lp-run-settings__choices small,
.lp-run-settings__ratios small {
  color: var(--color-text-secondary, #656970);
  font-size: 12px;
  font-weight: 450;
  line-height: 1.35;
}

.lp-run-settings__section {
  margin: 0;
  padding: 16px;
  border: 0;
  border-bottom: 1px solid var(--color-border-sidebar, #dcdcdc);
}

.lp-run-settings > .lp-run-settings__section:first-child {
  padding-top: 24px;
}

.lp-run-settings__section-label {
  margin-bottom: 8px;
  color: var(--color-text-secondary, #656970);
  font-size: 12px;
  font-weight: 650;
}

.lp-run-settings__ratios {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.lp-run-settings__ratios button {
  display: grid;
  min-height: 48px;
  padding: 8px;
  grid-template-columns: 32px minmax(0, 1fr) 16px;
  align-items: center;
  gap: 8px;
  color: var(--color-text-secondary, #656970);
  background: transparent;
  border: 1px solid var(--color-border-input, #d7d9dd);
  border-radius: 4px;
  cursor: pointer;
  font-family: inherit;
  text-align: left;
  transition: color 100ms cubic-bezier(0.2, 0, 0, 1),
    background-color 100ms cubic-bezier(0.2, 0, 0, 1),
    transform 140ms cubic-bezier(0.2, 0, 0, 1);
}

.lp-run-settings__ratios button:hover,
.lp-run-settings__ratios button.is-selected {
  color: var(--color-text-primary, #111318);
  background: var(--color-bg-user-bubble, #f1f2f3);
}

.lp-run-settings__ratios button:active { transform: scale(0.98); }
.lp-run-settings__ratios strong { font-family: var(--lp-font-mono); font-size: 12px; font-weight: 650; }
.lp-run-settings__ratio-icon { display: grid; width: 32px; height: 32px; place-items: center; border: 1px solid var(--color-border-input, #d7d9dd); border-radius: 4px; }

.lp-run-settings__choices {
  display: grid;
  gap: 16px;
}

.lp-run-settings__choices label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  cursor: pointer;
}

.lp-run-settings__choices strong,
.lp-run-settings__advanced-trigger strong { font-size: 14px; font-weight: 600; }

.lp-run-settings__switch {
  position: relative;
  width: 36px;
  height: 20px;
  padding: 0;
  flex: none;
  border: 1px solid var(--color-border-input, #d7d9dd);
  border-radius: 999px;
  background: var(--color-bg-sidebar, #f7f7f7);
  cursor: pointer;
  transition: background-color 160ms cubic-bezier(0.2, 0, 0, 1),
    border-color 160ms cubic-bezier(0.2, 0, 0, 1);
}

.lp-run-settings__switch[data-state='checked'] { border-color: var(--color-text-primary, #111318); background: var(--color-text-primary, #111318); }
.lp-run-settings__switch-thumb { display: block; width: 14px; height: 14px; border-radius: 50%; background: var(--color-bg-canvas-surface, #fff); box-shadow: 0 1px 2px rgb(0 0 0 / 22%); transform: translateX(2px); transition: transform 180ms cubic-bezier(0.2, 0, 0, 1); }
.lp-run-settings__switch[data-state='checked'] .lp-run-settings__switch-thumb { transform: translateX(18px); }

.lp-run-settings__advanced { border-bottom: 0; }
.lp-run-settings__advanced-trigger {
  display: flex;
  width: 100%;
  min-height: 64px;
  padding: 12px 16px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: inherit;
  background: transparent;
  border: 0;
  cursor: pointer;
  font-family: inherit;
  text-align: left;
}

.lp-run-settings__advanced-trigger:hover { background: var(--color-bg-user-bubble, #f1f2f3); }
.lp-run-settings__advanced-trigger:disabled { cursor: not-allowed; opacity: .5; }
.lp-run-settings__advanced-trigger > svg { flex: none; transition: transform 160ms cubic-bezier(0.2, 0, 0, 1); }
.lp-run-settings__model-panel { margin: 0; padding: 0; border: 0; }
.lp-run-settings__advanced-view { min-height: 0; }
.lp-run-settings__back {
  display: inline-flex;
  min-height: 40px;
  margin: 8px 8px 0;
  padding: 8px 12px;
  align-items: center;
  gap: 8px;
  color: var(--color-text-secondary, #656970);
  background: transparent;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
}
.lp-run-settings__back:hover { color: var(--color-text-primary, #111318); background: var(--color-bg-user-bubble, #f1f2f3); }
.lp-run-settings__back > svg { transform: rotate(90deg); }

.lp-run-settings button:focus-visible,
.lp-run-settings [role='switch']:focus-visible,
.lp-suggestions__trigger:focus-visible,
.lp-suggestions__item:focus-visible {
  outline: 2px solid var(--color-text-primary, #111318);
  outline-offset: 2px;
}

/* Reference picker menu placement inside the new composer */
.lp-composer .composer-reference-menu {
  left: 0;
  width: min(340px, calc(100vw - 48px));
}

.lp-composer .composer-reference-chips {
  display: contents;
}

/* Suggestions */
.lp-suggestions {
  margin-top: var(--lp-space-16);
  text-align: center;
}

.lp-suggestions__trigger {
  display: inline-flex;
  min-height: 36px;
  padding: 8px 12px;
  align-items: center;
  gap: 8px;
  color: var(--lp-text-muted);
  background: transparent;
  border: 1px solid transparent;
  border-radius: 999px;
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  transition: color 700ms cubic-bezier(0.32, 0.72, 0, 1),
    background-color 700ms cubic-bezier(0.32, 0.72, 0, 1),
    transform 700ms cubic-bezier(0.32, 0.72, 0, 1);
}

.lp-suggestions__trigger:hover,
.lp-suggestions__trigger[data-state='open'] { color: var(--lp-text); background: var(--lp-surface-subdued); }
.lp-suggestions__trigger:active { transform: scale(0.98); }
.lp-suggestions__trigger[data-state='open'] > svg:last-child { transform: rotate(180deg); }
.lp-suggestions__trigger > svg:last-child { transition: transform 700ms cubic-bezier(0.32, 0.72, 0, 1); }

.lp-suggestions__menu {
  z-index: 1200;
  width: min(280px, calc(100vw - 24px));
  padding: 4px;
  color: var(--color-text-primary, #111318);
  background: var(--color-bg-canvas-surface, #fff);
  border: 1px solid var(--color-border-input, #d7d9dd);
  border-radius: 8px;
  box-shadow: 0 16px 40px rgb(0 0 0 / 18%);
  font-family: inherit;
  animation: lpRunSettingsInBottom 120ms cubic-bezier(0.2, 0, 0, 1);
}

.lp-suggestions__menu[data-side='top'] { animation-name: lpRunSettingsInTop; }

.lp-suggestions__menu [role='menuitem'],
.lp-suggestions__menu [role='group'] { outline: none; }
.lp-suggestions__menu > [role='group'] { padding: 8px; color: var(--color-text-secondary, #656970); font-size: 12px; font-weight: 650; }
.lp-suggestions__item { padding: 8px; border: 1px solid transparent; border-radius: 4px; cursor: pointer; font-size: 14px; text-align: left; }
.lp-suggestions__item:hover,
.lp-suggestions__item[data-highlighted] { background: var(--color-bg-user-bubble, #f1f2f3); border-color: var(--color-border-input, #d7d9dd); }

@media (max-width: 600px) {
  .lp-run-settings__trigger > span { display: none; }
  .lp-run-settings__trigger { width: 40px; padding: 0; }
  .lp-run-settings { width: calc(100vw - 16px); }
  .lp-run-settings__ratios { grid-template-columns: 1fr; }
}

@media (prefers-reduced-motion: reduce) {
  .lp-run-settings,
  .lp-run-settings *,
  .lp-suggestions__trigger,
  .lp-suggestions__menu { transition-duration: .01ms; animation-duration: .01ms; }
}

.lp-suggestions__row {
  display: flex;
  flex-wrap: nowrap;
  gap: var(--lp-space-8);
  overflow-x: auto;
  padding-bottom: var(--lp-space-4);
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
}

.lp-suggestions__row::-webkit-scrollbar {
  display: none;
}

@media (min-width: 1024px) {
  .lp-suggestions__row {
    flex-wrap: wrap;
    justify-content: center;
    overflow: visible;
  }
}

.lp-suggestion-chip {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  min-height: 36px;
  padding: var(--lp-space-8) var(--lp-space-12);
  border: 1px solid var(--lp-border);
  border-radius: 999px;
  background: var(--lp-surface);
  color: var(--lp-text-muted);
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  transition: color var(--lp-dur-press) var(--lp-ease),
    background-color var(--lp-dur-press) var(--lp-ease),
    transform var(--lp-dur-press) var(--lp-ease);
}

.lp-suggestion-chip:hover:not(:disabled) {
  color: var(--lp-text);
  background: var(--lp-surface-subdued);
  transform: translateY(-2px);
}

.lp-suggestion-chip:active:not(:disabled) {
  transform: translateY(0) scale(0.98);
}

.lp-suggestion-chip:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.lp-suggestions__confirm {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--lp-space-12);
  margin-bottom: var(--lp-space-12);
  padding: var(--lp-space-12);
  border: 1px solid var(--lp-border);
  border-radius: 12px;
  background: var(--lp-surface);
  font-size: 14px;
  color: var(--lp-text);
}

.lp-suggestions__confirm-actions {
  display: flex;
  gap: var(--lp-space-8);
  margin-left: auto;
}

.lp-btn-quiet {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 32px;
  padding: var(--lp-space-8) var(--lp-space-12);
  border: 1px solid var(--lp-border);
  border-radius: 999px;
  background: transparent;
  color: var(--lp-text);
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color var(--lp-dur-press) var(--lp-ease);
}

.lp-btn-quiet:hover {
  background: var(--lp-surface-active);
}

.lp-btn-quiet--solid {
  background: var(--lp-text);
  border-color: var(--lp-text);
  color: var(--lp-page-bg);
}

.lp-btn-quiet--solid:hover {
  background: var(--lp-text);
  opacity: 0.88;
}

/* Risk reversal */
.lp-risk-reversal {
  margin: var(--lp-space-16) 0 0;
  text-align: center;
  font-size: 14px;
  color: var(--lp-text-muted);
}

/* ═══════════════════════════════════════════════════════════════
   Output showcase
   ═══════════════════════════════════════════════════════════════ */

.lp-showcase__head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: var(--lp-space-24);
}

.lp-showcase__nav {
  display: flex;
  gap: var(--lp-space-8);
}

.lp-showcase__scroller {
  display: flex;
  /* Cards size from their own aspect-ratio. The default \`stretch\` ties each
     card's height to the flex line instead, which Safari recomputes as the
     lazily-loaded videos settle — the cards visibly grow while scrolling. */
  align-items: flex-start;
  gap: var(--lp-space-16);
  margin-top: var(--lp-space-48);
  overflow-x: auto;
  scroll-padding-left: 0;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
  padding-bottom: var(--lp-space-8);
}

.lp-showcase__scroller::-webkit-scrollbar {
  display: none;
}

@media (pointer: coarse) {
  .lp-showcase__scroller {
    scroll-snap-type: x mandatory;
  }
}

.lp-device {
  flex: 0 0 78%;
  scroll-snap-align: start;
  aspect-ratio: 9 / 16;
  /* Containing block for the card, which is pinned rather than sized in
     flow, plus a hard clip so nothing inside can ever paint past the frame. */
  position: relative;
  overflow: hidden;
  padding: var(--lp-space-8);
  border: 1px solid var(--lp-border);
  border-radius: 16px;
  background: var(--lp-surface);
  transition: transform var(--lp-dur-press) var(--lp-ease),
    box-shadow var(--lp-dur-press) var(--lp-ease);
}

.lp-device:hover {
  transform: translateY(-2px);
}

@media (min-width: 640px) {
  .lp-device { flex-basis: calc((100% - var(--lp-space-16)) / 2.35); }
}

@media (min-width: 1024px) {
  .lp-device { flex-basis: calc((100% - (2 * var(--lp-space-16))) / 3.3); }
}

/* Restyle the shared example card as a clean device screen.
   The card is a <button>. Safari renders an un-reset button as a native
   push button whose box follows its contents rather than an author
   percentage height, so \`height: 100%\` was not reliable — the card grew
   when the video's intrinsic size landed, which happens lazily during
   scroll. Resetting the appearance and pinning the card to the frame's
   padding box takes it out of flow, so its size is a pure function of
   the frame and nothing inside it can feed back into layout. */
.lp-device .ex-card {
  appearance: none;
  -webkit-appearance: none;
  position: absolute;
  inset: var(--lp-space-8);
  width: auto;
  height: auto;
  aspect-ratio: auto;
  border: none;
  border-radius: 8px;
  overflow: hidden;
  background: #0d0c0a;
  display: block;
  cursor: pointer;
  padding: 0;
}

/* Keep showcase media stable while the page moves beneath the pointer. */
.lp-device .ex-card:hover .ex-card-thumb,
.lp-device .ex-card:hover .ex-card-video {
  transform: none;
}

.lp-showcase__footer {
  margin-top: var(--lp-space-24);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--lp-space-16);
}

.lp-showcase__disclosure {
  margin: 0;
  font-size: 13px;
  color: var(--lp-text-muted);
}

.lp-showcase__more {
  display: inline-flex;
  align-items: center;
  gap: var(--lp-space-8);
  font-size: 14px;
  font-weight: 600;
  color: var(--lp-text);
  text-decoration: none;
  transition: color var(--lp-dur-press) var(--lp-ease);
}

.lp-showcase__more:hover {
  color: var(--lp-terracotta);
}

/* ═══════════════════════════════════════════════════════════════
   Composer agent section
   ═══════════════════════════════════════════════════════════════ */

.lp-agent__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--lp-space-48);
  align-items: center;
}

@media (min-width: 640px) {
  .lp-agent__grid {
    grid-template-columns: repeat(8, 1fr);
  }
  .lp-agent__copy { grid-column: span 8; }
  .lp-agent__art { grid-column: span 8; }
}

@media (min-width: 1024px) {
  .lp-agent__grid {
    grid-template-columns: repeat(12, 1fr);
    gap: var(--lp-space-48);
  }
  .lp-agent__copy { grid-column: span 5; }
  .lp-agent__art { grid-column: span 7; }
}

.lp-agent__supporting {
  margin: var(--lp-space-24) 0 0;
  font-size: 16px;
  line-height: 1.6;
  font-weight: 500;
  color: var(--lp-text);
  max-width: var(--lp-text-max);
  text-wrap: pretty;
}

@media (min-width: 1024px) {
  .lp-agent__supporting { font-size: 18px; }
}

/* ── Scripted agent run visual ───────────────────────────────── */

.lp-agentviz {
  display: flex;
  flex-direction: column;
  gap: var(--lp-space-12);
  padding: var(--lp-space-12);
  border: 1px solid var(--lp-border);
  border-radius: 18px;
  background: var(--lp-surface);
  box-shadow: 0 18px 44px -32px rgba(23, 18, 14, 0.5);
}

@media (min-width: 640px) {
  .lp-agentviz {
    gap: var(--lp-space-16);
    padding: var(--lp-space-16);
  }
}

/* Composer — the prompt types itself, then sends */

.lp-agentviz__composer {
  display: flex;
  align-items: center;
  gap: var(--lp-space-8);
  min-height: 44px;
  padding: var(--lp-space-8) var(--lp-space-8) var(--lp-space-8) var(--lp-space-12);
  border: 1px solid var(--lp-border);
  border-radius: 12px;
  background: var(--lp-page-bg);
  transition: border-color var(--lp-dur-press) var(--lp-ease);
}

.lp-agentviz__composer--typing,
.lp-agentviz__composer--sending {
  border-color: var(--lp-terracotta);
  box-shadow: 0 0 0 3px var(--lp-focus-ring);
}

.lp-agentviz__composer-text {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 13px;
  line-height: 1.45;
  color: var(--lp-text);
  text-wrap: pretty;
}

.lp-agentviz__caret {
  display: inline-block;
  width: 1.5px;
  height: 1em;
  margin-left: 1px;
  vertical-align: text-bottom;
  background: var(--lp-terracotta);
  animation: lp-agent-caret 900ms steps(1, end) infinite;
}

.lp-agentviz__send {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: var(--lp-surface-subdued);
  color: var(--lp-text-muted);
  transition:
    background-color var(--lp-dur-press) var(--lp-ease),
    color var(--lp-dur-press) var(--lp-ease),
    transform var(--lp-dur-press) var(--lp-ease);
}

.lp-agentviz__send svg {
  width: 14px;
  height: 14px;
}

.lp-agentviz__send--ready {
  background: var(--lp-terracotta);
  color: var(--lp-surface);
}

.lp-agentviz__send--pressed {
  transform: scale(0.88);
}

/* Work log — mirrors the agent panel inside the product */

.lp-agentviz__log {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: var(--lp-space-4);
  /* Reserved so rows streaming in never resize the card. */
  min-height: 144px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.lp-agentviz__row {
  display: flex;
  align-items: center;
  gap: var(--lp-space-8);
  padding: var(--lp-space-8);
  border-radius: 10px;
  animation: lp-agent-row-in 360ms var(--lp-ease) both;
}

.lp-agentviz__row--active {
  background: var(--lp-surface-subdued);
}

.lp-agentviz__row--done {
  opacity: 0.62;
}

.lp-agentviz__row-icon {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: var(--lp-olive);
}

.lp-agentviz__check {
  width: 12px;
  height: 12px;
}

.lp-agentviz__spinner {
  width: 11px;
  height: 11px;
  border: 1.5px solid var(--lp-border);
  border-top-color: var(--lp-terracotta);
  border-radius: 50%;
  animation: lp-agent-spin 700ms linear infinite;
}

.lp-agentviz__row-copy {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--lp-space-8);
}

.lp-agentviz__row-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--lp-text);
}

.lp-agentviz__row--think .lp-agentviz__row-title {
  font-style: italic;
  font-weight: 500;
  color: var(--lp-text-muted);
}

.lp-agentviz__row-meta {
  font-family: var(--lp-font-mono);
  font-size: 11px;
  color: var(--lp-text-muted);
}

.lp-agentviz__timer {
  margin-left: auto;
  padding-left: var(--lp-space-8);
  font-family: var(--lp-font-mono);
  font-size: 11px;
  color: var(--lp-text-muted);
  font-variant-numeric: tabular-nums;
}

/* Timeline — video, audio, and caption tracks under a time ruler */

.lp-agentviz__tl-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--lp-space-8);
  padding-top: var(--lp-space-12);
  border-top: 1px solid var(--lp-border);
}

.lp-agentviz__tl-title {
  font-family: var(--lp-font-mono);
  font-size: 10px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--lp-text-muted);
}

.lp-agentviz__tl-chip {
  padding: 3px 10px;
  border-radius: 999px;
  background: var(--lp-olive);
  color: var(--lp-surface);
  font-family: var(--lp-font-mono);
  font-size: 10px;
  letter-spacing: 0.02em;
  animation: lp-agent-chip-in 360ms var(--lp-ease) both;
}

.lp-agentviz__tl {
  border: 1px solid var(--lp-border);
  border-radius: 10px;
  background: var(--lp-page-bg);
  padding: var(--lp-space-8);
}

.lp-agentviz__tl-grid {
  position: relative;
  display: grid;
  grid-template-columns: 26px minmax(0, 1fr);
  gap: 4px var(--lp-space-8);
  align-items: center;
  --lp-tl-lane-start: 34px;
}

.lp-agentviz__ruler {
  display: flex;
  justify-content: space-between;
  height: 14px;
  border-bottom: 1px solid var(--lp-border);
}

.lp-agentviz__tick {
  position: relative;
  flex: none;
  font-family: var(--lp-font-mono);
  font-size: 8px;
  line-height: 1;
  color: var(--lp-text-muted);
}

.lp-agentviz__tick::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 1px;
  height: 4px;
  background: var(--lp-border);
}

.lp-agentviz__tl-name {
  font-family: var(--lp-font-mono);
  font-size: 9px;
  letter-spacing: 0.04em;
  color: var(--lp-text-muted);
  text-align: right;
}

.lp-agentviz__lane {
  display: flex;
  gap: 2px;
  height: 34px;
  padding: 2px;
  border-radius: 4px;
  background: var(--lp-surface-subdued);
}

.lp-agentviz__lane--audio { height: 22px; }
.lp-agentviz__lane--text { height: 14px; }

/* Video clips read as NLE clips: label header over a filmstrip body. */

.lp-agentviz__clip {
  position: relative;
  display: flex;
  flex-direction: column;
  flex-basis: 0;
  min-width: 0;
  overflow: hidden;
  border-radius: 3px;
  opacity: 0;
  transform: scaleX(0.94);
  transform-origin: left center;
  transition:
    opacity 300ms var(--lp-ease),
    transform 300ms var(--lp-ease);
}

.lp-agentviz__clip--pending,
.lp-agentviz__clip--in {
  opacity: 1;
  transform: scaleX(1);
}

.lp-agentviz__clip--pending {
  opacity: 0.55;
}

.lp-agentviz__clip-head {
  padding: 1px 4px;
  font-family: var(--lp-font-mono);
  font-size: 8px;
  line-height: 1.5;
  color: var(--lp-surface);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.lp-agentviz__clip-frames {
  flex: 1 1;
  background-image: repeating-linear-gradient(
    90deg,
    rgba(255, 253, 248, 0.28) 0 1px,
    transparent 1px 12px
  );
}

.lp-agentviz__clip--1 { background: var(--lp-terracotta); }
.lp-agentviz__clip--2 { background: var(--lp-olive); }
.lp-agentviz__clip--3 { background: var(--lp-sepia); }

.lp-agentviz__clip--pending .lp-agentviz__clip-frames {
  background-image: repeating-linear-gradient(
    -45deg,
    rgba(255, 253, 248, 0.34) 0 4px,
    transparent 4px 8px
  );
}

/* Audio track */

.lp-agentviz__audio {
  display: flex;
  flex: 1 1;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 1px;
  overflow: hidden;
  padding: 0 3px;
  border: 1px solid var(--lp-border);
  border-radius: 3px;
  background: var(--lp-surface);
  opacity: 0;
  transition: opacity 320ms var(--lp-ease);
}

.lp-agentviz__audio--pending { opacity: 0.45; }
.lp-agentviz__audio--in { opacity: 1; }

.lp-agentviz__audio span {
  flex: 0 0 2px;
  border-radius: 1px;
  background: var(--lp-sepia);
}

/* Caption track */

.lp-agentviz__caption {
  flex: 1 1;
  border-radius: 2px;
  background: var(--lp-text-muted);
  opacity: 0;
}

.lp-agentviz__caption--pending {
  opacity: 0.4;
  animation: lp-agent-caption-in 300ms var(--lp-ease) both;
}

.lp-agentviz__caption--in {
  opacity: 0.85;
  animation: lp-agent-caption-in 300ms var(--lp-ease) both;
}

.lp-agentviz__playhead {
  position: absolute;
  top: 0;
  bottom: 0;
  left: var(--lp-tl-lane-start);
  width: 1.5px;
  background: var(--lp-rust);
  animation: lp-agent-playhead 2000ms var(--lp-ease) infinite;
}

.lp-agentviz__playhead::before {
  content: '';
  position: absolute;
  top: -1px;
  left: -3.25px;
  width: 8px;
  height: 6px;
  clip-path: polygon(0 0, 100% 0, 50% 100%);
  background: var(--lp-rust);
}

.lp-agentviz__playhead--parked {
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}

@keyframes lp-agent-caret {
  50% { opacity: 0; }
}

@keyframes lp-agent-row-in {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes lp-agent-chip-in {
  from { opacity: 0; transform: translateY(-4px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes lp-agent-caption-in {
  from { transform: scaleX(0.6); }
  to { transform: scaleX(1); }
}

@keyframes lp-agent-spin {
  to { transform: rotate(360deg); }
}

@keyframes lp-agent-playhead {
  from { left: var(--lp-tl-lane-start); }
  to { left: calc(100% - 2px); }
}

@media (prefers-reduced-motion: reduce) {
  .lp-agentviz__row,
  .lp-agentviz__caret,
  .lp-agentviz__tl-chip,
  .lp-agentviz__caption,
  .lp-agentviz__spinner,
  .lp-agentviz__playhead {
    animation: none;
  }

  .lp-agentviz__caret { display: none; }
  .lp-agentviz__playhead { left: calc(100% - 2px); }
}


.lp-illustration {
  width: 100%;
  height: auto;
  display: block;
  color: var(--lp-sepia);
}

.lp-ink {
  stroke: var(--lp-sepia);
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.lp-fill-paper { fill: var(--lp-page-bg); }
.lp-fill-surface { fill: var(--lp-surface); }
.lp-fill-subdued { fill: var(--lp-surface-subdued); }
.lp-fill-terra { fill: var(--lp-terracotta); }
.lp-fill-olive { fill: var(--lp-olive); }
.lp-fill-sepia { fill: var(--lp-sepia); }

/* ═══════════════════════════════════════════════════════════════
   Tagline reveal
   ═══════════════════════════════════════════════════════════════ */

.lp-tagline {
  padding-top: var(--lp-space-96);
  padding-bottom: var(--lp-space-96);
  text-align: center;
}

@media (max-width: 639px) {
  .lp-tagline {
    padding-top: var(--lp-space-64);
    padding-bottom: var(--lp-space-64);
  }
}

.lp-tagline__text {
  margin: 0 auto;
  max-width: var(--lp-text-max);
  font-size: 36px;
  font-weight: 500;
  line-height: 1.12;
  letter-spacing: -0.02em;
  color: var(--lp-text);
  text-wrap: balance;
}

@media (min-width: 640px) {
  .lp-tagline__text { font-size: 48px; }
}

@media (min-width: 1024px) {
  .lp-tagline__text { font-size: 60px; }
}

.lp-tagline__line {
  display: block;
}

.lp-tagline__word {
  opacity: 0.3;
  transition: opacity 800ms var(--lp-ease);
}

.lp-tagline--visible .lp-tagline__word {
  opacity: 1;
}

/* ═══════════════════════════════════════════════════════════════
   Factory journey
   ═══════════════════════════════════════════════════════════════ */

.lp-factory__intro {
  max-width: var(--lp-text-max);
}

.lp-factory__media {
  margin-top: var(--lp-space-48);
}

@media (max-width: 639px) {
  .lp-factory__media { margin-top: var(--lp-space-32); }
}

/* ── Content factory workflow ────────────────────────────────── */

.lp-flow {
  width: 100%;
  padding: var(--lp-space-16);
  border: 1px solid var(--lp-border);
  border-radius: 16px;
  background: var(--lp-surface);
}

@media (min-width: 768px) {
  .lp-flow { padding: var(--lp-space-24); }
}

/* Automation canvas: dot grid, edges behind, nodes on top. */
.lp-flow__canvas {
  position: relative;
  width: 100%;
  border-radius: 12px;
  background-color: var(--lp-page-bg);
  background-image: radial-gradient(var(--lp-border) 1.2px, transparent 1.2px);
  background-size: 18px 18px;
  background-position: -9px -9px;
}

@media (min-width: 768px) {
  .lp-flow__canvas {
    aspect-ratio: 1000 / 300;
  }
}

.lp-flow__edges {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
  display: none;
}

@media (min-width: 768px) {
  .lp-flow__edges { display: block; }
}

.lp-flow__edge {
  fill: none;
  stroke: var(--lp-border);
  stroke-width: 2;
  stroke-linecap: round;
  vector-effect: non-scaling-stroke;
  stroke-dasharray: 1;
  stroke-dashoffset: 1;
  /* Round caps leave a sliver at zero dash length, so undrawn edges are
     hidden outright rather than relying on the dash alone. */
  stroke-opacity: 0;
  transition:
    stroke-dashoffset 320ms var(--lp-ease),
    stroke-opacity 160ms var(--lp-ease),
    stroke 260ms var(--lp-ease);
}

.lp-flow__edge--drawn,
.lp-flow__edge--flowing {
  stroke-dashoffset: 0;
  stroke-opacity: 1;
}

.lp-flow__edge--flowing {
  stroke: var(--lp-terracotta);
  stroke-dasharray: 0.022 0.018;
  animation: lp-flow-dash 520ms linear infinite;
}

.lp-flow__nodes {
  margin: 0;
  padding: 0;
  list-style: none;
}

/* Mobile: a vertical run of steps with a connecting spine. */
@media (max-width: 767px) {
  .lp-flow__nodes {
    display: flex;
    flex-direction: column;
    gap: var(--lp-space-24);
    padding: var(--lp-space-16);
  }

  .lp-flow__node {
    position: relative;
    display: flex;
    align-items: center;
    gap: var(--lp-space-12);
  }

  .lp-flow__node:not(:first-child)::before {
    content: '';
    position: absolute;
    left: 27px;
    bottom: 100%;
    width: 2px;
    height: var(--lp-space-24);
    background: var(--lp-border);
    transform-origin: bottom center;
    transform: scaleY(0);
    transition: transform 300ms var(--lp-ease);
  }

  /* Must match the base rule's specificity to win. */
  .lp-flow__node--idle:not(:first-child)::before,
  .lp-flow__node--running:not(:first-child)::before,
  .lp-flow__node--done:not(:first-child)::before {
    transform: scaleY(1);
  }

  .lp-flow__node--running:not(:first-child)::before {
    background: var(--lp-terracotta);
  }
}

@media (min-width: 768px) {
  .lp-flow__node {
    position: absolute;
    left: var(--lp-node-x);
    top: var(--lp-node-y);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--lp-space-8);
    width: 128px;
    transform: translate(-50%, -50%);
  }
}

.lp-flow__node {
  opacity: 0;
  transition: opacity 300ms var(--lp-ease);
}

.lp-flow__node--idle,
.lp-flow__node--running,
.lp-flow__node--done {
  opacity: 1;
}

/* The node tile — the part that reads as a workflow step. */
.lp-flow__tile {
  position: relative;
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border: 1px solid var(--lp-border);
  border-radius: 14px;
  background: var(--lp-surface);
  color: var(--lp-sepia);
  box-shadow: 0 6px 16px -12px rgba(23, 18, 14, 0.7);
  transform: scale(0.9);
  transition:
    transform 300ms var(--lp-ease),
    border-color 260ms var(--lp-ease),
    box-shadow 260ms var(--lp-ease),
    color 260ms var(--lp-ease);
}

.lp-flow__node--idle .lp-flow__tile,
.lp-flow__node--running .lp-flow__tile,
.lp-flow__node--done .lp-flow__tile {
  transform: scale(1);
}

.lp-flow__node--running .lp-flow__tile {
  border-color: var(--lp-terracotta);
  color: var(--lp-terracotta);
  box-shadow: 0 0 0 4px var(--lp-focus-ring);
}

.lp-flow__node--done .lp-flow__tile {
  color: var(--lp-olive);
}

.lp-flow__icon {
  transition: opacity 200ms var(--lp-ease);
}

/* While a node runs, its own animation takes over the tile. */
.lp-flow__node--running .lp-flow__icon {
  opacity: 0;
}

/* Connection ports, the small dots an edge attaches to. */
.lp-flow__port {
  position: absolute;
  top: 50%;
  width: 7px;
  height: 7px;
  margin-top: -3.5px;
  border: 1.5px solid var(--lp-border);
  border-radius: 50%;
  background: var(--lp-surface);
  display: none;
}

@media (min-width: 768px) {
  .lp-flow__port { display: block; }
}

.lp-flow__port--in { left: -4px; }
.lp-flow__port--out { right: -4px; }

.lp-flow__node--running .lp-flow__port {
  border-color: var(--lp-terracotta);
}

.lp-flow__node--instagram .lp-flow__port--in,
.lp-flow__node--publish .lp-flow__port--out {
  display: none;
}

/* Completed steps get the check badge an automation tool would show. */
.lp-flow__badge {
  position: absolute;
  top: -6px;
  right: -6px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--lp-olive);
  color: var(--lp-surface);
  opacity: 0;
  transform: scale(0.4);
  transition: opacity 220ms var(--lp-ease), transform 220ms var(--lp-ease);
}

.lp-flow__badge svg {
  width: 10px;
  height: 10px;
}

.lp-flow__node--done .lp-flow__badge {
  opacity: 1;
  transform: scale(1);
}

.lp-flow__label {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

@media (min-width: 768px) {
  .lp-flow__label {
    align-items: center;
    text-align: center;
  }
}

.lp-flow__title {
  font-size: 12px;
  font-weight: 600;
  line-height: 1.25;
  color: var(--lp-text);
}

.lp-flow__meta {
  font-family: var(--lp-font-mono);
  font-size: 10px;
  line-height: 1.3;
  color: var(--lp-text-muted);
}

/* ── Per-node micro animations, played inside the tile ───────── */

.lp-flow__viz {
  position: absolute;
  inset: 12px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 2px;
  opacity: 0;
  transition: opacity 200ms var(--lp-ease);
  pointer-events: none;
}

.lp-flow__node--running .lp-flow__viz {
  opacity: 1;
}

/* Instagram: a grid of Reels tiles popping in. */
.lp-flow__viz--grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  place-items: stretch;
  gap: 2px;
}

.lp-flow__viz--grid > span {
  border-radius: 2px;
  background: var(--lp-terracotta);
  animation: lp-flow-pop 1500ms var(--lp-ease) infinite;
}

/* TikTok: a feed scrolling past. */
.lp-flow__viz--feed {
  overflow: hidden;
  border-radius: 3px;
}

.lp-flow__feed-track {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  animation: lp-flow-scroll 2200ms linear infinite;
}

.lp-flow__feed-track > span {
  flex: none;
  height: 9px;
  border-radius: 2px;
  background: var(--lp-terracotta);
}

/* Meta Ads: a bar chart filling in. */
.lp-flow__viz--bars > span {
  width: 5px;
  height: var(--lp-bar-h);
  border-radius: 1px;
  background: var(--lp-terracotta);
  transform-origin: bottom center;
  animation: lp-flow-grow 1500ms var(--lp-ease) infinite;
}

/* Ideate: lines writing themselves. */
.lp-flow__viz--lines {
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
}

.lp-flow__viz--lines > span {
  height: 4px;
  width: var(--lp-line-w);
  border-radius: 2px;
  background: var(--lp-terracotta);
  transform-origin: left center;
  animation: lp-flow-write 1800ms var(--lp-ease) infinite;
}

/* Generate: vertical frames filling. */
.lp-flow__viz--frames {
  align-items: stretch;
  gap: 3px;
}

.lp-flow__viz--frames > span {
  position: relative;
  flex: 1 1;
  border-radius: 2px;
  overflow: hidden;
  background: var(--lp-surface-subdued);
}

.lp-flow__viz--frames > span::after {
  content: '';
  position: absolute;
  inset: 0;
  background: var(--lp-terracotta);
  transform-origin: bottom center;
  animation: lp-flow-fill 1800ms var(--lp-ease) infinite;
}

/* Approval: Slack messages answered with a check. */
.lp-flow__viz--approve {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 3px;
}

.lp-flow__bubble {
  height: 5px;
  border-radius: 3px;
  background: var(--lp-terracotta);
  opacity: 0.5;
}

.lp-flow__bubble:first-child { width: 100%; }
.lp-flow__bubble:nth-child(2) { width: 62%; }

.lp-flow__tick {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: flex-end;
  width: 14px;
  height: 14px;
  margin-top: 2px;
  border-radius: 50%;
  background: var(--lp-olive);
  color: var(--lp-surface);
  animation: lp-flow-pop-in 1800ms var(--lp-ease) infinite;
}

.lp-flow__tick svg {
  width: 9px;
  height: 9px;
}

/* Publish: a live signal going out. */
.lp-flow__viz--publish {
  align-items: center;
}

.lp-flow__live {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--lp-terracotta);
}

.lp-flow__pulse {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  margin: -4px 0 0 -4px;
  border-radius: 50%;
  border: 1.5px solid var(--lp-terracotta);
  animation: lp-flow-ripple 2400ms var(--lp-ease) infinite;
}

.lp-flow__pulse:nth-child(2) {
  animation-delay: 800ms;
}

@keyframes lp-flow-dash {
  to { stroke-dashoffset: -0.04; }
}

@keyframes lp-flow-pop {
  0%, 100% { transform: scale(0.65); opacity: 0.4; }
  40% { transform: scale(1); opacity: 1; }
}

@keyframes lp-flow-scroll {
  to { transform: translateY(-50%); }
}

@keyframes lp-flow-grow {
  0%, 100% { transform: scaleY(0.4); }
  50% { transform: scaleY(1); }
}

@keyframes lp-flow-write {
  from { transform: scaleX(0); }
  60%, 100% { transform: scaleX(1); }
}

@keyframes lp-flow-fill {
  from { transform: scaleY(0); }
  70%, 100% { transform: scaleY(1); }
}

@keyframes lp-flow-pop-in {
  0%, 45% { transform: scale(0); }
  65% { transform: scale(1.2); }
  80%, 100% { transform: scale(1); }
}

@keyframes lp-flow-ripple {
  from { transform: scale(1); opacity: 0.7; }
  to { transform: scale(3.4); opacity: 0; }
}

@media (prefers-reduced-motion: reduce) {
  .lp-flow__node,
  .lp-flow__tile,
  .lp-flow__badge,
  .lp-flow__edge,
  .lp-flow__viz > span,
  .lp-flow__feed-track,
  .lp-flow__tick,
  .lp-flow__pulse,
  .lp-flow__viz--frames > span::after {
    animation: none;
    transition: none;
  }

  .lp-flow__pulse { display: none; }
}

.lp-factory__stages {
  list-style: none;
  padding: 0;
  margin-bottom: 0;
  margin-top: var(--lp-space-64);
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--lp-space-24);
}

@media (min-width: 640px) {
  .lp-factory__stages {
    grid-template-columns: repeat(2, 1fr);
    gap: var(--lp-space-32);
  }
}

@media (min-width: 1024px) {
  .lp-factory__stages > .lp-stage:nth-child(even) {
    transform: translateY(var(--lp-space-48));
  }
}

.lp-stage {
  border: 1px solid var(--lp-border);
  border-radius: 16px;
  background: var(--lp-surface);
  padding: var(--lp-space-16);
}

@media (min-width: 1024px) {
  .lp-stage { padding: var(--lp-space-24); }
}

.lp-stage__number {
  display: block;
  font-family: var(--lp-font-mono);
  font-size: 14px;
  font-weight: 500;
  color: var(--lp-terracotta);
  margin-bottom: var(--lp-space-16);
}

.lp-stage__title {
  margin: 0;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: -0.01em;
  color: var(--lp-text);
}

@media (min-width: 640px) {
  .lp-stage__title { font-size: 24px; }
}

.lp-stage__outcome {
  margin: var(--lp-space-12) 0 0;
  font-size: 16px;
  line-height: 1.55;
  font-weight: 500;
  color: var(--lp-text);
  text-wrap: pretty;
}

.lp-stage__detail {
  margin: var(--lp-space-8) 0 0;
  font-size: 14px;
  line-height: 1.65;
  color: var(--lp-text-muted);
  text-wrap: pretty;
}

/* ═══════════════════════════════════════════════════════════════
   Force multiplier
   ═══════════════════════════════════════════════════════════════ */

.lp-force__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--lp-space-48);
  align-items: center;
}

@media (min-width: 1024px) {
  .lp-force__grid {
    grid-template-columns: repeat(12, 1fr);
    gap: var(--lp-space-24);
  }
  .lp-force__copy { grid-column: span 5; }
  .lp-force__visual { grid-column: span 7; }
}

.lp-force__scale {
  margin: var(--lp-space-24) 0 0;
  font-size: 18px;
  line-height: 1.5;
  font-weight: 500;
  color: var(--lp-text);
  text-wrap: pretty;
}

.lp-force__control {
  margin: var(--lp-space-16) 0 0;
  font-size: 16px;
  line-height: 1.6;
  color: var(--lp-text-muted);
  text-wrap: pretty;
}

.lp-force__canvas {
  position: relative;
}

.lp-force__source {
  position: relative;
  z-index: 2;
  width: min(220px, 52%);
  aspect-ratio: 9 / 16;
  border: 1px solid var(--lp-border);
  border-radius: 16px;
  background: var(--lp-surface);
  padding: var(--lp-space-8);
}

.lp-force__source-screen {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background: var(--lp-surface-subdued);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  color: var(--lp-sepia);
}

/* A still frame, never played: no controls, no pointer target. */
.lp-force__source-video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  pointer-events: none;
}

.lp-force__source-play {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: rgba(255, 253, 248, 0.92);
  color: var(--lp-sepia);
  padding-left: 3px;
  box-shadow: 0 6px 18px -8px rgba(23, 18, 14, 0.65);
}

.lp-force__connectors {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  color: var(--lp-sepia);
  z-index: 1;
}

.lp-force__branch-path {
  stroke-dasharray: 1;
  stroke-dashoffset: 1;
  transition: stroke-dashoffset 1200ms var(--lp-ease);
}

.lp-force__visual--visible .lp-force__branch-path {
  stroke-dashoffset: 0;
}

.lp-force__visual--visible .lp-force__branch-path--2 {
  transition-delay: 150ms;
}

.lp-force__visual--visible .lp-force__branch-path--3 {
  transition-delay: 300ms;
}

.lp-force__groups {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 2;
  width: 58%;
  height: 100%;
  display: grid;
  grid-template-rows: repeat(3, 1fr);
  align-items: center;
  gap: var(--lp-space-24);
}

.lp-force__group {
  border: 1px solid var(--lp-border);
  border-radius: 16px;
  background: var(--lp-surface);
  padding: var(--lp-space-16);
  opacity: 0;
  transform: translateY(24px);
  transition: opacity 700ms var(--lp-ease), transform 700ms var(--lp-ease);
}

.lp-force__visual--visible .lp-force__group {
  opacity: 1;
  transform: translateY(0);
}

.lp-force__visual--visible .lp-force__group--2 { transition-delay: 150ms; }
.lp-force__visual--visible .lp-force__group--3 { transition-delay: 300ms; }

.lp-force__group-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--lp-space-12);
}

.lp-force__group-label {
  font-size: 14px;
  font-weight: 600;
  color: var(--lp-text);
}

.lp-force__group-count {
  font-family: var(--lp-font-mono);
  font-size: 14px;
  font-weight: 500;
  color: var(--lp-terracotta);
}

.lp-force__chips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--lp-space-8);
  margin-top: var(--lp-space-12);
}

.lp-force__chip {
  display: inline-flex;
  align-items: center;
  gap: var(--lp-space-4);
  padding: var(--lp-space-4) var(--lp-space-8);
  border: 1px solid var(--lp-border);
  border-radius: 999px;
  background: var(--lp-page-bg);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  color: var(--lp-text);
  white-space: nowrap;
}

.lp-force__chip-flag {
  font-size: 13px;
  line-height: 1;
}

.lp-force__chip--more {
  font-family: var(--lp-font-mono);
  color: var(--lp-terracotta);
  border-color: var(--lp-terracotta);
  background: transparent;
}

@media (min-width: 1024px) {
  .lp-force__canvas {
    min-height: 520px;
  }
}

/* Mobile: source frame above branch groups (absolute overlay is too cramped
   at small widths, so the visual becomes a static vertical stack). */
@media (max-width: 639px) {
  .lp-force__source {
    width: min(200px, 64%);
    margin: 0 auto;
  }

  .lp-force__connectors {
    display: none;
  }

  .lp-force__groups {
    position: static;
    width: 100%;
    height: auto;
    grid-template-rows: none;
    margin-top: var(--lp-space-24);
    gap: var(--lp-space-16);
  }
}

/* ═══════════════════════════════════════════════════════════════
   Brand control
   ═══════════════════════════════════════════════════════════════ */

.lp-brand__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--lp-space-48);
  align-items: start;
}

@media (min-width: 1024px) {
  .lp-brand__grid {
    grid-template-columns: repeat(12, 1fr);
    gap: var(--lp-space-24);
  }
  .lp-brand__inputs-col { grid-column: span 5; }
  .lp-brand__review-col { grid-column: span 7; }
}

.lp-brand__inputs {
  list-style: none;
  margin: var(--lp-space-32) 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--lp-space-12);
}

.lp-brand__input {
  display: flex;
  align-items: center;
  gap: var(--lp-space-12);
  padding: var(--lp-space-12) var(--lp-space-16);
  border: 1px solid var(--lp-border);
  border-radius: 12px;
  background: var(--lp-surface);
  font-size: 16px;
  font-weight: 500;
  color: var(--lp-text);
}

.lp-brand__input-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: var(--lp-surface-subdued);
  color: var(--lp-sepia);
  flex-shrink: 0;
}

.lp-brand__sequence {
  list-style: none;
  padding: 0;
  margin-top: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--lp-space-8);
  margin-bottom: var(--lp-space-24);
}

.lp-brand__sequence-step {
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  padding: var(--lp-space-8) var(--lp-space-12);
  border: 1px solid var(--lp-border);
  border-radius: 999px;
  background: var(--lp-surface);
  font-size: 13px;
  font-weight: 500;
  color: var(--lp-text-muted);
  white-space: nowrap;
}

.lp-brand__sequence-arrow {
  color: var(--lp-sepia);
  flex-shrink: 0;
}

.lp-slack-mock {
  border: 1px solid var(--lp-border);
  border-radius: 16px;
  background: var(--lp-surface);
  padding: var(--lp-space-16);
  max-width: 420px;
}

@media (min-width: 1024px) {
  .lp-slack-mock { padding: var(--lp-space-24); }
}

.lp-slack-mock__row {
  display: flex;
  gap: var(--lp-space-12);
}

.lp-slack-mock__avatar {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: var(--lp-terracotta);
  color: var(--lp-surface);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  flex-shrink: 0;
}

.lp-slack-mock__body {
  min-width: 0;
}

.lp-slack-mock__name {
  display: flex;
  align-items: center;
  gap: var(--lp-space-8);
  font-size: 14px;
  font-weight: 600;
  color: var(--lp-text);
}

.lp-slack-mock__badge {
  padding: 0 var(--lp-space-4);
  border-radius: 4px;
  background: var(--lp-surface-subdued);
  color: var(--lp-text-muted);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.lp-slack-mock__message {
  margin: var(--lp-space-4) 0 0;
  font-size: 14px;
  line-height: 1.5;
  color: var(--lp-text);
}

.lp-slack-mock__actions {
  display: flex;
  gap: var(--lp-space-8);
  margin-top: var(--lp-space-12);
}

.lp-slack-mock__action {
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  padding: var(--lp-space-8) var(--lp-space-12);
  border: 1px solid var(--lp-border);
  border-radius: 8px;
  background: var(--lp-surface);
  color: var(--lp-text);
  font-size: 13px;
  font-weight: 600;
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
}

/* ═══════════════════════════════════════════════════════════════
   Platform coverage
   ═══════════════════════════════════════════════════════════════ */

.lp-platforms__groups {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--lp-space-24);
  margin-top: var(--lp-space-48);
}

@media (min-width: 640px) {
  .lp-platforms__groups {
    grid-template-columns: repeat(2, 1fr);
    gap: var(--lp-space-32);
  }
}

.lp-platforms__group {
  border: 1px solid var(--lp-border);
  border-radius: 16px;
  background: var(--lp-surface);
  padding: var(--lp-space-24);
}

.lp-platforms__group-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: var(--lp-terracotta);
  margin-bottom: var(--lp-space-16);
}

.lp-platforms__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: var(--lp-space-8);
}

.lp-platforms__item {
  display: inline-flex;
  align-items: center;
  gap: var(--lp-space-8);
  min-height: 40px;
  padding: var(--lp-space-8) var(--lp-space-12);
  border: 1px solid var(--lp-border);
  border-radius: 999px;
  background: var(--lp-page-bg);
  font-size: 16px;
  font-weight: 500;
  color: var(--lp-text);
}

.lp-platforms__planned {
  padding: var(--lp-space-2) var(--lp-space-8);
  border-radius: 999px;
  background: var(--lp-surface-subdued);
  color: var(--lp-text-muted);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

/* ═══════════════════════════════════════════════════════════════
   Results
   ═══════════════════════════════════════════════════════════════ */

.lp-results__grid {
  list-style: none;
  padding: 0;
  margin-bottom: 0;
  margin-top: var(--lp-space-48);
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--lp-space-48);
}

@media (min-width: 640px) {
  .lp-results__grid {
    grid-template-columns: repeat(3, 1fr);
    gap: var(--lp-space-32);
  }
}

.lp-result__value {
  display: block;
  font-size: 48px;
  font-weight: 500;
  line-height: 1.05;
  letter-spacing: -0.02em;
  color: var(--lp-text);
}

@media (min-width: 1024px) {
  .lp-result__value { font-size: 60px; }
}

.lp-result__value--mono {
  font-family: var(--lp-font-mono);
  letter-spacing: -0.04em;
}

.lp-result__label {
  display: block;
  margin-top: var(--lp-space-12);
  font-size: 16px;
  line-height: 1.55;
  color: var(--lp-text-muted);
  max-width: 32ch;
}

@media (min-width: 1024px) {
  .lp-result__label { font-size: 18px; }
}

/* ═══════════════════════════════════════════════════════════════
   FAQ
   ═══════════════════════════════════════════════════════════════ */

.lp-faq__heading {
  text-align: center;
}

.lp-faq__list {
  margin: var(--lp-space-48) auto 0;
  max-width: var(--lp-composer-max);
  display: flex;
  flex-direction: column;
  gap: var(--lp-space-12);
}

.lp-faq__item {
  border: 1px solid var(--lp-border);
  border-radius: 16px;
  background: var(--lp-surface);
  overflow: hidden;
}

.lp-faq__summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--lp-space-16);
  width: 100%;
  padding: var(--lp-space-16);
  border: none;
  background: none;
  font-family: inherit;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  color: var(--lp-text);
  text-align: left;
  cursor: pointer;
  list-style: none;
  transition: background-color var(--lp-dur-press) var(--lp-ease);
}

@media (min-width: 1024px) {
  .lp-faq__summary { padding: var(--lp-space-24); }
}

.lp-faq__summary::-webkit-details-marker {
  display: none;
}

.lp-faq__summary:hover {
  background: var(--lp-surface-active);
}

.lp-faq__summary:focus-visible {
  outline: 2px solid var(--lp-terracotta);
  outline-offset: -2px;
}

.lp-faq__icon {
  flex-shrink: 0;
  color: var(--lp-text-muted);
  transition: transform var(--lp-dur-press) var(--lp-ease);
}

.lp-faq__item[open] .lp-faq__icon {
  transform: rotate(180deg);
}

.lp-faq__answer {
  padding: 0 var(--lp-space-16) var(--lp-space-16);
  font-size: 16px;
  line-height: 1.65;
  color: var(--lp-text-muted);
  text-wrap: pretty;
}

@media (min-width: 1024px) {
  .lp-faq__answer { padding: 0 var(--lp-space-24) var(--lp-space-24); }
}

.lp-faq__answer p {
  margin: 0;
}

/* ═══════════════════════════════════════════════════════════════
   Final CTA
   ═══════════════════════════════════════════════════════════════ */

.lp-final-cta {
  text-align: center;
}

.lp-final-cta__composer {
  margin: var(--lp-space-48) auto 0;
  max-width: var(--lp-composer-max);
  text-align: left;
}

.lp-final-cta .lp-body {
  margin-left: auto;
  margin-right: auto;
}

/* ═══════════════════════════════════════════════════════════════
   Authenticated home (inside UniversalLayout)
   ═══════════════════════════════════════════════════════════════ */

:root .lp-page.lp-page--app {
  --lp-page-bg: var(--color-bg-root);
  --lp-surface: var(--color-bg-canvas-surface);
  --lp-surface-subdued: var(--color-bg-user-bubble);
  --lp-surface-elevated: var(--color-bg-sidebar);
  --lp-surface-active: var(--color-bg-user-bubble);
  --lp-text: var(--color-text-primary);
  --lp-text-muted: var(--color-text-secondary);
  --lp-border: var(--color-border-input);
  --lp-terracotta: var(--color-accent-base);
  --lp-rust: var(--color-accent-strong);
  --lp-olive: var(--color-accent-base);
  --lp-sepia: var(--color-text-secondary);
  --lp-error: var(--color-status-error-text);
  --lp-hero-heading-from: var(--color-text-primary);
  --lp-hero-heading-to: var(--color-text-secondary);
  --lp-focus-ring: var(--color-focus-ring);
  --lp-grain-opacity: 0;
  --lp-glass: var(--color-bg-sidebar);
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 100%;
}

.lp-app-home {
  display: flex;
  flex: 1 1;
  width: 100%;
  align-items: flex-start;
  justify-content: center;
  padding: max(
    var(--lp-space-96),
    calc(50vh - var(--lp-space-96) - var(--lp-space-48))
  ) 0 var(--lp-space-64);
  overflow-y: auto;
}

.lp-app-home__inner {
  max-width: var(--lp-composer-max);
  text-align: center;
}

.lp-app-home__title {
  margin: 0 0 var(--lp-space-40);
}

.lp-app-home form {
  text-align: left;
}

/* ─── Authenticated project activity ─── */

.lp-project-runs {
  margin-top: var(--lp-space-24);
  text-align: left;
}

.lp-project-runs__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--lp-space-16);
  margin-bottom: var(--lp-space-8);
  padding: 0 var(--lp-space-4);
}

.lp-project-runs__header h2 {
  margin: 0;
  color: var(--lp-text);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}

.lp-project-runs__header button {
  min-height: 24px;
  border: none;
  border-radius: 8px;
  padding: var(--lp-space-4) var(--lp-space-8);
  background: transparent;
  color: var(--lp-text-muted);
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: color var(--lp-dur-press) var(--lp-ease),
    background-color var(--lp-dur-press) var(--lp-ease),
    transform var(--lp-dur-press) var(--lp-ease);
}

.lp-project-runs__header button:hover {
  background: var(--lp-surface-active);
  color: var(--lp-text);
}

.lp-project-runs__header button:active {
  transform: scale(0.98);
}

.lp-project-runs__header button:focus-visible,
.lp-project-run:focus-visible {
  outline: 2px solid var(--lp-terracotta);
  outline-offset: 2px;
}

.lp-project-runs__list {
  display: flex;
  flex-direction: column;
  gap: var(--lp-space-4);
}

.lp-project-run {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto auto;
  align-items: center;
  gap: var(--lp-space-8);
  width: 100%;
  min-height: 40px;
  overflow: hidden;
  border: 1px solid transparent;
  border-radius: 8px;
  padding: var(--lp-space-4) var(--lp-space-8);
  background: transparent;
  color: var(--lp-text);
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  animation: lpProjectRunEnter 240ms var(--lp-ease) both;
  transition: border-color var(--lp-dur-press) var(--lp-ease),
    background-color var(--lp-dur-press) var(--lp-ease);
}

.lp-project-run:hover:not(:disabled) {
  border-color: var(--lp-border);
  background: var(--lp-surface-active);
}

.lp-project-run:active:not(:disabled) {
  background: var(--lp-surface-subdued);
}

.lp-project-run:disabled {
  cursor: wait;
  opacity: 1;
}

.lp-project-run__status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  color: var(--lp-text-muted);
}

.lp-project-run--active .lp-project-run__status {
  color: var(--lp-terracotta);
}

.lp-project-run--ready .lp-project-run__status {
  color: var(--lp-success);
}

.lp-project-run--failed .lp-project-run__status {
  color: var(--lp-error);
}

.lp-project-run__spinner {
  animation: lpProjectRunSpin 1.4s linear infinite;
}

.lp-project-run__copy {
  min-width: 0;
}

.lp-project-run__eyebrow {
  color: var(--lp-text-muted);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  white-space: nowrap;
}

.lp-project-run__title {
  display: block;
  overflow: hidden;
  color: var(--lp-text);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
  animation: lpProjectTitleReveal var(--lp-dur-press) var(--lp-ease) both;
}

.lp-project-run__open {
  color: var(--lp-text-muted);
  transition: color var(--lp-dur-press) var(--lp-ease);
}

.lp-project-run:hover .lp-project-run__open {
  color: var(--lp-text);
}

.lp-project-run--skeleton {
  cursor: default;
  animation: none;
}

.lp-project-run__skeleton-icon,
.lp-project-run__skeleton-copy span,
.lp-project-run__skeleton-status {
  display: block;
  border-radius: 8px;
  background: var(--lp-surface-subdued);
  animation: lpProjectRunSkeleton 1.6s var(--lp-ease) infinite alternate;
}

.lp-project-run__skeleton-icon {
  width: 16px;
  height: 16px;
  border-radius: 999px;
}

.lp-project-run__skeleton-copy {
  min-width: 0;
}

.lp-project-run__skeleton-copy span:first-child {
  width: min(240px, 62%);
  height: 12px;
}

.lp-project-run__skeleton-status {
  width: 48px;
  height: 8px;
}

@keyframes lpProjectRunEnter {
  from { opacity: 0; transform: translateY(-8px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes lpProjectTitleReveal {
  from { opacity: 0; transform: translateY(2px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes lpProjectRunSpin {
  to { transform: rotate(360deg); }
}

@keyframes lpProjectRunSkeleton {
  from { opacity: 0.45; }
  to { opacity: 0.9; }
}

/* ═══════════════════════════════════════════════════════════════
   Footer
   ═══════════════════════════════════════════════════════════════ */

.lp-footer {
  border-top: 1px solid var(--lp-border);
  padding: var(--lp-space-64) 0 var(--lp-space-32);
}

.lp-footer__top {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--lp-space-32);
}

@media (min-width: 640px) {
  .lp-footer__top {
    grid-template-columns: 1.4fr repeat(3, 1fr);
    gap: var(--lp-space-24);
  }
}

.lp-footer__brand img {
  height: 28px;
  width: auto;
  display: block;
}

.lp-footer__tagline {
  margin: var(--lp-space-16) 0 0;
  font-size: 14px;
  line-height: 1.6;
  color: var(--lp-text-muted);
  max-width: 32ch;
}

.lp-footer__group-title {
  margin: 0 0 var(--lp-space-16);
  font-size: 14px;
  font-weight: 600;
  color: var(--lp-text);
}

.lp-footer__links {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--lp-space-12);
}

.lp-footer__link {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  border: none;
  background: none;
  padding: 0;
  font-family: inherit;
  font-size: 14px;
  color: var(--lp-text-muted);
  text-decoration: none;
  cursor: pointer;
  transition: color var(--lp-dur-press) var(--lp-ease);
}

.lp-footer__link:hover {
  color: var(--lp-text);
}

.lp-footer__bottom {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--lp-space-16);
  margin-top: var(--lp-space-48);
  padding-top: var(--lp-space-24);
  border-top: 1px solid var(--lp-border);
}

.lp-footer__copyright {
  margin: 0;
  font-size: 13px;
  color: var(--lp-text-muted);
}

.lp-footer__theme {
  display: flex;
  align-items: center;
  gap: var(--lp-space-8);
  font-size: 13px;
  color: var(--lp-text-muted);
}

/* ═══════════════════════════════════════════════════════════════
   Reduced motion
   ═══════════════════════════════════════════════════════════════ */

@media (prefers-reduced-motion: reduce) {
  .lp-reveal {
    opacity: 1;
    transform: none;
    filter: none;
    transition: none;
  }

  .lp-tagline__word {
    opacity: 1;
    transition: none;
  }

  .lp-force__branch-path {
    stroke-dashoffset: 0;
    transition: none;
  }

  .lp-force__group {
    opacity: 1;
    transform: none;
    transition: none;
  }

  .lp-menu-overlay,
  .lp-menu-overlay__link {
    transition: none;
  }

  .lp-page *,
  .lp-page *::before,
  .lp-page *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }

  .lp-page {
    scroll-behavior: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/landing/landing.css"],"names":[],"mappings":"AAAA;;;;;oEAKoE;;AAEpE;EACE,uCAAuC;EACvC,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,SAAS;EACT,mFAAmF;EACnF,gEAAgE;;EAEhE,WAAW;EACX,yCAAyC;EACzC,sBAAsB;EACtB,qBAAqB;;EAErB,WAAW;EACX,wBAAwB;EACxB,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,oCAAoC;;EAEpC,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;EAC7B,wCAAwC;EACxC,wBAAwB;EACxB,qCAAqC;;EAErC,6BAA6B;EAC7B,qBAAqB;EACrB,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE;IACE,+BAA+B;IAC/B,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,+BAA+B;IAC/B,oCAAoC;EACtC;AACF;;AAEA;EACE;;IAEE,qBAAqB;IACrB,qBAAqB;IACrB,6BAA6B;IAC7B,8BAA8B;IAC9B,4BAA4B;IAC5B,kBAAkB;IAClB,wBAAwB;IACxB,oBAAoB;IACpB,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;IACnB,+BAA+B;IAC/B,6BAA6B;IAC7B,yCAAyC;IACzC,wBAAwB;IACxB,kCAAkC;EACpC;AACF;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;EAC7B,yCAAyC;EACzC,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA,4EAA4E;AAC5E;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,gCAAgC;EAChC,yDAAgW;EAChW,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,sBAAsB;;AAEtB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,0BAA0B;EAC1B,wBAAwB;EACxB,6CAA6C;EAC7C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,wDAAwD;AAC1D;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,cAAc;EACd,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc,eAAe,EAAE;AACjC;;AAEA;EACE,cAAc,eAAe,EAAE;AACjC;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW,eAAe,EAAE;AAC9B;;AAEA;EACE,WAAW,eAAe,EAAE;AAC9B;;AAEA,oDAAoD;AACpD;EACE,UAAU;EACV,2BAA2B;EAC3B,kBAAkB;EAClB;;;+BAG6B;AAC/B;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;;oEAEoE;;AAEpE;0EAC0E;AAC1E;EACE,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,sEAAsE;EACtE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;EACpB,uBAAuB;EACvB;;;gCAG8B;AAChC;;AAEA;EACE,YAAY;EACZ,iDAAiD;EACjD,8BAA8B;EAC9B,6BAA6B;EAE7B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mEAAmE;AACrE;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,cAAc;EACd,WAAW;EACX,2BAA2B;EAC3B,qEAAqE;AACvE;;AAEA,8BAA8B,YAAY,EAAE;;AAE5C;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA,4CAA4C,UAAU,EAAE;;AAExD;EACE;;sBAEoB,gBAAgB,EAAE;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;EAC7C,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;EACrB;uDACqD;AACvD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;EAC7C,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,6CAA6C;EAC7C,gCAAgC;EAChC,oBAAoB;EACpB,0BAA0B;EAC1B,wBAAwB;EACxB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf;8CAC4C;AAC9C;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,oBAAoB;EACpB,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf;;gDAE8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB;gDAC8C;AAChD;;AAEA;EACE,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,mCAAmC;AACrC;;AAEA;EACE,iBAAiB,aAAa,EAAE;EAChC,kBAAkB,oBAAoB,EAAE;EACxC,eAAe,oBAAoB,EAAE;EACrC,oBAAoB,aAAa,EAAE;AACrC;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iDAAiD;EACjD,2BAA2B;EAE3B,2BAA2B;EAC3B,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB;6CAC2C;AAC7C;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,UAAU;EACV,2BAA2B;EAC3B;iDAC+C;AACjD;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;oEAEoE;;AAEpE;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4CAA4C;EAC5C,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA,qEAAqE;AACrE;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,oBAAoB;EACpB,UAAU;EACV,8BAA8B;EAC9B,uDAAuD;EAEvD,iEAAiE;AACnE;;AAEA,yBAAyB,UAAU,EAAE;;AAErC;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB,gBAAgB,EAAE;AACtC;;AAEA;EACE,WAAW,4CAA4C,EAAE;AAC3D;;AAEA;EACE,WAAW,4CAA4C,EAAE;AAC3D;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,0EAA0E;EAC1E,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,0FAA0F;EAC1F,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB,eAAe,EAAE;AACxC;;AAEA;EACE,qBAAqB,eAAe,EAAE;AACxC;;AAEA;oCACoC;AACpC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB;oDACkD;EAClD,0FAA0F;EAC1F,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;yDACyD;AACzD;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,uEAAuE;EACvE,qBAAqB;EACrB,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B,gBAAgB,EAAE;AAC/C;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,wBAAwB,eAAe,EAAE;AAC3C;;AAEA;EACE,wBAAwB,eAAe,EAAE;AAC3C;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;;oEAEoE;;AAEpE;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,iEAAiE;EACjE;iDAC+C;AACjD;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB,iBAAiB,EAAE;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,4CAA4C;EAC5C,kCAAkC;EAClC,mBAAmB;EACnB,qCAAqC;EACrC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,6BAA6B;EAC7B,kCAAkC;EAClC,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd;4CAC0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB;;;;;GAKC;EACD,0BAA0B;EAC1B,kDAAkD;AACpD;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,2BAA2B,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;;gDAE8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yCAAyC;EACzC,oBAAoB;EACpB,qCAAqC;EACrC,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA,wCAAwC,iCAAiC,EAAE,mBAAmB,EAAE;AAChG,mCAAmC,WAAW,EAAE,eAAe,EAAE;;AAEjE;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,wCAAwC;EACxC,0BAA0B;EAC1B,wDAAwD;AAC1D;;AAEA,+CAA+C,2BAA2B,EAAE;;AAE5E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,mBAAmB;EACnB,0BAA0B;EAC1B,wBAAwB;EACxB,eAAe;EACf;gDAC8C;AAChD;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB;;;;;GAKC;EACD,0BAA0B;EAC1B,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,mDAAmD;AACrD;;AAEA,mCAAmC,sBAAsB,EAAE;AAC3D,mCAAmC,sBAAsB,EAAE;;AAE3D;EACE,gBAAgB,WAAW,EAAE,wBAAwB,EAAE;EACvD,MAAM,UAAU,EAAE,2BAA2B,EAAE;AACjD;;AAEA;EACE,sBAAsB,eAAe,EAAE,WAAW,EAAE;AACtD;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kEAAkE;EAClE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,kCAAkC;AAClC;EACE,qBAAqB;EACrB,oCAAoC;EACpC,4EAA4E;AAC9E;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;EACrD,wDAAwD;EACxD,4DAA4D;EAC5D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;;EAExD,YAAY;EACZ,2EAA2E;EAC3E,gBAAgB;EAChB,wBAAwB;EACxB,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;EACxC,kEAAkE;EAClE,YAAY;EACZ,qEAAqE;EACrE,wDAAwD;AAC1D;;AAEA;EACE,OAAO,UAAU,EAAE,sCAAsC,EAAE;AAC7D;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,aAAa;EACb,yBAAiB;UAAjB,iBAAiB;EACjB;;8CAE4C;AAC9C;;AAEA;;EAEE,uCAAuC;EACvC,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,uCAAuC;EACvC,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,uBAAuB;AACzB;;AAEA,yBAAyB;AACzB;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,yFAAyF;EACzF,gBAAgB;EAChB,yCAAyC;EACzC,gDAAgD;EAChD,oDAAoD;EACpD,kBAAkB;EAClB,wCAAwC;EACxC,oBAAoB;EACpB,+DAA+D;EAC/D,+BAA+B;EAC/B,iEAAiE;AACnE;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;AAClD;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;AACjD;;AAEA,oCAAoC,kCAAkC,EAAE;;AAExE;;;EAGE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;;EAGE,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,SAAS;EACT,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,+CAA+C;EAC/C,mBAAmB;EACnB,QAAQ;EACR,2CAA2C;EAC3C,uBAAuB;EACvB,oDAAoD;EACpD,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB;;8CAE4C;AAC9C;;AAEA;;EAEE,yCAAyC;EACzC,gDAAgD;AAClD;;AAEA,yCAAyC,sBAAsB,EAAE;AACjE,kCAAkC,gCAAgC,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACvG,+BAA+B,aAAa,EAAE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,oDAAoD,EAAE,kBAAkB,EAAE;;AAExK;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;4CAC4C,eAAe,EAAE,gBAAgB,EAAE;;AAE/E;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;EACV,oDAAoD;EACpD,oBAAoB;EACpB,4CAA4C;EAC5C,eAAe;EACf;iDAC+C;AACjD;;AAEA,iDAAiD,gDAAgD,EAAE,8CAA8C,EAAE;AACnJ,iCAAiC,cAAc,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,gDAAgD,EAAE,sCAAsC,EAAE,0BAA0B,EAAE,sDAAsD,EAAE;AAC9Q,gFAAgF,2BAA2B,EAAE;;AAE7G,6BAA6B,gBAAgB,EAAE;AAC/C;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,2CAA2C,gDAAgD,EAAE;AAC7F,8CAA8C,mBAAmB,EAAE,WAAW,EAAE;AAChF,2CAA2C,UAAU,EAAE,sDAAsD,EAAE;AAC/G,gCAAgC,SAAS,EAAE,UAAU,EAAE,SAAS,EAAE;AAClE,kCAAkC,aAAa,EAAE;AACjD;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,2CAA2C;EAC3C,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;AACA,+BAA+B,yCAAyC,EAAE,gDAAgD,EAAE;AAC5H,+BAA+B,wBAAwB,EAAE;;AAEzD;;;;EAIE,qDAAqD;EACrD,mBAAmB;AACrB;;AAEA,4DAA4D;AAC5D;EACE,OAAO;EACP,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,uBAAuB;EACvB,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB;;kDAEgD;AAClD;;AAEA;8CAC8C,qBAAqB,EAAE,qCAAqC,EAAE;AAC5G,kCAAkC,sBAAsB,EAAE;AAC1D,+DAA+D,yBAAyB,EAAE;AAC1F,4CAA4C,0DAA0D,EAAE;;AAExG;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,yCAAyC;EACzC,gDAAgD;EAChD,oDAAoD;EACpD,kBAAkB;EAClB,wCAAwC;EACxC,oBAAoB;EACpB,iEAAiE;AACnE;;AAEA,yCAAyC,kCAAkC,EAAE;;AAE7E;uCACuC,aAAa,EAAE;AACtD,yCAAyC,YAAY,EAAE,2CAA2C,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACvI,wBAAwB,YAAY,EAAE,6BAA6B,EAAE,kBAAkB,EAAE,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC7I;0CAC0C,gDAAgD,EAAE,gDAAgD,EAAE;;AAE9I;EACE,mCAAmC,aAAa,EAAE;EAClD,4BAA4B,WAAW,EAAE,UAAU,EAAE;EACrD,mBAAmB,yBAAyB,EAAE;EAC9C,2BAA2B,0BAA0B,EAAE;AACzD;;AAEA;EACE;;;0BAGwB,0BAA0B,EAAE,yBAAyB,EAAE;AACjF;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,eAAe;IACf,uBAAuB;IACvB,iBAAiB;EACnB;AACF;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;EAC7C,kCAAkC;EAClC,oBAAoB;EACpB,6BAA6B;EAC7B,2BAA2B;EAC3B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf;;gDAE8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,2BAA2B;EAC3B,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,6CAA6C;EAC7C,kCAAkC;EAClC,oBAAoB;EACpB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,+DAA+D;AACjE;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;oEAEoE;;AAEpE;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb;;4EAE0E;EAC1E,uBAAuB;EACvB,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,oBAAoB;EACpB;8EAC4E;EAC5E,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B;iDAC+C;AACjD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa,oDAAoD,EAAE;AACrE;;AAEA;EACE,aAAa,yDAAyD,EAAE;AAC1E;;AAEA;;;;;;;+DAO+D;AAC/D;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA,yEAAyE;AACzE;;EAEE,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;oEAEoE;;AAEpE;EACE,aAAa;EACb,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA,kBAAkB,mBAAmB,EAAE;EACvC,iBAAiB,mBAAmB,EAAE;AACxC;;AAEA;EACE;IACE,sCAAsC;IACtC,uBAAuB;EACzB;EACA,kBAAkB,mBAAmB,EAAE;EACvC,iBAAiB,mBAAmB,EAAE;AACxC;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,wBAAwB,eAAe,EAAE;AAC3C;;AAEA,mEAAmE;;AAEnE;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,mDAAmD;AACrD;;AAEA;EACE;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;AACF;;AAEA,mDAAmD;;AAEnD;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,iFAAiF;EACjF,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,2DAA2D;AAC7D;;AAEA;;EAEE,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,gCAAgC;EAChC,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B;;;gDAG8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,0DAA0D;;AAE1D;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,yDAAyD;EACzD,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,sCAAsC;EACtC,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gCAAgC;EAChC,eAAe;EACf,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA,mEAAmE;;AAEnE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,2BAA2B;EAC3B,wBAAwB;EACxB,gCAAgC;EAChC,eAAe;EACf,sBAAsB;EACtB,qDAAqD;AACvD;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,0CAA0C;EAC1C,0BAA0B;EAC1B,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gCAAgC;EAChC,cAAc;EACd,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,UAAU;EACV,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,sBAAsB;EACtB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA,4BAA4B,YAAY,EAAE;AAC1C,2BAA2B,YAAY,EAAE;;AAEzC,uEAAuE;;AAEvE;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,6BAA6B;EAC7B;;kCAEgC;AAClC;;AAEA;;EAEE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;EACd,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP;;;;GAIC;AACH;;AAEA,wBAAwB,gCAAgC,EAAE;AAC1D,wBAAwB,2BAA2B,EAAE;AACrD,wBAAwB,2BAA2B,EAAE;;AAErD;EACE;;;;GAIC;AACH;;AAEA,gBAAgB;;AAEhB;EACE,aAAa;EACb,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,kBAAkB;EAClB,6BAA6B;EAC7B,UAAU;EACV,wCAAwC;AAC1C;;AAEA,+BAA+B,aAAa,EAAE;AAC9C,0BAA0B,UAAU,EAAE;;AAEtC;EACE,aAAa;EACb,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,kBAAkB;;AAElB;EACE,SAAO;EACP,kBAAkB;EAClB,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,6BAA6B;EAC7B,YAAY;EACZ,0BAA0B;EAC1B,2DAA2D;AAC7D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,UAAU;EACV,WAAW;EACX,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,MAAM,UAAU,EAAE;AACpB;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,sBAAsB,EAAE;EAC/B,KAAK,oBAAoB,EAAE;AAC7B;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,OAAO,6BAA6B,EAAE;EACtC,KAAK,sBAAsB,EAAE;AAC/B;;AAEA;EACE;;;;;;IAME,eAAe;EACjB;;EAEA,sBAAsB,aAAa,EAAE;EACrC,yBAAyB,sBAAsB,EAAE;AACnD;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,iBAAiB,uBAAuB,EAAE;AAC1C,mBAAmB,uBAAuB,EAAE;AAC5C,mBAAmB,+BAA+B,EAAE;AACpD,iBAAiB,0BAA0B,EAAE;AAC7C,iBAAiB,qBAAqB,EAAE;AACxC,iBAAiB,qBAAqB,EAAE;;AAExC;;oEAEoE;;AAEpE;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE;IACE,+BAA+B;IAC/B,kCAAkC;EACpC;AACF;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB,eAAe,EAAE;AACvC;;AAEA;EACE,oBAAoB,eAAe,EAAE;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,UAAU;AACZ;;AAEA;;oEAEoE;;AAEpE;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB,8BAA8B,EAAE;AACvD;;AAEA,mEAAmE;;AAEnE;EACE,WAAW;EACX,2BAA2B;EAC3B,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW,2BAA2B,EAAE;AAC1C;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mCAAmC;EACnC,4EAA4E;EAC5E,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,kBAAkB,cAAc,EAAE;AACpC;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,eAAe;EACf,qBAAqB;EACrB,iCAAiC;EACjC,mBAAmB;EACnB,oBAAoB;EACpB;6DAC2D;EAC3D,iBAAiB;EACjB;;;+BAG6B;AAC/B;;AAEA;;EAEE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,UAAU;IACV,0BAA0B;IAC1B,4BAA4B;IAC5B,+BAA+B;IAC/B,oBAAoB;IACpB,0CAA0C;EAC5C;;EAEA,mDAAmD;EACnD;;;IAGE,oBAAoB;EACtB;;EAEA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,sBAAsB;IACtB,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,gCAAgC;EAClC;AACF;;AAEA;EACE,UAAU;EACV,wCAAwC;AAC1C;;AAEA;;;EAGE,UAAU;AACZ;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;EACtB,kDAAkD;EAClD,qBAAqB;EACrB;;;;8BAI4B;AAC9B;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,8DAA8D;AAC9D;EACE,UAAU;AACZ;;AAEA,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,iBAAiB,cAAc,EAAE;AACnC;;AAEA,qBAAqB,UAAU,EAAE;AACjC,sBAAsB,WAAW,EAAE;;AAEnC;EACE,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;AACf;;AAEA,uEAAuE;AACvE;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;EACxB,UAAU;EACV,qBAAqB;EACrB,wEAAwE;AAC1E;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,mEAAmE;;AAEnE;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,QAAQ;EACR,UAAU;EACV,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,qDAAqD;AACvD;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,gDAAgD;AAClD;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA,sCAAsC;AACtC;EACE,UAAU;EACV,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;EAChC,+BAA+B;EAC/B,sDAAsD;AACxD;;AAEA,sCAAsC;AACtC;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;EAChC,6BAA6B;EAC7B,uDAAuD;AACzD;;AAEA,uCAAuC;AACvC;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,+BAA+B;EAC/B,sDAAsD;AACxD;;AAEA,oDAAoD;AACpD;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;AACd;;AAEA,+BAA+B,WAAW,EAAE;AAC5C,gCAAgC,UAAU,EAAE;;AAE5C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;EACxB,wDAAwD;AAC1D;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA,sCAAsC;AACtC;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,wCAAwC;EACxC,wDAAwD;AAC1D;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,KAAK,wBAAwB,EAAE;AACjC;;AAEA;EACE,WAAW,sBAAsB,EAAE,YAAY,EAAE;EACjD,MAAM,mBAAmB,EAAE,UAAU,EAAE;AACzC;;AAEA;EACE,KAAK,2BAA2B,EAAE;AACpC;;AAEA;EACE,WAAW,sBAAsB,EAAE;EACnC,MAAM,oBAAoB,EAAE;AAC9B;;AAEA;EACE,OAAO,oBAAoB,EAAE;EAC7B,YAAY,oBAAoB,EAAE;AACpC;;AAEA;EACE,OAAO,oBAAoB,EAAE;EAC7B,YAAY,oBAAoB,EAAE;AACpC;;AAEA;EACE,UAAU,mBAAmB,EAAE;EAC/B,MAAM,qBAAqB,EAAE;EAC7B,YAAY,mBAAmB,EAAE;AACnC;;AAEA;EACE,OAAO,mBAAmB,EAAE,YAAY,EAAE;EAC1C,KAAK,qBAAqB,EAAE,UAAU,EAAE;AAC1C;;AAEA;EACE;;;;;;;;;IASE,eAAe;IACf,gBAAgB;EAClB;;EAEA,kBAAkB,aAAa,EAAE;AACnC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;EACb,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE;IACE,qCAAqC;IACrC,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,YAAY,2BAA2B,EAAE;AAC3C;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB,eAAe,EAAE;AACtC;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;;oEAEoE;;AAEpE;EACE,aAAa;EACb,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,sCAAsC;IACtC,uBAAuB;EACzB;EACA,kBAAkB,mBAAmB,EAAE;EACvC,oBAAoB,mBAAmB,EAAE;AAC3C;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,oBAAoB;EACpB,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,iEAAiE;AACjE;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,sBAAsB;EACtB,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mDAAmD;AACrD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,UAAU;EACV,UAAU;EACV,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;EAC3B,UAAU;EACV,2BAA2B;EAC3B,wEAAwE;AAC1E;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,iDAAiD,uBAAuB,EAAE;AAC1E,iDAAiD,uBAAuB,EAAE;;AAE1E;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,kCAAkC;EAClC,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;qEACqE;AACrE;EACE;IACE,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,8BAA8B;IAC9B,uBAAuB;EACzB;AACF;;AAEA;;oEAEoE;;AAEpE;EACE,aAAa;EACb,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE;IACE,sCAAsC;IACtC,uBAAuB;EACzB;EACA,wBAAwB,mBAAmB,EAAE;EAC7C,wBAAwB,mBAAmB,EAAE;AAC/C;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;EAC9C,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;EAC7C,kCAAkC;EAClC,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB,2BAA2B,EAAE;AAChD;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;EAC7C,kCAAkC;EAClC,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;;oEAEoE;;AAEpE;EACE,aAAa;EACb,0BAA0B;EAC1B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE;IACE,qCAAqC;IACrC,uBAAuB;EACzB;AACF;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,6CAA6C;EAC7C,kCAAkC;EAClC,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;EAC5C,oBAAoB;EACpB,qCAAqC;EACrC,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;oEAEoE;;AAEpE;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;EACb,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE;IACE,qCAAqC;IACrC,uBAAuB;EACzB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB,eAAe,EAAE;AACvC;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,oBAAoB,eAAe,EAAE;AACvC;;AAEA;;oEAEoE;;AAEpE;EACE,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;EACX,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,+DAA+D;AACjE;;AAEA;EACE,mBAAmB,2BAA2B,EAAE;AAClD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,wDAAwD;AAC1D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;EAChD,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB,gDAAgD,EAAE;AACtE;;AAEA;EACE,SAAS;AACX;;AAEA;;oEAEoE;;AAEpE;EACE,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;oEAEoE;;AAEpE;EACE,kCAAkC;EAClC,4CAA4C;EAC5C,iDAAiD;EACjD,8CAA8C;EAC9C,gDAAgD;EAChD,oCAAoC;EACpC,4CAA4C;EAC5C,sCAAsC;EACtC,yCAAyC;EACzC,qCAAqC;EACrC,oCAAoC;EACpC,uCAAuC;EACvC,0CAA0C;EAC1C,iDAAiD;EACjD,iDAAiD;EACjD,wCAAwC;EACxC,qBAAqB;EACrB,mCAAmC;EACnC,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB;;;wBAGsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA,2CAA2C;;AAE3C;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,4CAA4C;EAC5C,uBAAuB;EACvB,2BAA2B;EAC3B,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;;gDAE8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,4CAA4C;EAC5C,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,sDAAsD;EACtD;uDACqD;AACvD;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,uEAAuE;AACzE;;AAEA;EACE,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;;;EAGE,cAAc;EACd,kBAAkB;EAClB,qCAAqC;EACrC,sEAAsE;AACxE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,OAAO,aAAa,EAAE;EACtB,KAAK,YAAY,EAAE;AACrB;;AAEA;;oEAEoE;;AAEpE;EACE,sCAAsC;EACtC,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE;IACE,2CAA2C;IAC3C,uBAAuB;EACzB;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;oEAEoE;;AAEpE;EACE;IACE,UAAU;IACV,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;;EAEA;IACE,qBAAqB;EACvB;AACF","sourcesContent":["/* ═══════════════════════════════════════════════════════════════\n   Latted landing — modern editorial infrastructure\n   Design tokens, type scale, motion, and section styles.\n   Breakpoints: mobile 0–639, tablet 640–1023, desktop 1024+.\n   Mobile-first. Spacing only from the approved token set.\n   ═══════════════════════════════════════════════════════════════ */\n\n.lp-page {\n  /* Spacing tokens (approved set only) */\n  --lp-space-2: 2px;\n  --lp-space-4: 4px;\n  --lp-space-8: 8px;\n  --lp-space-12: 12px;\n  --lp-space-16: 16px;\n  --lp-space-24: 24px;\n  --lp-space-32: 32px;\n  --lp-space-40: 40px;\n  --lp-space-48: 48px;\n  --lp-space-64: 64px;\n  --lp-space-80: 80px;\n  --lp-space-96: 96px;\n\n  /* Type */\n  --lp-font-sans: 'Geist Sans', 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  --lp-font-mono: 'Geist Mono', 'SF Mono', ui-monospace, monospace;\n\n  /* Motion */\n  --lp-ease: cubic-bezier(0.32, 0.72, 0, 1);\n  --lp-dur-travel: 700ms;\n  --lp-dur-press: 200ms;\n\n  /* Layout */\n  --lp-content-max: 1200px;\n  --lp-composer-max: 840px;\n  --lp-text-max: 680px;\n  --lp-gutter: var(--lp-space-16);\n  --lp-section-pad: var(--lp-space-64);\n\n  /* Light theme tokens */\n  --lp-page-bg: #F6F0E5;\n  --lp-surface: #FFFDF8;\n  --lp-surface-subdued: #EDE3D4;\n  --lp-surface-elevated: #FFFDF8;\n  --lp-surface-active: #EDE3D4;\n  --lp-text: #17120E;\n  --lp-text-muted: #6F655A;\n  --lp-border: #D8CBB9;\n  --lp-terracotta: #A6533B;\n  --lp-rust: #8B432F;\n  --lp-olive: #626A45;\n  --lp-success: #16A34A;\n  --lp-sepia: #59483B;\n  --lp-error: #8B432F;\n  --lp-hero-heading-from: #000000;\n  --lp-hero-heading-to: #666666;\n  --lp-focus-ring: rgba(166, 83, 59, 0.28);\n  --lp-grain-opacity: 0.05;\n  --lp-glass: rgba(255, 253, 248, 0.78);\n\n  background: var(--lp-page-bg);\n  color: var(--lp-text);\n  font-family: var(--lp-font-sans);\n  position: relative;\n  min-height: 100vh;\n  overflow-x: clip;\n  -webkit-font-smoothing: antialiased;\n}\n\n@media (min-width: 640px) {\n  .lp-page {\n    --lp-gutter: var(--lp-space-24);\n    --lp-section-pad: var(--lp-space-80);\n  }\n}\n\n@media (min-width: 1024px) {\n  .lp-page {\n    --lp-gutter: var(--lp-space-32);\n    --lp-section-pad: var(--lp-space-96);\n  }\n}\n\n@media (prefers-color-scheme: dark) {\n  :root:not([data-theme]) .lp-page,\n  :root[data-theme='dark'] .lp-page {\n    --lp-page-bg: #131209;\n    --lp-surface: #181818;\n    --lp-surface-subdued: #1F1F1F;\n    --lp-surface-elevated: #1F1F1F;\n    --lp-surface-active: #272727;\n    --lp-text: #FFFFFF;\n    --lp-text-muted: #9B9B9B;\n    --lp-border: #313131;\n    --lp-terracotta: #C77B61;\n    --lp-rust: #C77B61;\n    --lp-olive: #9DA47B;\n    --lp-success: #4ADE80;\n    --lp-sepia: #B49A86;\n    --lp-error: #C77B61;\n    --lp-hero-heading-from: #FFFFFF;\n    --lp-hero-heading-to: #9B9B9B;\n    --lp-focus-ring: rgba(199, 123, 97, 0.32);\n    --lp-grain-opacity: 0.04;\n    --lp-glass: rgba(24, 24, 24, 0.78);\n  }\n}\n\n:root[data-theme='dark'] .lp-page {\n  --lp-page-bg: #131209;\n  --lp-surface: #181818;\n  --lp-surface-subdued: #1F1F1F;\n  --lp-surface-elevated: #1F1F1F;\n  --lp-surface-active: #272727;\n  --lp-text: #FFFFFF;\n  --lp-text-muted: #9B9B9B;\n  --lp-border: #313131;\n  --lp-terracotta: #C77B61;\n  --lp-rust: #C77B61;\n  --lp-olive: #9DA47B;\n  --lp-success: #4ADE80;\n  --lp-sepia: #B49A86;\n  --lp-error: #C77B61;\n  --lp-hero-heading-from: #FFFFFF;\n  --lp-hero-heading-to: #9B9B9B;\n  --lp-focus-ring: rgba(199, 123, 97, 0.32);\n  --lp-grain-opacity: 0.04;\n  --lp-glass: rgba(24, 24, 24, 0.78);\n}\n\n/* Paper grain overlay — illustration layer only, never over text contrast */\n.lp-page::before {\n  content: '';\n  position: fixed;\n  inset: 0;\n  z-index: 1;\n  pointer-events: none;\n  opacity: var(--lp-grain-opacity);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='180' height='180'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='2' stitchTiles='stitch'/%3E%3CfeColorMatrix type='saturate' values='0'/%3E%3C/filter%3E%3Crect width='180' height='180' filter='url(%23n)'/%3E%3C/svg%3E\");\n  background-size: 180px 180px;\n}\n\n.lp-page > * {\n  position: relative;\n  z-index: 2;\n}\n\n/* ─── Utilities ─── */\n\n.lp-visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.lp-skip-link {\n  position: fixed;\n  top: var(--lp-space-8);\n  left: var(--lp-space-8);\n  z-index: 300;\n  transform: translateY(-64px);\n  background: var(--lp-text);\n  color: var(--lp-page-bg);\n  padding: var(--lp-space-8) var(--lp-space-12);\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  text-decoration: none;\n  transition: transform var(--lp-dur-press) var(--lp-ease);\n}\n\n.lp-skip-link:focus-visible {\n  transform: translateY(0);\n  outline: 2px solid var(--lp-terracotta);\n  outline-offset: 2px;\n}\n\n/* The skip target is focusable programmatically but shows no outline itself. */\n.lp-page main:focus {\n  outline: none;\n}\n\n.lp-container {\n  width: 100%;\n  max-width: var(--lp-content-max);\n  margin: 0 auto;\n  padding-left: var(--lp-gutter);\n  padding-right: var(--lp-gutter);\n}\n\n.lp-section {\n  padding-top: var(--lp-section-pad);\n  padding-bottom: var(--lp-section-pad);\n  scroll-margin-top: 96px;\n}\n\n.lp-label {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  color: var(--lp-terracotta);\n  margin: 0 0 var(--lp-space-16);\n}\n\n.lp-heading {\n  margin: 0;\n  font-weight: 500;\n  letter-spacing: -0.02em;\n  line-height: 1.08;\n  font-size: 30px;\n  text-wrap: balance;\n  color: var(--lp-text);\n}\n\n@media (min-width: 640px) {\n  .lp-heading { font-size: 36px; }\n}\n\n@media (min-width: 1024px) {\n  .lp-heading { font-size: 48px; }\n}\n\n.lp-body {\n  margin: var(--lp-space-24) 0 0;\n  font-size: 16px;\n  line-height: 1.65;\n  color: var(--lp-text-muted);\n  text-wrap: pretty;\n  max-width: var(--lp-text-max);\n}\n\n@media (min-width: 640px) {\n  .lp-body { font-size: 16px; }\n}\n\n@media (min-width: 1024px) {\n  .lp-body { font-size: 18px; }\n}\n\n/* Section entrance reveal — one group per section */\n.lp-reveal {\n  opacity: 0;\n  transform: translateY(64px);\n  filter: blur(12px);\n  transition:\n    opacity 800ms var(--lp-ease),\n    transform 800ms var(--lp-ease),\n    filter 800ms var(--lp-ease);\n}\n\n.lp-reveal--visible {\n  opacity: 1;\n  transform: translateY(0);\n  filter: blur(0);\n}\n\n/* Shared focus treatment */\n.lp-focusable:focus-visible {\n  outline: 2px solid var(--lp-terracotta);\n  outline-offset: 2px;\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Navigation\n   ═══════════════════════════════════════════════════════════════ */\n\n/* At the top of the page the bar is chrome-free: no card, no blur, and the\n   full wordmark. Crossing the hero sentinel collapses it into the card. */\n.lp-nav {\n  position: fixed;\n  top: var(--lp-space-24);\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 120;\n  width: min(var(--lp-content-max), calc(100% - (2 * var(--lp-gutter))));\n  height: 64px;\n  display: flex;\n  align-items: center;\n  gap: var(--lp-space-8);\n  padding: 0;\n  border: 1px solid transparent;\n  border-radius: 999px;\n  background: transparent;\n  transition: background-color var(--lp-dur-press) var(--lp-ease),\n    border-color var(--lp-dur-press) var(--lp-ease),\n    height 280ms var(--lp-ease),\n    padding 280ms var(--lp-ease);\n}\n\n.lp-nav--scrolled {\n  height: 48px;\n  padding: 0 var(--lp-space-8) 0 var(--lp-space-16);\n  border-color: var(--lp-border);\n  background: var(--lp-surface);\n  -webkit-backdrop-filter: blur(14px);\n  backdrop-filter: blur(14px);\n}\n\n.lp-nav__logo {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n  width: 92px;\n  height: 46px;\n  border-radius: 8px;\n  transition: width 280ms var(--lp-ease), height 280ms var(--lp-ease);\n}\n\n.lp-nav--scrolled .lp-nav__logo {\n  width: 30px;\n  height: 34px;\n}\n\n/* The wordmark and the icon are stacked so the swap cross-fades in place. */\n.lp-nav__logo-img {\n  position: absolute;\n  left: 0;\n  top: 50%;\n  display: block;\n  width: auto;\n  transform: translateY(-50%);\n  transition: opacity 200ms var(--lp-ease), height 280ms var(--lp-ease);\n}\n\n.lp-nav__logo-img--wordmark { height: 46px; }\n\n.lp-nav__logo-img--icon {\n  height: 24px;\n  opacity: 0;\n}\n\n.lp-nav--scrolled .lp-nav__logo-img--wordmark {\n  height: 34px;\n  opacity: 0;\n}\n\n.lp-nav--scrolled .lp-nav__logo-img--icon { opacity: 1; }\n\n@media (prefers-reduced-motion: reduce) {\n  .lp-nav,\n  .lp-nav__logo,\n  .lp-nav__logo-img { transition: none; }\n}\n\n.lp-nav__links {\n  display: none;\n  align-items: center;\n  gap: var(--lp-space-4);\n  margin: 0 auto;\n}\n\n.lp-nav__link {\n  display: inline-flex;\n  align-items: center;\n  min-height: 36px;\n  padding: var(--lp-space-8) var(--lp-space-12);\n  border-radius: 999px;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--lp-text-muted);\n  text-decoration: none;\n  transition: color var(--lp-dur-press) var(--lp-ease),\n    background-color var(--lp-dur-press) var(--lp-ease);\n}\n\n.lp-nav__link:hover {\n  color: var(--lp-text);\n}\n\n.lp-nav__link--active {\n  color: var(--lp-text);\n}\n\n.lp-nav__actions {\n  display: flex;\n  align-items: center;\n  gap: var(--lp-space-8);\n  margin-left: auto;\n}\n\n.lp-nav__signin {\n  display: none;\n  align-items: center;\n  min-height: 36px;\n  padding: var(--lp-space-8) var(--lp-space-12);\n  border: none;\n  border-radius: 999px;\n  background: transparent;\n  color: var(--lp-text-muted);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: color var(--lp-dur-press) var(--lp-ease);\n}\n\n.lp-nav__signin:hover {\n  color: var(--lp-text);\n}\n\n.lp-btn-primary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--lp-space-8);\n  min-height: 36px;\n  padding: var(--lp-space-8) var(--lp-space-12);\n  border: 1px solid var(--lp-text);\n  border-radius: 999px;\n  background: var(--lp-text);\n  color: var(--lp-page-bg);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n  text-decoration: none;\n  cursor: pointer;\n  transition: transform var(--lp-dur-press) var(--lp-ease),\n    opacity var(--lp-dur-press) var(--lp-ease);\n}\n\n.lp-btn-primary:hover {\n  opacity: 0.88;\n  transform: translateY(-1px);\n}\n\n.lp-btn-primary:active {\n  transform: translateY(1px) scale(0.98);\n}\n\n.lp-btn-primary:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.lp-nav__cta {\n  display: none;\n}\n\n.lp-icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: 1px solid var(--lp-border);\n  border-radius: 999px;\n  background: transparent;\n  color: var(--lp-text-muted);\n  cursor: pointer;\n  transition: color var(--lp-dur-press) var(--lp-ease),\n    background-color var(--lp-dur-press) var(--lp-ease),\n    transform var(--lp-dur-press) var(--lp-ease);\n}\n\n.lp-icon-btn:hover {\n  color: var(--lp-text);\n  background: var(--lp-surface-active);\n}\n\n.lp-icon-btn:active {\n  transform: scale(0.98);\n}\n\n.lp-nav__menu-btn {\n  position: relative;\n}\n\n.lp-nav__menu-btn .lp-nav__menu-icon {\n  position: absolute;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  transition: opacity var(--lp-dur-press) var(--lp-ease),\n    transform var(--lp-dur-press) var(--lp-ease);\n}\n\n.lp-nav__menu-btn .lp-nav__menu-icon--close {\n  opacity: 0;\n  transform: rotate(-90deg) scale(0.6);\n}\n\n.lp-nav__menu-btn--open .lp-nav__menu-icon--close {\n  opacity: 1;\n  transform: rotate(0deg) scale(1);\n}\n\n.lp-nav__menu-btn--open .lp-nav__menu-icon--bars {\n  opacity: 0;\n  transform: rotate(90deg) scale(0.6);\n}\n\n@media (min-width: 1024px) {\n  .lp-nav__links { display: flex; }\n  .lp-nav__signin { display: inline-flex; }\n  .lp-nav__cta { display: inline-flex; }\n  .lp-nav__menu-btn { display: none; }\n}\n\n/* Mobile menu overlay */\n.lp-menu-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 110;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 96px var(--lp-gutter) var(--lp-space-48);\n  background: var(--lp-glass);\n  -webkit-backdrop-filter: blur(24px);\n  backdrop-filter: blur(24px);\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: opacity var(--lp-dur-travel) var(--lp-ease),\n    visibility 0s linear var(--lp-dur-travel);\n}\n\n.lp-menu-overlay--open {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: auto;\n  transition-delay: 0s;\n}\n\n.lp-menu-overlay__links {\n  display: flex;\n  flex-direction: column;\n  gap: var(--lp-space-8);\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.lp-menu-overlay__link {\n  display: block;\n  padding: var(--lp-space-12) 0;\n  font-size: 30px;\n  font-weight: 500;\n  letter-spacing: -0.02em;\n  color: var(--lp-text);\n  text-decoration: none;\n  opacity: 0;\n  transform: translateY(24px);\n  transition: opacity var(--lp-dur-travel) var(--lp-ease),\n    transform var(--lp-dur-travel) var(--lp-ease);\n}\n\n.lp-menu-overlay--open .lp-menu-overlay__link {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.lp-menu-overlay__footer {\n  margin-top: var(--lp-space-48);\n  display: flex;\n  flex-direction: column;\n  gap: var(--lp-space-16);\n}\n\n.lp-menu-overlay__signin {\n  align-self: flex-start;\n  border: none;\n  background: none;\n  padding: var(--lp-space-8) 0;\n  font-family: inherit;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--lp-text-muted);\n  cursor: pointer;\n}\n\n.lp-menu-overlay__cta {\n  width: 100%;\n  min-height: 48px;\n  font-size: 16px;\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Hero\n   ═══════════════════════════════════════════════════════════════ */\n\n.lp-hero {\n  position: relative;\n  isolation: isolate;\n  padding-top: calc(72px + var(--lp-space-64));\n  padding-bottom: var(--lp-section-pad);\n  text-align: center;\n}\n\n/* Floating 3D app icons behind the headline. Decorative and inert. */\n.lp-hero__scene {\n  position: absolute;\n  inset: -4% 0 0;\n  z-index: 0;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity 900ms ease;\n  /* Fade the icons out before they reach the composer. */\n  -webkit-mask-image: linear-gradient(to bottom, #000 68%, transparent 94%);\n  mask-image: linear-gradient(to bottom, #000 68%, transparent 94%);\n}\n\n.lp-hero__scene--ready { opacity: 1; }\n\n.lp-hero__scene canvas {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.lp-hero > .lp-container {\n  position: relative;\n  z-index: 1;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .lp-hero__scene { transition: none; }\n}\n\n@media (min-width: 640px) {\n  .lp-hero { padding-top: calc(72px + var(--lp-space-80)); }\n}\n\n@media (min-width: 1024px) {\n  .lp-hero { padding-top: calc(72px + var(--lp-space-96)); }\n}\n\n.lp-hero__headline {\n  margin: 0 auto;\n  max-width: var(--lp-text-max);\n  /* Scales down on narrow phones so the no-wrap accent phrase still fits. */\n  font-size: clamp(28px, 8.4vw, 36px);\n  font-weight: 500;\n  line-height: 1.04;\n  letter-spacing: -0.03em;\n  text-wrap: balance;\n  background: linear-gradient(90deg, var(--lp-hero-heading-from), var(--lp-hero-heading-to));\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n@media (min-width: 640px) {\n  .lp-hero__headline { font-size: 60px; }\n}\n\n@media (min-width: 1024px) {\n  .lp-hero__headline { font-size: 72px; }\n}\n\n/* Accent phrase: never wraps, so the hand-drawn underline always sits under\n   a single unbroken line of text. */\n.lp-hero__accent {\n  position: relative;\n  display: inline-block;\n  white-space: nowrap;\n  /* The positioned span paints outside the h1's background-clip pass, so it\n     carries its own copy of the heading gradient. */\n  background: linear-gradient(90deg, var(--lp-hero-heading-from), var(--lp-hero-heading-to));\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n/* Scales uniformly with the phrase, so the stroke thickens with the type and\n   the dash lengths below stay valid at every viewport. */\n.lp-hero__underline {\n  position: absolute;\n  left: -1.5%;\n  top: 100%;\n  width: 103%;\n  height: auto;\n  margin-top: -0.16em;\n  overflow: visible;\n  pointer-events: none;\n  color: var(--lp-terracotta);\n}\n\n.lp-hero__underline-path {\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 2;\n  stroke-linecap: round;\n  /* The path runs ~300 viewBox units; the dash covers the whole sweep. */\n  stroke-dasharray: 320;\n  stroke-dashoffset: 320;\n  transition: stroke-dashoffset 900ms var(--lp-ease) 420ms;\n}\n\n.lp-hero__accent--drawn .lp-hero__underline-path {\n  stroke-dashoffset: 0;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .lp-hero__underline-path { transition: none; }\n}\n\n.lp-hero__subheadline {\n  margin: var(--lp-space-24) auto 0;\n  max-width: var(--lp-text-max);\n  font-size: 16px;\n  line-height: 1.6;\n  color: var(--lp-text-muted);\n  text-wrap: pretty;\n}\n\n@media (min-width: 640px) {\n  .lp-hero__subheadline { font-size: 18px; }\n}\n\n@media (min-width: 1024px) {\n  .lp-hero__subheadline { font-size: 20px; }\n}\n\n.lp-hero__composer {\n  margin: var(--lp-space-40) auto 0;\n  max-width: var(--lp-composer-max);\n  text-align: left;\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Composer\n   ═══════════════════════════════════════════════════════════════ */\n\n.lp-composer {\n  position: relative;\n  background: var(--lp-surface);\n  border: 1px solid var(--lp-border);\n  border-radius: 16px;\n  padding: var(--lp-space-16) var(--lp-space-16) var(--lp-space-12);\n  transition: border-color var(--lp-dur-press) var(--lp-ease),\n    box-shadow var(--lp-dur-press) var(--lp-ease);\n}\n\n.lp-composer:focus-within {\n  border-color: var(--lp-terracotta);\n  box-shadow: 0 0 0 3px var(--lp-focus-ring);\n}\n\n.lp-composer--drag {\n  border-style: dashed;\n  border-color: var(--lp-terracotta);\n}\n\n.lp-composer__textarea {\n  display: block;\n  width: 100%;\n  min-height: 128px;\n  margin: 0;\n  padding: 0;\n  border: none;\n  outline: none;\n  resize: none;\n  background: transparent;\n  color: var(--lp-text);\n  font-family: inherit;\n  font-size: 16px;\n  line-height: 1.6;\n}\n\n@media (min-width: 1024px) {\n  .lp-composer__textarea { min-height: 144px; }\n}\n\n.lp-composer__textarea::placeholder {\n  color: var(--lp-text-muted);\n  opacity: 0.7;\n}\n\n.lp-composer__textarea:disabled {\n  opacity: 0.6;\n}\n\n.lp-composer__menu-wrap {\n  position: relative;\n}\n\n.lp-composer__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--lp-space-8);\n  margin-top: var(--lp-space-12);\n}\n\n.lp-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--lp-space-8);\n  max-width: 100%;\n  padding: var(--lp-space-4) var(--lp-space-8);\n  border: 1px solid var(--lp-border);\n  border-radius: 12px;\n  background: var(--lp-surface-subdued);\n  color: var(--lp-text);\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.3;\n}\n\n.lp-chip__ext {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 28px;\n  height: 28px;\n  padding: 0 var(--lp-space-4);\n  border-radius: 8px;\n  background: var(--lp-surface);\n  border: 1px solid var(--lp-border);\n  color: var(--lp-text-muted);\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  flex-shrink: 0;\n}\n\n.lp-chip__meta {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.lp-chip__name {\n  max-width: 180px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lp-chip__size {\n  font-size: 11px;\n  font-weight: 400;\n  color: var(--lp-text-muted);\n}\n\n.lp-chip__remove {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border: none;\n  border-radius: 999px;\n  background: transparent;\n  color: var(--lp-text-muted);\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background-color var(--lp-dur-press) var(--lp-ease),\n    color var(--lp-dur-press) var(--lp-ease);\n}\n\n.lp-chip__remove:hover {\n  background: var(--lp-surface-active);\n  color: var(--lp-text);\n}\n\n.lp-chip--skeleton {\n  width: 180px;\n  height: 40px;\n  border-radius: 12px;\n  background: linear-gradient(\n    100deg,\n    var(--lp-surface-subdued) 40%,\n    var(--lp-surface-active) 50%,\n    var(--lp-surface-subdued) 60%\n  );\n  background-size: 200% 100%;\n  animation: lpSkeleton 1.4s var(--lp-ease) infinite;\n}\n\n@keyframes lpSkeleton {\n  from { background-position: 120% 0; }\n  to { background-position: -80% 0; }\n}\n\n.lp-composer__toolbar {\n  display: flex;\n  align-items: center;\n  gap: var(--lp-space-8);\n  margin-top: var(--lp-space-12);\n}\n\n.lp-composer__toolbar-group {\n  display: flex;\n  align-items: center;\n  gap: var(--lp-space-8);\n}\n\n.lp-composer__submit {\n  margin-left: auto;\n}\n\n.lp-tool-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--lp-space-8);\n  min-width: 40px;\n  height: 40px;\n  padding: 0 var(--lp-space-12);\n  border: 1px solid var(--lp-border);\n  border-radius: 12px;\n  background: transparent;\n  color: var(--lp-text-muted);\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: color var(--lp-dur-press) var(--lp-ease),\n    background-color var(--lp-dur-press) var(--lp-ease),\n    transform var(--lp-dur-press) var(--lp-ease);\n}\n\n.lp-tool-btn:hover:not(:disabled) {\n  color: var(--lp-text);\n  background: var(--lp-surface-active);\n}\n\n.lp-tool-btn:active:not(:disabled) {\n  transform: translateY(1px);\n}\n\n.lp-tool-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.lp-tool-btn--icon-only {\n  padding: 0;\n  width: 40px;\n}\n\n.lp-multi-agent {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  color: var(--lp-text-muted);\n  font-size: 12px;\n  font-weight: 560;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.lp-multi-agent__switch {\n  position: relative;\n  width: 30px;\n  height: 17px;\n  padding: 0;\n  border: 1px solid var(--lp-border-strong);\n  border-radius: 999px;\n  background: var(--lp-surface-subdued);\n  cursor: pointer;\n  transition: background var(--lp-dur-press), border-color var(--lp-dur-press);\n}\n\n.lp-multi-agent__switch[data-state='checked'] {\n  border-color: var(--lp-text);\n  background: var(--lp-text);\n}\n\n.lp-multi-agent__switch:focus-visible { outline: 2px solid var(--lp-text); outline-offset: 2px; }\n.lp-multi-agent__switch:disabled { opacity: .5; cursor: default; }\n\n.lp-multi-agent__thumb {\n  display: block;\n  width: 11px;\n  height: 11px;\n  border-radius: 50%;\n  background: var(--lp-surface-elevated);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, .22);\n  transform: translateX(2px);\n  transition: transform var(--lp-dur-press) var(--lp-ease);\n}\n\n.lp-multi-agent__thumb[data-state='checked'] { transform: translateX(15px); }\n\n.lp-submit-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border: 1px solid var(--lp-text);\n  border-radius: 12px;\n  background: var(--lp-text);\n  color: var(--lp-page-bg);\n  cursor: pointer;\n  transition: opacity var(--lp-dur-press) var(--lp-ease),\n    transform var(--lp-dur-press) var(--lp-ease);\n}\n\n.lp-submit-btn:hover:not(:disabled) {\n  opacity: 0.88;\n  transform: translateY(-1px);\n}\n\n.lp-submit-btn:active:not(:disabled) {\n  transform: translateY(1px) scale(0.98);\n}\n\n.lp-submit-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.lp-submit-btn__skeleton {\n  width: 16px;\n  height: 16px;\n  border-radius: 4px;\n  background: linear-gradient(\n    100deg,\n    transparent 20%,\n    currentColor 50%,\n    transparent 80%\n  );\n  background-size: 200% 100%;\n  opacity: 0.9;\n  animation: lpSkeleton 1s var(--lp-ease) infinite;\n}\n\n.lp-composer__submit--planning {\n  width: 112px;\n  padding: 0 14px;\n  opacity: 1 !important;\n  cursor: wait !important;\n}\n\n.lp-planning-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 650;\n  letter-spacing: -0.01em;\n}\n\n.lp-planning-dots {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  height: 10px;\n}\n\n.lp-planning-dots i {\n  width: 3px;\n  height: 3px;\n  border-radius: 50%;\n  background: currentColor;\n  animation: lpPlanningDot 1.05s ease-in-out infinite;\n}\n\n.lp-planning-dots i:nth-child(2) { animation-delay: 0.14s; }\n.lp-planning-dots i:nth-child(3) { animation-delay: 0.28s; }\n\n@keyframes lpPlanningDot {\n  0%, 60%, 100% { opacity: .3; transform: translateY(0); }\n  30% { opacity: 1; transform: translateY(-2px); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .lp-planning-dots i { animation: none; opacity: .7; }\n}\n\n.lp-composer__status {\n  margin: var(--lp-space-8) 0 0;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.lp-composer__status--error {\n  color: var(--lp-error);\n}\n\n.lp-composer__status--hint {\n  color: var(--lp-text-muted);\n}\n\n.lp-composer__drop-hint {\n  position: absolute;\n  inset: 0;\n  z-index: 5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 16px;\n  background: color-mix(in srgb, var(--lp-surface) 88%, transparent);\n  color: var(--lp-terracotta);\n  font-size: 16px;\n  font-weight: 600;\n  pointer-events: none;\n}\n\n/* Aspect ratio dropdown (Radix) */\n.lp-ar-trigger[data-state='open'] {\n  color: var(--lp-text);\n  background: var(--lp-surface-active);\n  border-color: color-mix(in srgb, var(--lp-text-muted) 45%, var(--lp-border));\n}\n\n.lp-ar-trigger[data-state='open'] > svg:last-child {\n  transform: rotate(180deg);\n}\n\n.lp-ar-trigger > svg:last-child {\n  transition: transform 120ms var(--lp-ease);\n}\n\n.lp-ar-content {\n  --lp-ar-surface: var(--color-bg-canvas-surface, #fff);\n  --lp-ar-surface-raised: var(--color-bg-sidebar, #f7f7f7);\n  --lp-ar-surface-active: var(--color-bg-user-bubble, #f1f2f3);\n  --lp-ar-border: var(--color-border-input, #d7d9dd);\n  --lp-ar-text: var(--color-text-primary, #111318);\n  --lp-ar-text-muted: var(--color-text-secondary, #656970);\n\n  width: 232px;\n  max-height: min(360px, var(--radix-dropdown-menu-content-available-height));\n  overflow-y: auto;\n  color: var(--lp-ar-text);\n  background: var(--lp-ar-surface);\n  border: 1px solid var(--lp-ar-border);\n  border-radius: 7px;\n  padding: 5px;\n  box-shadow: 0 16px 40px rgb(0 0 0 / 18%);\n  font-family: 'Geist Sans', 'SF Pro Display', system-ui, sans-serif;\n  z-index: 200;\n  transform-origin: var(--radix-dropdown-menu-content-transform-origin);\n  animation: lpMenuIn 120ms cubic-bezier(0.32, 0.72, 0, 1);\n}\n\n@keyframes lpMenuIn {\n  from { opacity: 0; transform: translateY(3px) scale(0.99); }\n}\n\n.lp-ar-content__label {\n  display: block;\n  padding: 7px 9px 8px;\n  color: var(--lp-ar-text-muted);\n  font-size: 10px;\n  font-weight: 650;\n  letter-spacing: 0.055em;\n  text-transform: uppercase;\n}\n\n.lp-ar-item {\n  display: grid;\n  min-height: 46px;\n  grid-template-columns: 30px minmax(0, 1fr) 18px;\n  align-items: center;\n  gap: 9px;\n  padding: 5px 8px;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  cursor: pointer;\n  color: var(--lp-ar-text-muted);\n  outline: none;\n  user-select: none;\n  transition: background-color 120ms cubic-bezier(0.32, 0.72, 0, 1),\n    border-color 120ms cubic-bezier(0.32, 0.72, 0, 1),\n    color 120ms cubic-bezier(0.32, 0.72, 0, 1);\n}\n\n.lp-ar-item:hover,\n.lp-ar-item[data-highlighted] {\n  background: var(--lp-ar-surface-active);\n  border-color: var(--lp-ar-border);\n  color: var(--lp-ar-text);\n}\n\n.lp-ar-item--selected {\n  color: var(--lp-ar-text);\n  background: var(--lp-ar-surface-active);\n}\n\n.lp-ar-item__icon {\n  display: grid;\n  width: 30px;\n  height: 30px;\n  place-items: center;\n  color: var(--lp-ar-text-muted);\n  background: var(--lp-ar-surface-raised);\n  border: 1px solid var(--lp-ar-border);\n  border-radius: 4px;\n}\n\n.lp-ar-item[data-highlighted] .lp-ar-item__icon,\n.lp-ar-item--selected .lp-ar-item__icon {\n  color: var(--lp-ar-text);\n}\n\n.lp-ar-item__copy {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.lp-ar-item__label {\n  font-family: 'Geist Mono', 'SF Mono', ui-monospace, monospace;\n  font-size: 12px;\n  font-weight: 650;\n  line-height: 1.2;\n}\n\n.lp-ar-item__description {\n  overflow: hidden;\n  color: var(--lp-ar-text-muted);\n  font-size: 10px;\n  font-weight: 450;\n  line-height: 1.25;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.lp-ar-item__check {\n  display: grid;\n  width: 18px;\n  height: 18px;\n  place-items: center;\n  color: var(--lp-ar-text);\n}\n\n.lp-ar-trigger__label {\n  font-family: var(--lp-font-mono);\n  font-size: 12px;\n  letter-spacing: -0.01em;\n}\n\n/* Unified run settings */\n.lp-run-settings__trigger[data-state='open'] {\n  color: var(--lp-text);\n  background: var(--lp-surface-active);\n}\n\n.lp-run-settings__trigger[data-state='open'] > svg:last-child {\n  transform: rotate(180deg);\n}\n\n.lp-run-settings__trigger > svg:last-child {\n  transition: transform 160ms cubic-bezier(0.2, 0, 0, 1);\n}\n\n.lp-run-settings {\n  z-index: 1200;\n  width: min(400px, calc(100vw - 24px));\n  max-height: min(680px, var(--radix-popover-content-available-height, calc(100vh - 24px)));\n  overflow-y: auto;\n  color: var(--color-text-primary, #111318);\n  background: var(--color-bg-canvas-surface, #fff);\n  border: 1px solid var(--color-border-input, #d7d9dd);\n  border-radius: 8px;\n  box-shadow: 0 16px 40px rgb(0 0 0 / 18%);\n  font-family: inherit;\n  transform-origin: var(--radix-popover-content-transform-origin);\n  will-change: opacity, transform;\n  animation: lpRunSettingsInBottom 180ms cubic-bezier(0.2, 0, 0, 1);\n}\n\n@keyframes lpRunSettingsInBottom {\n  from { opacity: 0; transform: translateY(-4px); }\n}\n\n@keyframes lpRunSettingsInTop {\n  from { opacity: 0; transform: translateY(4px); }\n}\n\n.lp-run-settings[data-side='top'] { animation-name: lpRunSettingsInTop; }\n\n.lp-run-settings__advanced-trigger > span,\n.lp-run-settings__choices label > span,\n.lp-run-settings__ratios button > span:nth-child(2) {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.lp-run-settings__advanced-trigger small,\n.lp-run-settings__choices small,\n.lp-run-settings__ratios small {\n  color: var(--color-text-secondary, #656970);\n  font-size: 12px;\n  font-weight: 450;\n  line-height: 1.35;\n}\n\n.lp-run-settings__section {\n  margin: 0;\n  padding: 16px;\n  border: 0;\n  border-bottom: 1px solid var(--color-border-sidebar, #dcdcdc);\n}\n\n.lp-run-settings > .lp-run-settings__section:first-child {\n  padding-top: 24px;\n}\n\n.lp-run-settings__section-label {\n  margin-bottom: 8px;\n  color: var(--color-text-secondary, #656970);\n  font-size: 12px;\n  font-weight: 650;\n}\n\n.lp-run-settings__ratios {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.lp-run-settings__ratios button {\n  display: grid;\n  min-height: 48px;\n  padding: 8px;\n  grid-template-columns: 32px minmax(0, 1fr) 16px;\n  align-items: center;\n  gap: 8px;\n  color: var(--color-text-secondary, #656970);\n  background: transparent;\n  border: 1px solid var(--color-border-input, #d7d9dd);\n  border-radius: 4px;\n  cursor: pointer;\n  font-family: inherit;\n  text-align: left;\n  transition: color 100ms cubic-bezier(0.2, 0, 0, 1),\n    background-color 100ms cubic-bezier(0.2, 0, 0, 1),\n    transform 140ms cubic-bezier(0.2, 0, 0, 1);\n}\n\n.lp-run-settings__ratios button:hover,\n.lp-run-settings__ratios button.is-selected {\n  color: var(--color-text-primary, #111318);\n  background: var(--color-bg-user-bubble, #f1f2f3);\n}\n\n.lp-run-settings__ratios button:active { transform: scale(0.98); }\n.lp-run-settings__ratios strong { font-family: var(--lp-font-mono); font-size: 12px; font-weight: 650; }\n.lp-run-settings__ratio-icon { display: grid; width: 32px; height: 32px; place-items: center; border: 1px solid var(--color-border-input, #d7d9dd); border-radius: 4px; }\n\n.lp-run-settings__choices {\n  display: grid;\n  gap: 16px;\n}\n\n.lp-run-settings__choices label {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  cursor: pointer;\n}\n\n.lp-run-settings__choices strong,\n.lp-run-settings__advanced-trigger strong { font-size: 14px; font-weight: 600; }\n\n.lp-run-settings__switch {\n  position: relative;\n  width: 36px;\n  height: 20px;\n  padding: 0;\n  flex: none;\n  border: 1px solid var(--color-border-input, #d7d9dd);\n  border-radius: 999px;\n  background: var(--color-bg-sidebar, #f7f7f7);\n  cursor: pointer;\n  transition: background-color 160ms cubic-bezier(0.2, 0, 0, 1),\n    border-color 160ms cubic-bezier(0.2, 0, 0, 1);\n}\n\n.lp-run-settings__switch[data-state='checked'] { border-color: var(--color-text-primary, #111318); background: var(--color-text-primary, #111318); }\n.lp-run-settings__switch-thumb { display: block; width: 14px; height: 14px; border-radius: 50%; background: var(--color-bg-canvas-surface, #fff); box-shadow: 0 1px 2px rgb(0 0 0 / 22%); transform: translateX(2px); transition: transform 180ms cubic-bezier(0.2, 0, 0, 1); }\n.lp-run-settings__switch[data-state='checked'] .lp-run-settings__switch-thumb { transform: translateX(18px); }\n\n.lp-run-settings__advanced { border-bottom: 0; }\n.lp-run-settings__advanced-trigger {\n  display: flex;\n  width: 100%;\n  min-height: 64px;\n  padding: 12px 16px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  color: inherit;\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n  font-family: inherit;\n  text-align: left;\n}\n\n.lp-run-settings__advanced-trigger:hover { background: var(--color-bg-user-bubble, #f1f2f3); }\n.lp-run-settings__advanced-trigger:disabled { cursor: not-allowed; opacity: .5; }\n.lp-run-settings__advanced-trigger > svg { flex: none; transition: transform 160ms cubic-bezier(0.2, 0, 0, 1); }\n.lp-run-settings__model-panel { margin: 0; padding: 0; border: 0; }\n.lp-run-settings__advanced-view { min-height: 0; }\n.lp-run-settings__back {\n  display: inline-flex;\n  min-height: 40px;\n  margin: 8px 8px 0;\n  padding: 8px 12px;\n  align-items: center;\n  gap: 8px;\n  color: var(--color-text-secondary, #656970);\n  background: transparent;\n  border: 0;\n  border-radius: 4px;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 600;\n}\n.lp-run-settings__back:hover { color: var(--color-text-primary, #111318); background: var(--color-bg-user-bubble, #f1f2f3); }\n.lp-run-settings__back > svg { transform: rotate(90deg); }\n\n.lp-run-settings button:focus-visible,\n.lp-run-settings [role='switch']:focus-visible,\n.lp-suggestions__trigger:focus-visible,\n.lp-suggestions__item:focus-visible {\n  outline: 2px solid var(--color-text-primary, #111318);\n  outline-offset: 2px;\n}\n\n/* Reference picker menu placement inside the new composer */\n.lp-composer .composer-reference-menu {\n  left: 0;\n  width: min(340px, calc(100vw - 48px));\n}\n\n.lp-composer .composer-reference-chips {\n  display: contents;\n}\n\n/* Suggestions */\n.lp-suggestions {\n  margin-top: var(--lp-space-16);\n  text-align: center;\n}\n\n.lp-suggestions__trigger {\n  display: inline-flex;\n  min-height: 36px;\n  padding: 8px 12px;\n  align-items: center;\n  gap: 8px;\n  color: var(--lp-text-muted);\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: 999px;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  transition: color 700ms cubic-bezier(0.32, 0.72, 0, 1),\n    background-color 700ms cubic-bezier(0.32, 0.72, 0, 1),\n    transform 700ms cubic-bezier(0.32, 0.72, 0, 1);\n}\n\n.lp-suggestions__trigger:hover,\n.lp-suggestions__trigger[data-state='open'] { color: var(--lp-text); background: var(--lp-surface-subdued); }\n.lp-suggestions__trigger:active { transform: scale(0.98); }\n.lp-suggestions__trigger[data-state='open'] > svg:last-child { transform: rotate(180deg); }\n.lp-suggestions__trigger > svg:last-child { transition: transform 700ms cubic-bezier(0.32, 0.72, 0, 1); }\n\n.lp-suggestions__menu {\n  z-index: 1200;\n  width: min(280px, calc(100vw - 24px));\n  padding: 4px;\n  color: var(--color-text-primary, #111318);\n  background: var(--color-bg-canvas-surface, #fff);\n  border: 1px solid var(--color-border-input, #d7d9dd);\n  border-radius: 8px;\n  box-shadow: 0 16px 40px rgb(0 0 0 / 18%);\n  font-family: inherit;\n  animation: lpRunSettingsInBottom 120ms cubic-bezier(0.2, 0, 0, 1);\n}\n\n.lp-suggestions__menu[data-side='top'] { animation-name: lpRunSettingsInTop; }\n\n.lp-suggestions__menu [role='menuitem'],\n.lp-suggestions__menu [role='group'] { outline: none; }\n.lp-suggestions__menu > [role='group'] { padding: 8px; color: var(--color-text-secondary, #656970); font-size: 12px; font-weight: 650; }\n.lp-suggestions__item { padding: 8px; border: 1px solid transparent; border-radius: 4px; cursor: pointer; font-size: 14px; text-align: left; }\n.lp-suggestions__item:hover,\n.lp-suggestions__item[data-highlighted] { background: var(--color-bg-user-bubble, #f1f2f3); border-color: var(--color-border-input, #d7d9dd); }\n\n@media (max-width: 600px) {\n  .lp-run-settings__trigger > span { display: none; }\n  .lp-run-settings__trigger { width: 40px; padding: 0; }\n  .lp-run-settings { width: calc(100vw - 16px); }\n  .lp-run-settings__ratios { grid-template-columns: 1fr; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .lp-run-settings,\n  .lp-run-settings *,\n  .lp-suggestions__trigger,\n  .lp-suggestions__menu { transition-duration: .01ms; animation-duration: .01ms; }\n}\n\n.lp-suggestions__row {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: var(--lp-space-8);\n  overflow-x: auto;\n  padding-bottom: var(--lp-space-4);\n  scrollbar-width: none;\n  -webkit-overflow-scrolling: touch;\n}\n\n.lp-suggestions__row::-webkit-scrollbar {\n  display: none;\n}\n\n@media (min-width: 1024px) {\n  .lp-suggestions__row {\n    flex-wrap: wrap;\n    justify-content: center;\n    overflow: visible;\n  }\n}\n\n.lp-suggestion-chip {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  min-height: 36px;\n  padding: var(--lp-space-8) var(--lp-space-12);\n  border: 1px solid var(--lp-border);\n  border-radius: 999px;\n  background: var(--lp-surface);\n  color: var(--lp-text-muted);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: color var(--lp-dur-press) var(--lp-ease),\n    background-color var(--lp-dur-press) var(--lp-ease),\n    transform var(--lp-dur-press) var(--lp-ease);\n}\n\n.lp-suggestion-chip:hover:not(:disabled) {\n  color: var(--lp-text);\n  background: var(--lp-surface-subdued);\n  transform: translateY(-2px);\n}\n\n.lp-suggestion-chip:active:not(:disabled) {\n  transform: translateY(0) scale(0.98);\n}\n\n.lp-suggestion-chip:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.lp-suggestions__confirm {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--lp-space-12);\n  margin-bottom: var(--lp-space-12);\n  padding: var(--lp-space-12);\n  border: 1px solid var(--lp-border);\n  border-radius: 12px;\n  background: var(--lp-surface);\n  font-size: 14px;\n  color: var(--lp-text);\n}\n\n.lp-suggestions__confirm-actions {\n  display: flex;\n  gap: var(--lp-space-8);\n  margin-left: auto;\n}\n\n.lp-btn-quiet {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 32px;\n  padding: var(--lp-space-8) var(--lp-space-12);\n  border: 1px solid var(--lp-border);\n  border-radius: 999px;\n  background: transparent;\n  color: var(--lp-text);\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color var(--lp-dur-press) var(--lp-ease);\n}\n\n.lp-btn-quiet:hover {\n  background: var(--lp-surface-active);\n}\n\n.lp-btn-quiet--solid {\n  background: var(--lp-text);\n  border-color: var(--lp-text);\n  color: var(--lp-page-bg);\n}\n\n.lp-btn-quiet--solid:hover {\n  background: var(--lp-text);\n  opacity: 0.88;\n}\n\n/* Risk reversal */\n.lp-risk-reversal {\n  margin: var(--lp-space-16) 0 0;\n  text-align: center;\n  font-size: 14px;\n  color: var(--lp-text-muted);\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Output showcase\n   ═══════════════════════════════════════════════════════════════ */\n\n.lp-showcase__head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: var(--lp-space-24);\n}\n\n.lp-showcase__nav {\n  display: flex;\n  gap: var(--lp-space-8);\n}\n\n.lp-showcase__scroller {\n  display: flex;\n  /* Cards size from their own aspect-ratio. The default `stretch` ties each\n     card's height to the flex line instead, which Safari recomputes as the\n     lazily-loaded videos settle — the cards visibly grow while scrolling. */\n  align-items: flex-start;\n  gap: var(--lp-space-16);\n  margin-top: var(--lp-space-48);\n  overflow-x: auto;\n  scroll-padding-left: 0;\n  scrollbar-width: none;\n  -webkit-overflow-scrolling: touch;\n  padding-bottom: var(--lp-space-8);\n}\n\n.lp-showcase__scroller::-webkit-scrollbar {\n  display: none;\n}\n\n@media (pointer: coarse) {\n  .lp-showcase__scroller {\n    scroll-snap-type: x mandatory;\n  }\n}\n\n.lp-device {\n  flex: 0 0 78%;\n  scroll-snap-align: start;\n  aspect-ratio: 9 / 16;\n  /* Containing block for the card, which is pinned rather than sized in\n     flow, plus a hard clip so nothing inside can ever paint past the frame. */\n  position: relative;\n  overflow: hidden;\n  padding: var(--lp-space-8);\n  border: 1px solid var(--lp-border);\n  border-radius: 16px;\n  background: var(--lp-surface);\n  transition: transform var(--lp-dur-press) var(--lp-ease),\n    box-shadow var(--lp-dur-press) var(--lp-ease);\n}\n\n.lp-device:hover {\n  transform: translateY(-2px);\n}\n\n@media (min-width: 640px) {\n  .lp-device { flex-basis: calc((100% - var(--lp-space-16)) / 2.35); }\n}\n\n@media (min-width: 1024px) {\n  .lp-device { flex-basis: calc((100% - (2 * var(--lp-space-16))) / 3.3); }\n}\n\n/* Restyle the shared example card as a clean device screen.\n   The card is a <button>. Safari renders an un-reset button as a native\n   push button whose box follows its contents rather than an author\n   percentage height, so `height: 100%` was not reliable — the card grew\n   when the video's intrinsic size landed, which happens lazily during\n   scroll. Resetting the appearance and pinning the card to the frame's\n   padding box takes it out of flow, so its size is a pure function of\n   the frame and nothing inside it can feed back into layout. */\n.lp-device .ex-card {\n  appearance: none;\n  -webkit-appearance: none;\n  position: absolute;\n  inset: var(--lp-space-8);\n  width: auto;\n  height: auto;\n  aspect-ratio: auto;\n  border: none;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #0d0c0a;\n  display: block;\n  cursor: pointer;\n  padding: 0;\n}\n\n/* Keep showcase media stable while the page moves beneath the pointer. */\n.lp-device .ex-card:hover .ex-card-thumb,\n.lp-device .ex-card:hover .ex-card-video {\n  transform: none;\n}\n\n.lp-showcase__footer {\n  margin-top: var(--lp-space-24);\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--lp-space-16);\n}\n\n.lp-showcase__disclosure {\n  margin: 0;\n  font-size: 13px;\n  color: var(--lp-text-muted);\n}\n\n.lp-showcase__more {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--lp-space-8);\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--lp-text);\n  text-decoration: none;\n  transition: color var(--lp-dur-press) var(--lp-ease);\n}\n\n.lp-showcase__more:hover {\n  color: var(--lp-terracotta);\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Composer agent section\n   ═══════════════════════════════════════════════════════════════ */\n\n.lp-agent__grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: var(--lp-space-48);\n  align-items: center;\n}\n\n@media (min-width: 640px) {\n  .lp-agent__grid {\n    grid-template-columns: repeat(8, 1fr);\n  }\n  .lp-agent__copy { grid-column: span 8; }\n  .lp-agent__art { grid-column: span 8; }\n}\n\n@media (min-width: 1024px) {\n  .lp-agent__grid {\n    grid-template-columns: repeat(12, 1fr);\n    gap: var(--lp-space-48);\n  }\n  .lp-agent__copy { grid-column: span 5; }\n  .lp-agent__art { grid-column: span 7; }\n}\n\n.lp-agent__supporting {\n  margin: var(--lp-space-24) 0 0;\n  font-size: 16px;\n  line-height: 1.6;\n  font-weight: 500;\n  color: var(--lp-text);\n  max-width: var(--lp-text-max);\n  text-wrap: pretty;\n}\n\n@media (min-width: 1024px) {\n  .lp-agent__supporting { font-size: 18px; }\n}\n\n/* ── Scripted agent run visual ───────────────────────────────── */\n\n.lp-agentviz {\n  display: flex;\n  flex-direction: column;\n  gap: var(--lp-space-12);\n  padding: var(--lp-space-12);\n  border: 1px solid var(--lp-border);\n  border-radius: 18px;\n  background: var(--lp-surface);\n  box-shadow: 0 18px 44px -32px rgba(23, 18, 14, 0.5);\n}\n\n@media (min-width: 640px) {\n  .lp-agentviz {\n    gap: var(--lp-space-16);\n    padding: var(--lp-space-16);\n  }\n}\n\n/* Composer — the prompt types itself, then sends */\n\n.lp-agentviz__composer {\n  display: flex;\n  align-items: center;\n  gap: var(--lp-space-8);\n  min-height: 44px;\n  padding: var(--lp-space-8) var(--lp-space-8) var(--lp-space-8) var(--lp-space-12);\n  border: 1px solid var(--lp-border);\n  border-radius: 12px;\n  background: var(--lp-page-bg);\n  transition: border-color var(--lp-dur-press) var(--lp-ease);\n}\n\n.lp-agentviz__composer--typing,\n.lp-agentviz__composer--sending {\n  border-color: var(--lp-terracotta);\n  box-shadow: 0 0 0 3px var(--lp-focus-ring);\n}\n\n.lp-agentviz__composer-text {\n  flex: 1 1 auto;\n  min-width: 0;\n  font-size: 13px;\n  line-height: 1.45;\n  color: var(--lp-text);\n  text-wrap: pretty;\n}\n\n.lp-agentviz__caret {\n  display: inline-block;\n  width: 1.5px;\n  height: 1em;\n  margin-left: 1px;\n  vertical-align: text-bottom;\n  background: var(--lp-terracotta);\n  animation: lp-agent-caret 900ms steps(1, end) infinite;\n}\n\n.lp-agentviz__send {\n  display: flex;\n  flex: none;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: var(--lp-surface-subdued);\n  color: var(--lp-text-muted);\n  transition:\n    background-color var(--lp-dur-press) var(--lp-ease),\n    color var(--lp-dur-press) var(--lp-ease),\n    transform var(--lp-dur-press) var(--lp-ease);\n}\n\n.lp-agentviz__send svg {\n  width: 14px;\n  height: 14px;\n}\n\n.lp-agentviz__send--ready {\n  background: var(--lp-terracotta);\n  color: var(--lp-surface);\n}\n\n.lp-agentviz__send--pressed {\n  transform: scale(0.88);\n}\n\n/* Work log — mirrors the agent panel inside the product */\n\n.lp-agentviz__log {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  gap: var(--lp-space-4);\n  /* Reserved so rows streaming in never resize the card. */\n  min-height: 144px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.lp-agentviz__row {\n  display: flex;\n  align-items: center;\n  gap: var(--lp-space-8);\n  padding: var(--lp-space-8);\n  border-radius: 10px;\n  animation: lp-agent-row-in 360ms var(--lp-ease) both;\n}\n\n.lp-agentviz__row--active {\n  background: var(--lp-surface-subdued);\n}\n\n.lp-agentviz__row--done {\n  opacity: 0.62;\n}\n\n.lp-agentviz__row-icon {\n  display: flex;\n  flex: none;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  color: var(--lp-olive);\n}\n\n.lp-agentviz__check {\n  width: 12px;\n  height: 12px;\n}\n\n.lp-agentviz__spinner {\n  width: 11px;\n  height: 11px;\n  border: 1.5px solid var(--lp-border);\n  border-top-color: var(--lp-terracotta);\n  border-radius: 50%;\n  animation: lp-agent-spin 700ms linear infinite;\n}\n\n.lp-agentviz__row-copy {\n  display: flex;\n  min-width: 0;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: var(--lp-space-8);\n}\n\n.lp-agentviz__row-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--lp-text);\n}\n\n.lp-agentviz__row--think .lp-agentviz__row-title {\n  font-style: italic;\n  font-weight: 500;\n  color: var(--lp-text-muted);\n}\n\n.lp-agentviz__row-meta {\n  font-family: var(--lp-font-mono);\n  font-size: 11px;\n  color: var(--lp-text-muted);\n}\n\n.lp-agentviz__timer {\n  margin-left: auto;\n  padding-left: var(--lp-space-8);\n  font-family: var(--lp-font-mono);\n  font-size: 11px;\n  color: var(--lp-text-muted);\n  font-variant-numeric: tabular-nums;\n}\n\n/* Timeline — video, audio, and caption tracks under a time ruler */\n\n.lp-agentviz__tl-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--lp-space-8);\n  padding-top: var(--lp-space-12);\n  border-top: 1px solid var(--lp-border);\n}\n\n.lp-agentviz__tl-title {\n  font-family: var(--lp-font-mono);\n  font-size: 10px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--lp-text-muted);\n}\n\n.lp-agentviz__tl-chip {\n  padding: 3px 10px;\n  border-radius: 999px;\n  background: var(--lp-olive);\n  color: var(--lp-surface);\n  font-family: var(--lp-font-mono);\n  font-size: 10px;\n  letter-spacing: 0.02em;\n  animation: lp-agent-chip-in 360ms var(--lp-ease) both;\n}\n\n.lp-agentviz__tl {\n  border: 1px solid var(--lp-border);\n  border-radius: 10px;\n  background: var(--lp-page-bg);\n  padding: var(--lp-space-8);\n}\n\n.lp-agentviz__tl-grid {\n  position: relative;\n  display: grid;\n  grid-template-columns: 26px minmax(0, 1fr);\n  gap: 4px var(--lp-space-8);\n  align-items: center;\n  --lp-tl-lane-start: 34px;\n}\n\n.lp-agentviz__ruler {\n  display: flex;\n  justify-content: space-between;\n  height: 14px;\n  border-bottom: 1px solid var(--lp-border);\n}\n\n.lp-agentviz__tick {\n  position: relative;\n  flex: none;\n  font-family: var(--lp-font-mono);\n  font-size: 8px;\n  line-height: 1;\n  color: var(--lp-text-muted);\n}\n\n.lp-agentviz__tick::after {\n  content: '';\n  position: absolute;\n  bottom: -5px;\n  left: 0;\n  width: 1px;\n  height: 4px;\n  background: var(--lp-border);\n}\n\n.lp-agentviz__tl-name {\n  font-family: var(--lp-font-mono);\n  font-size: 9px;\n  letter-spacing: 0.04em;\n  color: var(--lp-text-muted);\n  text-align: right;\n}\n\n.lp-agentviz__lane {\n  display: flex;\n  gap: 2px;\n  height: 34px;\n  padding: 2px;\n  border-radius: 4px;\n  background: var(--lp-surface-subdued);\n}\n\n.lp-agentviz__lane--audio { height: 22px; }\n.lp-agentviz__lane--text { height: 14px; }\n\n/* Video clips read as NLE clips: label header over a filmstrip body. */\n\n.lp-agentviz__clip {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex-basis: 0;\n  min-width: 0;\n  overflow: hidden;\n  border-radius: 3px;\n  opacity: 0;\n  transform: scaleX(0.94);\n  transform-origin: left center;\n  transition:\n    opacity 300ms var(--lp-ease),\n    transform 300ms var(--lp-ease);\n}\n\n.lp-agentviz__clip--pending,\n.lp-agentviz__clip--in {\n  opacity: 1;\n  transform: scaleX(1);\n}\n\n.lp-agentviz__clip--pending {\n  opacity: 0.55;\n}\n\n.lp-agentviz__clip-head {\n  padding: 1px 4px;\n  font-family: var(--lp-font-mono);\n  font-size: 8px;\n  line-height: 1.5;\n  color: var(--lp-surface);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.lp-agentviz__clip-frames {\n  flex: 1;\n  background-image: repeating-linear-gradient(\n    90deg,\n    rgba(255, 253, 248, 0.28) 0 1px,\n    transparent 1px 12px\n  );\n}\n\n.lp-agentviz__clip--1 { background: var(--lp-terracotta); }\n.lp-agentviz__clip--2 { background: var(--lp-olive); }\n.lp-agentviz__clip--3 { background: var(--lp-sepia); }\n\n.lp-agentviz__clip--pending .lp-agentviz__clip-frames {\n  background-image: repeating-linear-gradient(\n    -45deg,\n    rgba(255, 253, 248, 0.34) 0 4px,\n    transparent 4px 8px\n  );\n}\n\n/* Audio track */\n\n.lp-agentviz__audio {\n  display: flex;\n  flex: 1;\n  min-width: 0;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1px;\n  overflow: hidden;\n  padding: 0 3px;\n  border: 1px solid var(--lp-border);\n  border-radius: 3px;\n  background: var(--lp-surface);\n  opacity: 0;\n  transition: opacity 320ms var(--lp-ease);\n}\n\n.lp-agentviz__audio--pending { opacity: 0.45; }\n.lp-agentviz__audio--in { opacity: 1; }\n\n.lp-agentviz__audio span {\n  flex: 0 0 2px;\n  border-radius: 1px;\n  background: var(--lp-sepia);\n}\n\n/* Caption track */\n\n.lp-agentviz__caption {\n  flex: 1;\n  border-radius: 2px;\n  background: var(--lp-text-muted);\n  opacity: 0;\n}\n\n.lp-agentviz__caption--pending {\n  opacity: 0.4;\n  animation: lp-agent-caption-in 300ms var(--lp-ease) both;\n}\n\n.lp-agentviz__caption--in {\n  opacity: 0.85;\n  animation: lp-agent-caption-in 300ms var(--lp-ease) both;\n}\n\n.lp-agentviz__playhead {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: var(--lp-tl-lane-start);\n  width: 1.5px;\n  background: var(--lp-rust);\n  animation: lp-agent-playhead 2000ms var(--lp-ease) infinite;\n}\n\n.lp-agentviz__playhead::before {\n  content: '';\n  position: absolute;\n  top: -1px;\n  left: -3.25px;\n  width: 8px;\n  height: 6px;\n  clip-path: polygon(0 0, 100% 0, 50% 100%);\n  background: var(--lp-rust);\n}\n\n.lp-agentviz__playhead--parked {\n  animation-iteration-count: 1;\n  animation-fill-mode: forwards;\n}\n\n@keyframes lp-agent-caret {\n  50% { opacity: 0; }\n}\n\n@keyframes lp-agent-row-in {\n  from { opacity: 0; transform: translateY(6px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes lp-agent-chip-in {\n  from { opacity: 0; transform: translateY(-4px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes lp-agent-caption-in {\n  from { transform: scaleX(0.6); }\n  to { transform: scaleX(1); }\n}\n\n@keyframes lp-agent-spin {\n  to { transform: rotate(360deg); }\n}\n\n@keyframes lp-agent-playhead {\n  from { left: var(--lp-tl-lane-start); }\n  to { left: calc(100% - 2px); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .lp-agentviz__row,\n  .lp-agentviz__caret,\n  .lp-agentviz__tl-chip,\n  .lp-agentviz__caption,\n  .lp-agentviz__spinner,\n  .lp-agentviz__playhead {\n    animation: none;\n  }\n\n  .lp-agentviz__caret { display: none; }\n  .lp-agentviz__playhead { left: calc(100% - 2px); }\n}\n\n\n.lp-illustration {\n  width: 100%;\n  height: auto;\n  display: block;\n  color: var(--lp-sepia);\n}\n\n.lp-ink {\n  stroke: var(--lp-sepia);\n  fill: none;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.lp-fill-paper { fill: var(--lp-page-bg); }\n.lp-fill-surface { fill: var(--lp-surface); }\n.lp-fill-subdued { fill: var(--lp-surface-subdued); }\n.lp-fill-terra { fill: var(--lp-terracotta); }\n.lp-fill-olive { fill: var(--lp-olive); }\n.lp-fill-sepia { fill: var(--lp-sepia); }\n\n/* ═══════════════════════════════════════════════════════════════\n   Tagline reveal\n   ═══════════════════════════════════════════════════════════════ */\n\n.lp-tagline {\n  padding-top: var(--lp-space-96);\n  padding-bottom: var(--lp-space-96);\n  text-align: center;\n}\n\n@media (max-width: 639px) {\n  .lp-tagline {\n    padding-top: var(--lp-space-64);\n    padding-bottom: var(--lp-space-64);\n  }\n}\n\n.lp-tagline__text {\n  margin: 0 auto;\n  max-width: var(--lp-text-max);\n  font-size: 36px;\n  font-weight: 500;\n  line-height: 1.12;\n  letter-spacing: -0.02em;\n  color: var(--lp-text);\n  text-wrap: balance;\n}\n\n@media (min-width: 640px) {\n  .lp-tagline__text { font-size: 48px; }\n}\n\n@media (min-width: 1024px) {\n  .lp-tagline__text { font-size: 60px; }\n}\n\n.lp-tagline__line {\n  display: block;\n}\n\n.lp-tagline__word {\n  opacity: 0.3;\n  transition: opacity 800ms var(--lp-ease);\n}\n\n.lp-tagline--visible .lp-tagline__word {\n  opacity: 1;\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Factory journey\n   ═══════════════════════════════════════════════════════════════ */\n\n.lp-factory__intro {\n  max-width: var(--lp-text-max);\n}\n\n.lp-factory__media {\n  margin-top: var(--lp-space-48);\n}\n\n@media (max-width: 639px) {\n  .lp-factory__media { margin-top: var(--lp-space-32); }\n}\n\n/* ── Content factory workflow ────────────────────────────────── */\n\n.lp-flow {\n  width: 100%;\n  padding: var(--lp-space-16);\n  border: 1px solid var(--lp-border);\n  border-radius: 16px;\n  background: var(--lp-surface);\n}\n\n@media (min-width: 768px) {\n  .lp-flow { padding: var(--lp-space-24); }\n}\n\n/* Automation canvas: dot grid, edges behind, nodes on top. */\n.lp-flow__canvas {\n  position: relative;\n  width: 100%;\n  border-radius: 12px;\n  background-color: var(--lp-page-bg);\n  background-image: radial-gradient(var(--lp-border) 1.2px, transparent 1.2px);\n  background-size: 18px 18px;\n  background-position: -9px -9px;\n}\n\n@media (min-width: 768px) {\n  .lp-flow__canvas {\n    aspect-ratio: 1000 / 300;\n  }\n}\n\n.lp-flow__edges {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  overflow: visible;\n  display: none;\n}\n\n@media (min-width: 768px) {\n  .lp-flow__edges { display: block; }\n}\n\n.lp-flow__edge {\n  fill: none;\n  stroke: var(--lp-border);\n  stroke-width: 2;\n  stroke-linecap: round;\n  vector-effect: non-scaling-stroke;\n  stroke-dasharray: 1;\n  stroke-dashoffset: 1;\n  /* Round caps leave a sliver at zero dash length, so undrawn edges are\n     hidden outright rather than relying on the dash alone. */\n  stroke-opacity: 0;\n  transition:\n    stroke-dashoffset 320ms var(--lp-ease),\n    stroke-opacity 160ms var(--lp-ease),\n    stroke 260ms var(--lp-ease);\n}\n\n.lp-flow__edge--drawn,\n.lp-flow__edge--flowing {\n  stroke-dashoffset: 0;\n  stroke-opacity: 1;\n}\n\n.lp-flow__edge--flowing {\n  stroke: var(--lp-terracotta);\n  stroke-dasharray: 0.022 0.018;\n  animation: lp-flow-dash 520ms linear infinite;\n}\n\n.lp-flow__nodes {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n/* Mobile: a vertical run of steps with a connecting spine. */\n@media (max-width: 767px) {\n  .lp-flow__nodes {\n    display: flex;\n    flex-direction: column;\n    gap: var(--lp-space-24);\n    padding: var(--lp-space-16);\n  }\n\n  .lp-flow__node {\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: var(--lp-space-12);\n  }\n\n  .lp-flow__node:not(:first-child)::before {\n    content: '';\n    position: absolute;\n    left: 27px;\n    bottom: 100%;\n    width: 2px;\n    height: var(--lp-space-24);\n    background: var(--lp-border);\n    transform-origin: bottom center;\n    transform: scaleY(0);\n    transition: transform 300ms var(--lp-ease);\n  }\n\n  /* Must match the base rule's specificity to win. */\n  .lp-flow__node--idle:not(:first-child)::before,\n  .lp-flow__node--running:not(:first-child)::before,\n  .lp-flow__node--done:not(:first-child)::before {\n    transform: scaleY(1);\n  }\n\n  .lp-flow__node--running:not(:first-child)::before {\n    background: var(--lp-terracotta);\n  }\n}\n\n@media (min-width: 768px) {\n  .lp-flow__node {\n    position: absolute;\n    left: var(--lp-node-x);\n    top: var(--lp-node-y);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: var(--lp-space-8);\n    width: 128px;\n    transform: translate(-50%, -50%);\n  }\n}\n\n.lp-flow__node {\n  opacity: 0;\n  transition: opacity 300ms var(--lp-ease);\n}\n\n.lp-flow__node--idle,\n.lp-flow__node--running,\n.lp-flow__node--done {\n  opacity: 1;\n}\n\n/* The node tile — the part that reads as a workflow step. */\n.lp-flow__tile {\n  position: relative;\n  display: flex;\n  flex: none;\n  align-items: center;\n  justify-content: center;\n  width: 56px;\n  height: 56px;\n  border: 1px solid var(--lp-border);\n  border-radius: 14px;\n  background: var(--lp-surface);\n  color: var(--lp-sepia);\n  box-shadow: 0 6px 16px -12px rgba(23, 18, 14, 0.7);\n  transform: scale(0.9);\n  transition:\n    transform 300ms var(--lp-ease),\n    border-color 260ms var(--lp-ease),\n    box-shadow 260ms var(--lp-ease),\n    color 260ms var(--lp-ease);\n}\n\n.lp-flow__node--idle .lp-flow__tile,\n.lp-flow__node--running .lp-flow__tile,\n.lp-flow__node--done .lp-flow__tile {\n  transform: scale(1);\n}\n\n.lp-flow__node--running .lp-flow__tile {\n  border-color: var(--lp-terracotta);\n  color: var(--lp-terracotta);\n  box-shadow: 0 0 0 4px var(--lp-focus-ring);\n}\n\n.lp-flow__node--done .lp-flow__tile {\n  color: var(--lp-olive);\n}\n\n.lp-flow__icon {\n  transition: opacity 200ms var(--lp-ease);\n}\n\n/* While a node runs, its own animation takes over the tile. */\n.lp-flow__node--running .lp-flow__icon {\n  opacity: 0;\n}\n\n/* Connection ports, the small dots an edge attaches to. */\n.lp-flow__port {\n  position: absolute;\n  top: 50%;\n  width: 7px;\n  height: 7px;\n  margin-top: -3.5px;\n  border: 1.5px solid var(--lp-border);\n  border-radius: 50%;\n  background: var(--lp-surface);\n  display: none;\n}\n\n@media (min-width: 768px) {\n  .lp-flow__port { display: block; }\n}\n\n.lp-flow__port--in { left: -4px; }\n.lp-flow__port--out { right: -4px; }\n\n.lp-flow__node--running .lp-flow__port {\n  border-color: var(--lp-terracotta);\n}\n\n.lp-flow__node--instagram .lp-flow__port--in,\n.lp-flow__node--publish .lp-flow__port--out {\n  display: none;\n}\n\n/* Completed steps get the check badge an automation tool would show. */\n.lp-flow__badge {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: var(--lp-olive);\n  color: var(--lp-surface);\n  opacity: 0;\n  transform: scale(0.4);\n  transition: opacity 220ms var(--lp-ease), transform 220ms var(--lp-ease);\n}\n\n.lp-flow__badge svg {\n  width: 10px;\n  height: 10px;\n}\n\n.lp-flow__node--done .lp-flow__badge {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.lp-flow__label {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n@media (min-width: 768px) {\n  .lp-flow__label {\n    align-items: center;\n    text-align: center;\n  }\n}\n\n.lp-flow__title {\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.25;\n  color: var(--lp-text);\n}\n\n.lp-flow__meta {\n  font-family: var(--lp-font-mono);\n  font-size: 10px;\n  line-height: 1.3;\n  color: var(--lp-text-muted);\n}\n\n/* ── Per-node micro animations, played inside the tile ───────── */\n\n.lp-flow__viz {\n  position: absolute;\n  inset: 12px;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  gap: 2px;\n  opacity: 0;\n  transition: opacity 200ms var(--lp-ease);\n  pointer-events: none;\n}\n\n.lp-flow__node--running .lp-flow__viz {\n  opacity: 1;\n}\n\n/* Instagram: a grid of Reels tiles popping in. */\n.lp-flow__viz--grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-template-rows: repeat(2, 1fr);\n  place-items: stretch;\n  gap: 2px;\n}\n\n.lp-flow__viz--grid > span {\n  border-radius: 2px;\n  background: var(--lp-terracotta);\n  animation: lp-flow-pop 1500ms var(--lp-ease) infinite;\n}\n\n/* TikTok: a feed scrolling past. */\n.lp-flow__viz--feed {\n  overflow: hidden;\n  border-radius: 3px;\n}\n\n.lp-flow__feed-track {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  width: 100%;\n  animation: lp-flow-scroll 2200ms linear infinite;\n}\n\n.lp-flow__feed-track > span {\n  flex: none;\n  height: 9px;\n  border-radius: 2px;\n  background: var(--lp-terracotta);\n}\n\n/* Meta Ads: a bar chart filling in. */\n.lp-flow__viz--bars > span {\n  width: 5px;\n  height: var(--lp-bar-h);\n  border-radius: 1px;\n  background: var(--lp-terracotta);\n  transform-origin: bottom center;\n  animation: lp-flow-grow 1500ms var(--lp-ease) infinite;\n}\n\n/* Ideate: lines writing themselves. */\n.lp-flow__viz--lines {\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 4px;\n}\n\n.lp-flow__viz--lines > span {\n  height: 4px;\n  width: var(--lp-line-w);\n  border-radius: 2px;\n  background: var(--lp-terracotta);\n  transform-origin: left center;\n  animation: lp-flow-write 1800ms var(--lp-ease) infinite;\n}\n\n/* Generate: vertical frames filling. */\n.lp-flow__viz--frames {\n  align-items: stretch;\n  gap: 3px;\n}\n\n.lp-flow__viz--frames > span {\n  position: relative;\n  flex: 1;\n  border-radius: 2px;\n  overflow: hidden;\n  background: var(--lp-surface-subdued);\n}\n\n.lp-flow__viz--frames > span::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: var(--lp-terracotta);\n  transform-origin: bottom center;\n  animation: lp-flow-fill 1800ms var(--lp-ease) infinite;\n}\n\n/* Approval: Slack messages answered with a check. */\n.lp-flow__viz--approve {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 3px;\n}\n\n.lp-flow__bubble {\n  height: 5px;\n  border-radius: 3px;\n  background: var(--lp-terracotta);\n  opacity: 0.5;\n}\n\n.lp-flow__bubble:first-child { width: 100%; }\n.lp-flow__bubble:nth-child(2) { width: 62%; }\n\n.lp-flow__tick {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  align-self: flex-end;\n  width: 14px;\n  height: 14px;\n  margin-top: 2px;\n  border-radius: 50%;\n  background: var(--lp-olive);\n  color: var(--lp-surface);\n  animation: lp-flow-pop-in 1800ms var(--lp-ease) infinite;\n}\n\n.lp-flow__tick svg {\n  width: 9px;\n  height: 9px;\n}\n\n/* Publish: a live signal going out. */\n.lp-flow__viz--publish {\n  align-items: center;\n}\n\n.lp-flow__live {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--lp-terracotta);\n}\n\n.lp-flow__pulse {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 8px;\n  height: 8px;\n  margin: -4px 0 0 -4px;\n  border-radius: 50%;\n  border: 1.5px solid var(--lp-terracotta);\n  animation: lp-flow-ripple 2400ms var(--lp-ease) infinite;\n}\n\n.lp-flow__pulse:nth-child(2) {\n  animation-delay: 800ms;\n}\n\n@keyframes lp-flow-dash {\n  to { stroke-dashoffset: -0.04; }\n}\n\n@keyframes lp-flow-pop {\n  0%, 100% { transform: scale(0.65); opacity: 0.4; }\n  40% { transform: scale(1); opacity: 1; }\n}\n\n@keyframes lp-flow-scroll {\n  to { transform: translateY(-50%); }\n}\n\n@keyframes lp-flow-grow {\n  0%, 100% { transform: scaleY(0.4); }\n  50% { transform: scaleY(1); }\n}\n\n@keyframes lp-flow-write {\n  from { transform: scaleX(0); }\n  60%, 100% { transform: scaleX(1); }\n}\n\n@keyframes lp-flow-fill {\n  from { transform: scaleY(0); }\n  70%, 100% { transform: scaleY(1); }\n}\n\n@keyframes lp-flow-pop-in {\n  0%, 45% { transform: scale(0); }\n  65% { transform: scale(1.2); }\n  80%, 100% { transform: scale(1); }\n}\n\n@keyframes lp-flow-ripple {\n  from { transform: scale(1); opacity: 0.7; }\n  to { transform: scale(3.4); opacity: 0; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .lp-flow__node,\n  .lp-flow__tile,\n  .lp-flow__badge,\n  .lp-flow__edge,\n  .lp-flow__viz > span,\n  .lp-flow__feed-track,\n  .lp-flow__tick,\n  .lp-flow__pulse,\n  .lp-flow__viz--frames > span::after {\n    animation: none;\n    transition: none;\n  }\n\n  .lp-flow__pulse { display: none; }\n}\n\n.lp-factory__stages {\n  list-style: none;\n  padding: 0;\n  margin-bottom: 0;\n  margin-top: var(--lp-space-64);\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: var(--lp-space-24);\n}\n\n@media (min-width: 640px) {\n  .lp-factory__stages {\n    grid-template-columns: repeat(2, 1fr);\n    gap: var(--lp-space-32);\n  }\n}\n\n@media (min-width: 1024px) {\n  .lp-factory__stages > .lp-stage:nth-child(even) {\n    transform: translateY(var(--lp-space-48));\n  }\n}\n\n.lp-stage {\n  border: 1px solid var(--lp-border);\n  border-radius: 16px;\n  background: var(--lp-surface);\n  padding: var(--lp-space-16);\n}\n\n@media (min-width: 1024px) {\n  .lp-stage { padding: var(--lp-space-24); }\n}\n\n.lp-stage__number {\n  display: block;\n  font-family: var(--lp-font-mono);\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--lp-terracotta);\n  margin-bottom: var(--lp-space-16);\n}\n\n.lp-stage__title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  color: var(--lp-text);\n}\n\n@media (min-width: 640px) {\n  .lp-stage__title { font-size: 24px; }\n}\n\n.lp-stage__outcome {\n  margin: var(--lp-space-12) 0 0;\n  font-size: 16px;\n  line-height: 1.55;\n  font-weight: 500;\n  color: var(--lp-text);\n  text-wrap: pretty;\n}\n\n.lp-stage__detail {\n  margin: var(--lp-space-8) 0 0;\n  font-size: 14px;\n  line-height: 1.65;\n  color: var(--lp-text-muted);\n  text-wrap: pretty;\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Force multiplier\n   ═══════════════════════════════════════════════════════════════ */\n\n.lp-force__grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: var(--lp-space-48);\n  align-items: center;\n}\n\n@media (min-width: 1024px) {\n  .lp-force__grid {\n    grid-template-columns: repeat(12, 1fr);\n    gap: var(--lp-space-24);\n  }\n  .lp-force__copy { grid-column: span 5; }\n  .lp-force__visual { grid-column: span 7; }\n}\n\n.lp-force__scale {\n  margin: var(--lp-space-24) 0 0;\n  font-size: 18px;\n  line-height: 1.5;\n  font-weight: 500;\n  color: var(--lp-text);\n  text-wrap: pretty;\n}\n\n.lp-force__control {\n  margin: var(--lp-space-16) 0 0;\n  font-size: 16px;\n  line-height: 1.6;\n  color: var(--lp-text-muted);\n  text-wrap: pretty;\n}\n\n.lp-force__canvas {\n  position: relative;\n}\n\n.lp-force__source {\n  position: relative;\n  z-index: 2;\n  width: min(220px, 52%);\n  aspect-ratio: 9 / 16;\n  border: 1px solid var(--lp-border);\n  border-radius: 16px;\n  background: var(--lp-surface);\n  padding: var(--lp-space-8);\n}\n\n.lp-force__source-screen {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  border-radius: 8px;\n  background: var(--lp-surface-subdued);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--lp-sepia);\n}\n\n/* A still frame, never played: no controls, no pointer target. */\n.lp-force__source-video {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  pointer-events: none;\n}\n\n.lp-force__source-play {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 46px;\n  height: 46px;\n  border-radius: 50%;\n  background: rgba(255, 253, 248, 0.92);\n  color: var(--lp-sepia);\n  padding-left: 3px;\n  box-shadow: 0 6px 18px -8px rgba(23, 18, 14, 0.65);\n}\n\n.lp-force__connectors {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  color: var(--lp-sepia);\n  z-index: 1;\n}\n\n.lp-force__branch-path {\n  stroke-dasharray: 1;\n  stroke-dashoffset: 1;\n  transition: stroke-dashoffset 1200ms var(--lp-ease);\n}\n\n.lp-force__visual--visible .lp-force__branch-path {\n  stroke-dashoffset: 0;\n}\n\n.lp-force__visual--visible .lp-force__branch-path--2 {\n  transition-delay: 150ms;\n}\n\n.lp-force__visual--visible .lp-force__branch-path--3 {\n  transition-delay: 300ms;\n}\n\n.lp-force__groups {\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 2;\n  width: 58%;\n  height: 100%;\n  display: grid;\n  grid-template-rows: repeat(3, 1fr);\n  align-items: center;\n  gap: var(--lp-space-24);\n}\n\n.lp-force__group {\n  border: 1px solid var(--lp-border);\n  border-radius: 16px;\n  background: var(--lp-surface);\n  padding: var(--lp-space-16);\n  opacity: 0;\n  transform: translateY(24px);\n  transition: opacity 700ms var(--lp-ease), transform 700ms var(--lp-ease);\n}\n\n.lp-force__visual--visible .lp-force__group {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.lp-force__visual--visible .lp-force__group--2 { transition-delay: 150ms; }\n.lp-force__visual--visible .lp-force__group--3 { transition-delay: 300ms; }\n\n.lp-force__group-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: var(--lp-space-12);\n}\n\n.lp-force__group-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--lp-text);\n}\n\n.lp-force__group-count {\n  font-family: var(--lp-font-mono);\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--lp-terracotta);\n}\n\n.lp-force__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--lp-space-8);\n  margin-top: var(--lp-space-12);\n}\n\n.lp-force__chip {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--lp-space-4);\n  padding: var(--lp-space-4) var(--lp-space-8);\n  border: 1px solid var(--lp-border);\n  border-radius: 999px;\n  background: var(--lp-page-bg);\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.5;\n  color: var(--lp-text);\n  white-space: nowrap;\n}\n\n.lp-force__chip-flag {\n  font-size: 13px;\n  line-height: 1;\n}\n\n.lp-force__chip--more {\n  font-family: var(--lp-font-mono);\n  color: var(--lp-terracotta);\n  border-color: var(--lp-terracotta);\n  background: transparent;\n}\n\n@media (min-width: 1024px) {\n  .lp-force__canvas {\n    min-height: 520px;\n  }\n}\n\n/* Mobile: source frame above branch groups (absolute overlay is too cramped\n   at small widths, so the visual becomes a static vertical stack). */\n@media (max-width: 639px) {\n  .lp-force__source {\n    width: min(200px, 64%);\n    margin: 0 auto;\n  }\n\n  .lp-force__connectors {\n    display: none;\n  }\n\n  .lp-force__groups {\n    position: static;\n    width: 100%;\n    height: auto;\n    grid-template-rows: none;\n    margin-top: var(--lp-space-24);\n    gap: var(--lp-space-16);\n  }\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Brand control\n   ═══════════════════════════════════════════════════════════════ */\n\n.lp-brand__grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: var(--lp-space-48);\n  align-items: start;\n}\n\n@media (min-width: 1024px) {\n  .lp-brand__grid {\n    grid-template-columns: repeat(12, 1fr);\n    gap: var(--lp-space-24);\n  }\n  .lp-brand__inputs-col { grid-column: span 5; }\n  .lp-brand__review-col { grid-column: span 7; }\n}\n\n.lp-brand__inputs {\n  list-style: none;\n  margin: var(--lp-space-32) 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: var(--lp-space-12);\n}\n\n.lp-brand__input {\n  display: flex;\n  align-items: center;\n  gap: var(--lp-space-12);\n  padding: var(--lp-space-12) var(--lp-space-16);\n  border: 1px solid var(--lp-border);\n  border-radius: 12px;\n  background: var(--lp-surface);\n  font-size: 16px;\n  font-weight: 500;\n  color: var(--lp-text);\n}\n\n.lp-brand__input-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  background: var(--lp-surface-subdued);\n  color: var(--lp-sepia);\n  flex-shrink: 0;\n}\n\n.lp-brand__sequence {\n  list-style: none;\n  padding: 0;\n  margin-top: 0;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--lp-space-8);\n  margin-bottom: var(--lp-space-24);\n}\n\n.lp-brand__sequence-step {\n  display: inline-flex;\n  align-items: center;\n  min-height: 32px;\n  padding: var(--lp-space-8) var(--lp-space-12);\n  border: 1px solid var(--lp-border);\n  border-radius: 999px;\n  background: var(--lp-surface);\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--lp-text-muted);\n  white-space: nowrap;\n}\n\n.lp-brand__sequence-arrow {\n  color: var(--lp-sepia);\n  flex-shrink: 0;\n}\n\n.lp-slack-mock {\n  border: 1px solid var(--lp-border);\n  border-radius: 16px;\n  background: var(--lp-surface);\n  padding: var(--lp-space-16);\n  max-width: 420px;\n}\n\n@media (min-width: 1024px) {\n  .lp-slack-mock { padding: var(--lp-space-24); }\n}\n\n.lp-slack-mock__row {\n  display: flex;\n  gap: var(--lp-space-12);\n}\n\n.lp-slack-mock__avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  background: var(--lp-terracotta);\n  color: var(--lp-surface);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.lp-slack-mock__body {\n  min-width: 0;\n}\n\n.lp-slack-mock__name {\n  display: flex;\n  align-items: center;\n  gap: var(--lp-space-8);\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--lp-text);\n}\n\n.lp-slack-mock__badge {\n  padding: 0 var(--lp-space-4);\n  border-radius: 4px;\n  background: var(--lp-surface-subdued);\n  color: var(--lp-text-muted);\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.lp-slack-mock__message {\n  margin: var(--lp-space-4) 0 0;\n  font-size: 14px;\n  line-height: 1.5;\n  color: var(--lp-text);\n}\n\n.lp-slack-mock__actions {\n  display: flex;\n  gap: var(--lp-space-8);\n  margin-top: var(--lp-space-12);\n}\n\n.lp-slack-mock__action {\n  display: inline-flex;\n  align-items: center;\n  min-height: 32px;\n  padding: var(--lp-space-8) var(--lp-space-12);\n  border: 1px solid var(--lp-border);\n  border-radius: 8px;\n  background: var(--lp-surface);\n  color: var(--lp-text);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: default;\n  user-select: none;\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Platform coverage\n   ═══════════════════════════════════════════════════════════════ */\n\n.lp-platforms__groups {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: var(--lp-space-24);\n  margin-top: var(--lp-space-48);\n}\n\n@media (min-width: 640px) {\n  .lp-platforms__groups {\n    grid-template-columns: repeat(2, 1fr);\n    gap: var(--lp-space-32);\n  }\n}\n\n.lp-platforms__group {\n  border: 1px solid var(--lp-border);\n  border-radius: 16px;\n  background: var(--lp-surface);\n  padding: var(--lp-space-24);\n}\n\n.lp-platforms__group-label {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--lp-terracotta);\n  margin-bottom: var(--lp-space-16);\n}\n\n.lp-platforms__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--lp-space-8);\n}\n\n.lp-platforms__item {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--lp-space-8);\n  min-height: 40px;\n  padding: var(--lp-space-8) var(--lp-space-12);\n  border: 1px solid var(--lp-border);\n  border-radius: 999px;\n  background: var(--lp-page-bg);\n  font-size: 16px;\n  font-weight: 500;\n  color: var(--lp-text);\n}\n\n.lp-platforms__planned {\n  padding: var(--lp-space-2) var(--lp-space-8);\n  border-radius: 999px;\n  background: var(--lp-surface-subdued);\n  color: var(--lp-text-muted);\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Results\n   ═══════════════════════════════════════════════════════════════ */\n\n.lp-results__grid {\n  list-style: none;\n  padding: 0;\n  margin-bottom: 0;\n  margin-top: var(--lp-space-48);\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: var(--lp-space-48);\n}\n\n@media (min-width: 640px) {\n  .lp-results__grid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: var(--lp-space-32);\n  }\n}\n\n.lp-result__value {\n  display: block;\n  font-size: 48px;\n  font-weight: 500;\n  line-height: 1.05;\n  letter-spacing: -0.02em;\n  color: var(--lp-text);\n}\n\n@media (min-width: 1024px) {\n  .lp-result__value { font-size: 60px; }\n}\n\n.lp-result__value--mono {\n  font-family: var(--lp-font-mono);\n  letter-spacing: -0.04em;\n}\n\n.lp-result__label {\n  display: block;\n  margin-top: var(--lp-space-12);\n  font-size: 16px;\n  line-height: 1.55;\n  color: var(--lp-text-muted);\n  max-width: 32ch;\n}\n\n@media (min-width: 1024px) {\n  .lp-result__label { font-size: 18px; }\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   FAQ\n   ═══════════════════════════════════════════════════════════════ */\n\n.lp-faq__heading {\n  text-align: center;\n}\n\n.lp-faq__list {\n  margin: var(--lp-space-48) auto 0;\n  max-width: var(--lp-composer-max);\n  display: flex;\n  flex-direction: column;\n  gap: var(--lp-space-12);\n}\n\n.lp-faq__item {\n  border: 1px solid var(--lp-border);\n  border-radius: 16px;\n  background: var(--lp-surface);\n  overflow: hidden;\n}\n\n.lp-faq__summary {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--lp-space-16);\n  width: 100%;\n  padding: var(--lp-space-16);\n  border: none;\n  background: none;\n  font-family: inherit;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.4;\n  color: var(--lp-text);\n  text-align: left;\n  cursor: pointer;\n  list-style: none;\n  transition: background-color var(--lp-dur-press) var(--lp-ease);\n}\n\n@media (min-width: 1024px) {\n  .lp-faq__summary { padding: var(--lp-space-24); }\n}\n\n.lp-faq__summary::-webkit-details-marker {\n  display: none;\n}\n\n.lp-faq__summary:hover {\n  background: var(--lp-surface-active);\n}\n\n.lp-faq__summary:focus-visible {\n  outline: 2px solid var(--lp-terracotta);\n  outline-offset: -2px;\n}\n\n.lp-faq__icon {\n  flex-shrink: 0;\n  color: var(--lp-text-muted);\n  transition: transform var(--lp-dur-press) var(--lp-ease);\n}\n\n.lp-faq__item[open] .lp-faq__icon {\n  transform: rotate(180deg);\n}\n\n.lp-faq__answer {\n  padding: 0 var(--lp-space-16) var(--lp-space-16);\n  font-size: 16px;\n  line-height: 1.65;\n  color: var(--lp-text-muted);\n  text-wrap: pretty;\n}\n\n@media (min-width: 1024px) {\n  .lp-faq__answer { padding: 0 var(--lp-space-24) var(--lp-space-24); }\n}\n\n.lp-faq__answer p {\n  margin: 0;\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Final CTA\n   ═══════════════════════════════════════════════════════════════ */\n\n.lp-final-cta {\n  text-align: center;\n}\n\n.lp-final-cta__composer {\n  margin: var(--lp-space-48) auto 0;\n  max-width: var(--lp-composer-max);\n  text-align: left;\n}\n\n.lp-final-cta .lp-body {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Authenticated home (inside UniversalLayout)\n   ═══════════════════════════════════════════════════════════════ */\n\n:root .lp-page.lp-page--app {\n  --lp-page-bg: var(--color-bg-root);\n  --lp-surface: var(--color-bg-canvas-surface);\n  --lp-surface-subdued: var(--color-bg-user-bubble);\n  --lp-surface-elevated: var(--color-bg-sidebar);\n  --lp-surface-active: var(--color-bg-user-bubble);\n  --lp-text: var(--color-text-primary);\n  --lp-text-muted: var(--color-text-secondary);\n  --lp-border: var(--color-border-input);\n  --lp-terracotta: var(--color-accent-base);\n  --lp-rust: var(--color-accent-strong);\n  --lp-olive: var(--color-accent-base);\n  --lp-sepia: var(--color-text-secondary);\n  --lp-error: var(--color-status-error-text);\n  --lp-hero-heading-from: var(--color-text-primary);\n  --lp-hero-heading-to: var(--color-text-secondary);\n  --lp-focus-ring: var(--color-focus-ring);\n  --lp-grain-opacity: 0;\n  --lp-glass: var(--color-bg-sidebar);\n  display: flex;\n  width: 100%;\n  height: 100%;\n  min-height: 100%;\n}\n\n.lp-app-home {\n  display: flex;\n  flex: 1;\n  width: 100%;\n  align-items: flex-start;\n  justify-content: center;\n  padding: max(\n    var(--lp-space-96),\n    calc(50vh - var(--lp-space-96) - var(--lp-space-48))\n  ) 0 var(--lp-space-64);\n  overflow-y: auto;\n}\n\n.lp-app-home__inner {\n  max-width: var(--lp-composer-max);\n  text-align: center;\n}\n\n.lp-app-home__title {\n  margin: 0 0 var(--lp-space-40);\n}\n\n.lp-app-home form {\n  text-align: left;\n}\n\n/* ─── Authenticated project activity ─── */\n\n.lp-project-runs {\n  margin-top: var(--lp-space-24);\n  text-align: left;\n}\n\n.lp-project-runs__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--lp-space-16);\n  margin-bottom: var(--lp-space-8);\n  padding: 0 var(--lp-space-4);\n}\n\n.lp-project-runs__header h2 {\n  margin: 0;\n  color: var(--lp-text);\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n}\n\n.lp-project-runs__header button {\n  min-height: 24px;\n  border: none;\n  border-radius: 8px;\n  padding: var(--lp-space-4) var(--lp-space-8);\n  background: transparent;\n  color: var(--lp-text-muted);\n  font: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: color var(--lp-dur-press) var(--lp-ease),\n    background-color var(--lp-dur-press) var(--lp-ease),\n    transform var(--lp-dur-press) var(--lp-ease);\n}\n\n.lp-project-runs__header button:hover {\n  background: var(--lp-surface-active);\n  color: var(--lp-text);\n}\n\n.lp-project-runs__header button:active {\n  transform: scale(0.98);\n}\n\n.lp-project-runs__header button:focus-visible,\n.lp-project-run:focus-visible {\n  outline: 2px solid var(--lp-terracotta);\n  outline-offset: 2px;\n}\n\n.lp-project-runs__list {\n  display: flex;\n  flex-direction: column;\n  gap: var(--lp-space-4);\n}\n\n.lp-project-run {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr) auto auto;\n  align-items: center;\n  gap: var(--lp-space-8);\n  width: 100%;\n  min-height: 40px;\n  overflow: hidden;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  padding: var(--lp-space-4) var(--lp-space-8);\n  background: transparent;\n  color: var(--lp-text);\n  font-family: inherit;\n  text-align: left;\n  cursor: pointer;\n  animation: lpProjectRunEnter 240ms var(--lp-ease) both;\n  transition: border-color var(--lp-dur-press) var(--lp-ease),\n    background-color var(--lp-dur-press) var(--lp-ease);\n}\n\n.lp-project-run:hover:not(:disabled) {\n  border-color: var(--lp-border);\n  background: var(--lp-surface-active);\n}\n\n.lp-project-run:active:not(:disabled) {\n  background: var(--lp-surface-subdued);\n}\n\n.lp-project-run:disabled {\n  cursor: wait;\n  opacity: 1;\n}\n\n.lp-project-run__status {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  color: var(--lp-text-muted);\n}\n\n.lp-project-run--active .lp-project-run__status {\n  color: var(--lp-terracotta);\n}\n\n.lp-project-run--ready .lp-project-run__status {\n  color: var(--lp-success);\n}\n\n.lp-project-run--failed .lp-project-run__status {\n  color: var(--lp-error);\n}\n\n.lp-project-run__spinner {\n  animation: lpProjectRunSpin 1.4s linear infinite;\n}\n\n.lp-project-run__copy {\n  min-width: 0;\n}\n\n.lp-project-run__eyebrow {\n  color: var(--lp-text-muted);\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n  white-space: nowrap;\n}\n\n.lp-project-run__title {\n  display: block;\n  overflow: hidden;\n  color: var(--lp-text);\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  animation: lpProjectTitleReveal var(--lp-dur-press) var(--lp-ease) both;\n}\n\n.lp-project-run__open {\n  color: var(--lp-text-muted);\n  transition: color var(--lp-dur-press) var(--lp-ease);\n}\n\n.lp-project-run:hover .lp-project-run__open {\n  color: var(--lp-text);\n}\n\n.lp-project-run--skeleton {\n  cursor: default;\n  animation: none;\n}\n\n.lp-project-run__skeleton-icon,\n.lp-project-run__skeleton-copy span,\n.lp-project-run__skeleton-status {\n  display: block;\n  border-radius: 8px;\n  background: var(--lp-surface-subdued);\n  animation: lpProjectRunSkeleton 1.6s var(--lp-ease) infinite alternate;\n}\n\n.lp-project-run__skeleton-icon {\n  width: 16px;\n  height: 16px;\n  border-radius: 999px;\n}\n\n.lp-project-run__skeleton-copy {\n  min-width: 0;\n}\n\n.lp-project-run__skeleton-copy span:first-child {\n  width: min(240px, 62%);\n  height: 12px;\n}\n\n.lp-project-run__skeleton-status {\n  width: 48px;\n  height: 8px;\n}\n\n@keyframes lpProjectRunEnter {\n  from { opacity: 0; transform: translateY(-8px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes lpProjectTitleReveal {\n  from { opacity: 0; transform: translateY(2px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes lpProjectRunSpin {\n  to { transform: rotate(360deg); }\n}\n\n@keyframes lpProjectRunSkeleton {\n  from { opacity: 0.45; }\n  to { opacity: 0.9; }\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Footer\n   ═══════════════════════════════════════════════════════════════ */\n\n.lp-footer {\n  border-top: 1px solid var(--lp-border);\n  padding: var(--lp-space-64) 0 var(--lp-space-32);\n}\n\n.lp-footer__top {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: var(--lp-space-32);\n}\n\n@media (min-width: 640px) {\n  .lp-footer__top {\n    grid-template-columns: 1.4fr repeat(3, 1fr);\n    gap: var(--lp-space-24);\n  }\n}\n\n.lp-footer__brand img {\n  height: 28px;\n  width: auto;\n  display: block;\n}\n\n.lp-footer__tagline {\n  margin: var(--lp-space-16) 0 0;\n  font-size: 14px;\n  line-height: 1.6;\n  color: var(--lp-text-muted);\n  max-width: 32ch;\n}\n\n.lp-footer__group-title {\n  margin: 0 0 var(--lp-space-16);\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--lp-text);\n}\n\n.lp-footer__links {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: var(--lp-space-12);\n}\n\n.lp-footer__link {\n  display: inline-flex;\n  align-items: center;\n  min-height: 24px;\n  border: none;\n  background: none;\n  padding: 0;\n  font-family: inherit;\n  font-size: 14px;\n  color: var(--lp-text-muted);\n  text-decoration: none;\n  cursor: pointer;\n  transition: color var(--lp-dur-press) var(--lp-ease);\n}\n\n.lp-footer__link:hover {\n  color: var(--lp-text);\n}\n\n.lp-footer__bottom {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--lp-space-16);\n  margin-top: var(--lp-space-48);\n  padding-top: var(--lp-space-24);\n  border-top: 1px solid var(--lp-border);\n}\n\n.lp-footer__copyright {\n  margin: 0;\n  font-size: 13px;\n  color: var(--lp-text-muted);\n}\n\n.lp-footer__theme {\n  display: flex;\n  align-items: center;\n  gap: var(--lp-space-8);\n  font-size: 13px;\n  color: var(--lp-text-muted);\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Reduced motion\n   ═══════════════════════════════════════════════════════════════ */\n\n@media (prefers-reduced-motion: reduce) {\n  .lp-reveal {\n    opacity: 1;\n    transform: none;\n    filter: none;\n    transition: none;\n  }\n\n  .lp-tagline__word {\n    opacity: 1;\n    transition: none;\n  }\n\n  .lp-force__branch-path {\n    stroke-dashoffset: 0;\n    transition: none;\n  }\n\n  .lp-force__group {\n    opacity: 1;\n    transform: none;\n    transition: none;\n  }\n\n  .lp-menu-overlay,\n  .lp-menu-overlay__link {\n    transition: none;\n  }\n\n  .lp-page *,\n  .lp-page *::before,\n  .lp-page *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n\n  .lp-page {\n    scroll-behavior: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
